
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/**
 * @callback renderCallback
 * @param {*} value - The new value
 * @param {HTMLElement?} node - Previous node for re-use
 * @return {HTMLElement}
 */ /**
 * @param {Object} context - Store holding data
 * @param {string} target - Field to observe
 * @param {renderCallback} render - Render callback called on change
 * @return {HTMLElement}
 */ function $17a0552230a278a9$var$reactiveNode(context, target, render) {
    let value = context[target];
    const node = render(value);
    Object.defineProperty(context, target, {
        get: ()=>value,
        set: (newValue)=>{
            value = newValue;
            render(value, node);
        }
    });
    return node;
}
/**
 * @callback ChangeCallback
 * @param {string} name - Name of the Array method called
 * @param {*[]} args - All the following arguments
 */ /**
 * Copy of Array class to preserve its prototype
 * @class
 * @extends Array
 */ class $17a0552230a278a9$var$EmitterArray extends Array {
    #onChange;
    /**
     * @param {ChangeCallback} callback - Define what callback to call on change
     */ setOnChange(callback) {
        this.#onChange = callback;
    }
    /**
     * @inheritDoc
     */ push(...args) {
        super.push(...args);
        this.#onChange?.("push", args);
    }
    /**
     * @inheritDoc
     */ pop() {
        super.pop();
        this.#onChange?.("pop");
    }
    /**
     * @inheritDoc
     */ shift() {
        super.shift();
        this.#onChange("shift");
    }
    /**
     * @inheritDoc
     */ unshift(...args) {
        super.unshift(...args);
        this.#onChange?.("unshift", args);
    }
    /**
     * @inheritDoc
     */ splice(...args) {
        super.splice(...args);
        this.#onChange?.("splice", args);
    }
    /**
     * @inheritDoc
     */ sort(...args) {
        super.sort(...args);
        this.#onChange?.("sort", args);
    }
    /**
     * @inheritDoc
     */ reverse() {
        super.reverse();
        this.#onChange?.("reverse");
    }
}
/**
 * @param {Object} context - Store holding data
 * @param {string} target - Field to observe
 * @param {renderCallback} render - Render callback called on change
 * @param {renderCallback} childrenRender - Render callback for each child
 * @return {*}
 */ function $17a0552230a278a9$var$reactiveArray(context, target, render, childrenRender) {
    let values = new $17a0552230a278a9$var$EmitterArray(...context[target]);
    const wrapper = render(values.map((value)=>childrenRender(value)));
    /**
     * @param {string} [func] -
     * @param {...*} [args] -
     */ function reflow(func, args) {
        switch(func){
            case "push":
                args.forEach((value)=>wrapper.appendChild(childrenRender(value)));
                break;
            case "pop":
                if (wrapper.lastChild) wrapper.removeChild(wrapper.lastChild);
                break;
            case "shift":
                if (wrapper.firstChild) wrapper.removeChild(wrapper.firstChild);
                break;
            case "splice":
                // eslint-disable-next-line no-case-declarations
                const [index, removed, ...added] = args;
                for(let i = 0; i < removed; ++i)wrapper.removeChild(wrapper.children[index]);
                if (added.length) {
                    const pivot = wrapper.children[index] ?? null;
                    added.forEach((node)=>wrapper.insertBefore(childrenRender(node), pivot));
                }
                break;
            case "unshift":
                args.forEach((value)=>{
                    if (wrapper.children.length) wrapper.insertBefore(childrenRender(value), wrapper.firstChild);
                    else wrapper.appendChild(childrenRender(value));
                });
                break;
            default:
                wrapper.innerHTML = "";
                values.forEach((node)=>wrapper.appendChild(childrenRender(node)));
        }
    }
    values.setOnChange(reflow);
    Object.defineProperty(context, target, {
        get: ()=>values,
        set: (newValue)=>{
            if (!Array.isArray(newValue)) throw new window.TypeError(`Value of ${target} should be an array.`);
            values = new $17a0552230a278a9$var$EmitterArray(...newValue);
            values.setOnChange(reflow);
            reflow();
        }
    });
    return wrapper;
}
function $17a0552230a278a9$export$2e2bcd8739ae039(context, target, render, childrenRender) {
    if (context[target] === undefined) {
        const { name: name } = context.constructor;
        const message = `The prop [${target}] doesn't exists on [${name}]. Couldn't make it reactive.`;
        throw new window.ReferenceError(message, {
            cause: context
        });
    }
    return (Array.isArray(context[target]) ? $17a0552230a278a9$var$reactiveArray : $17a0552230a278a9$var$reactiveNode)(context, target, render, childrenRender);
}


/**
 * Get the value of an input element
 * @param {HTMLInputElement} input - Any type of input element to read the value from
 * @return {*}
 */ function $1bf5d568346a5aa2$var$getNodeValue(input) {
    switch(input.getAttribute("type")){
        case "checkbox":
            return input.checked;
        default:
            return input.value;
    }
}
const $1bf5d568346a5aa2$var$listeners = new WeakMap();
/**
 * Build an HTML element
 * @param {string|HTMLElement} [element = "div"] - Element to create or reuse
 * @param {Object} [props] - Set of attributes, prefix with "@" for event listeners, "--" for CSS variables and "." for properties
 * @param {(string|HTMLElement)[]|(string|HTMLElement)} [children] - List of children to append
 * @returns {HTMLElement}
 * @example
 * render("main", {
 *   class: "app"
 * }, [
 *   render("h1", "Whiskers.js"),
 *   render("p", "Minimalist HTML-in-JS reactive framework"),
 * ]);
 */ function $1bf5d568346a5aa2$export$b3890eb0ae9dca99(element, props, children) {
    const { Node: Node, document: document, Text: Text, HTMLInputElement: HTMLInputElement } = window;
    const node = element instanceof Node ? element : document.createElement(element || "div");
    $1bf5d568346a5aa2$var$listeners.get(node)?.forEach((params)=>node.removeEventListener(...params));
    $1bf5d568346a5aa2$var$listeners.delete(node);
    let nested = children;
    if (children === undefined && props?.constructor !== Object) nested = props;
    else Object.keys(props || {}).forEach((key)=>{
        switch(true){
            case key.startsWith("."):
                node[key.slice(1)] = props[key];
                break;
            case key.startsWith("@"):
                // eslint-disable-next-line no-case-declarations
                const params = [
                    key.slice(1),
                    (event)=>{
                        const isInput = key === "@input" && node instanceof HTMLInputElement;
                        props[key](isInput ? $1bf5d568346a5aa2$var$getNodeValue(node) : event);
                    }
                ];
                node.addEventListener(...params);
                if ($1bf5d568346a5aa2$var$listeners.has(node)) $1bf5d568346a5aa2$var$listeners.get(node).push(params);
                else $1bf5d568346a5aa2$var$listeners.set(node, [
                    params
                ]);
                break;
            case key.startsWith("--"):
                node.style.setProperty(key, props[key]);
                break;
            default:
                if (props[key] || props[key] === "") node.setAttribute(key, props[key] === true ? "" : props[key]);
                else node.removeAttribute(key);
                break;
        }
    });
    node.innerHTML = "";
    if (Array.isArray(nested)) nested.filter((child)=>child !== undefined).forEach((child)=>node.appendChild(child instanceof Node ? child : new Text(child.toString())));
    else if (nested) node.appendChild(nested instanceof Node ? nested : new Text(nested.toString()));
    return node;
}
/**
 * Turn a nested object into a CSS string
 * @param {CSSDefinition} styles - CSS style definition
 * @param {number} [depth = 0] - Current nesting depth
 * @return {string}
 */ function $1bf5d568346a5aa2$export$e6c4a7b90ce6ccb8(styles, depth = 0) {
    const indent = " ".repeat(depth * 4);
    return Object.keys(styles).reduce((style, key)=>{
        if (typeof styles[key] === "object") return `${style}${style ? "\n\n" : ""}${indent}${key} {${$1bf5d568346a5aa2$export$e6c4a7b90ce6ccb8(styles[key], depth + 1)}
${indent}}`;
        return `${style}
${indent}${key}: ${styles[key].toString()};`;
    }, "").trimEnd();
}
/**
 * @typedef {Object<string, (string|number|CSSDefinition)>} CSSDefinition
 */ /**
 * Build a style element
 * @param {CSSDefinition|string} styles - CSS style definition
 * @returns {HTMLStyleElement}
 * @example
 * renderStyle({
 *   ".app": {
 *     padding: "10px",
 *   }
 * });
 */ function $1bf5d568346a5aa2$export$2ac1b4e32926b135(styles) {
    const style = window.document.createElement("style");
    style.textContent = typeof styles === "string" ? styles : $1bf5d568346a5aa2$export$e6c4a7b90ce6ccb8(styles);
    return style;
}


const $a18ed44ada1e4192$export$44c6a27b41bcee9f = {
    black: "#1c2127",
    primary: "#1a9a7b",
    grey: "#86898a"
};
const $a18ed44ada1e4192$export$7f9953c70dacfd7f = {
    "@keyframes loading": {
        "0%": {
            "box-shadow": "0 0 0 1lh inset var(--loading-color)"
        },
        "100%": {
            "box-shadow": "0 0 0 inset var(--loading-color)"
        }
    }
};
const $a18ed44ada1e4192$export$ccc7b0636abaffc3 = {
    flex: (gap = "1em")=>({
            display: "flex",
            gap: gap
        }),
    flexCol: (gap)=>({
            ...$a18ed44ada1e4192$export$ccc7b0636abaffc3.flex(gap),
            "flex-direction": "column"
        })
};
const $a18ed44ada1e4192$export$60d5655c6babb2a0 = {
    border: `1px solid ${$a18ed44ada1e4192$export$44c6a27b41bcee9f.primary}`,
    padding: ".5em 1em",
    background: "none",
    cursor: "pointer",
    "&:hover": {
        background: $a18ed44ada1e4192$export$44c6a27b41bcee9f.primary,
        color: $a18ed44ada1e4192$export$44c6a27b41bcee9f.black
    }
};
const $a18ed44ada1e4192$export$46c1c92549715335 = {
    "&.loading": {
        "--loading-color": $a18ed44ada1e4192$export$44c6a27b41bcee9f.primary,
        animation: "loading linear",
        "animation-duration": "var(--time)"
    }
};




const $41f6e0b01b0859bd$export$4bf9923669ad6c63 = {
    earn: "earn-resource",
    consume: "consume-resource"
};
var $41f6e0b01b0859bd$export$2e2bcd8739ae039 = {
    render ([amount, resource], node) {
        const data = {
            amount: amount,
            resource: resource
        };
        return (0, $1bf5d568346a5aa2$export$b3890eb0ae9dca99)(node ?? "div", {
            class: "resource"
        }, [
            (0, $17a0552230a278a9$export$2e2bcd8739ae039)(data, "amount", (value)=>(0, $1bf5d568346a5aa2$export$b3890eb0ae9dca99)("span", undefined, [
                    value
                ])),
            resource.name
        ]);
    },
    styles: {
        ".resource": {}
    }
};




var $01ccc13c74d3501f$export$2e2bcd8739ae039 = (callback, time)=>{
    let statedAt = null;
    let remaining = time;
    let timer = null;
    const api = {
        stop () {
            clearTimeout(timer);
            timer = null;
            return performance.now() - statedAt;
        },
        pause () {
            remaining = this.stop();
        },
        start () {
            statedAt = performance.now();
            timer = setTimeout(()=>{
                callback();
            }, remaining);
        }
    };
    api.start();
    return api;
};



/**
 * @param {Array} array Array of strings
 * @param {string} separator Separator between items
 * @param {string} final Final separator
 * @return {string}
 */ function $820877bea407f5fe$export$f7e2c8231c57a8bd(array, separator = ", ", final = "and") {
    return array.length ? `${array.slice(0, -1).join(separator)} ${final} ${array[array.length - 1]}` : "";
}
/**
 * @param {number} [min = 1] Maximum value if only one argument is provided, minimum value otherwise
 * @param {number} [max] Maximum value
 * @return {number}
 */ function $820877bea407f5fe$export$4385e60b38654f68(min = 1, max) {
    let from = min;
    let to = max;
    if (max === undefined) {
        from = 0;
        to = min;
    }
    return Math.random() * (to - from) + from;
}
/**
 * @param {string} word Any word
 * @param {number} count Amount of items
 * @return {string}
 */ function $820877bea407f5fe$export$cefb40c9962541b5(word, count) {
    return `${count} ${word}${count > 1 ? "s" : ""}`;
}
/**
 * @param {number} value Any number
 * @param {number} min Minimum value
 * @param {number} max Maximum value
 * @return {number}
 */ function $820877bea407f5fe$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.min(max, Math.max(min, value));
}
/**
 * @param {string} eventName Event's name
 * @param {EventTarget} [target=window] Triggering element
 * @param {Object} [detail] Some details to attach
 */ function $820877bea407f5fe$export$635e15bbd66f01ea(eventName, target = window, detail) {
    target.dispatchEvent(new CustomEvent(eventName, {
        bubbles: true,
        detail: detail
    }));
}


const $a5a8dc8cb9c107ce$export$4bf9923669ad6c63 = {
    start: "action-start",
    end: "action-end"
};
var $a5a8dc8cb9c107ce$export$2e2bcd8739ae039 = {
    render (action) {
        action.doing = false;
        let element;
        /**
         * End action
         */ function done() {
            action.doing = false;
            action.onEnd?.(element);
            (0, $820877bea407f5fe$export$635e15bbd66f01ea)($a5a8dc8cb9c107ce$export$4bf9923669ad6c63.end, element, action);
        }
        /**
         * Start action
         */ function start() {
            if (!action.doing) {
                action.doing = true;
                (0, $820877bea407f5fe$export$635e15bbd66f01ea)($a5a8dc8cb9c107ce$export$4bf9923669ad6c63.start, element, action);
                if (action.time) (0, $01ccc13c74d3501f$export$2e2bcd8739ae039)(done, action.time);
                else done();
            }
        }
        element = (0, $17a0552230a278a9$export$2e2bcd8739ae039)(action, "doing", (value, node)=>(0, $1bf5d568346a5aa2$export$b3890eb0ae9dca99)(node ?? "button", {
                class: `action ${action.doing ? "loading" : ""}`,
                ".disabled": action.doing ? "disabled" : false,
                "--time": `${action.time ?? 0}ms`,
                "@click": start
            }, [
                action.name
            ]));
        return element;
    },
    styles: {
        ".action": {
            ...(0, $a18ed44ada1e4192$export$60d5655c6babb2a0),
            ...(0, $a18ed44ada1e4192$export$46c1c92549715335)
        }
    }
};





const $d558274f28a688d2$export$4bf9923669ad6c63 = {
    addLog: "add-log"
};
const $d558274f28a688d2$export$b14ad400b1d09e0f = {
    quote: "quote"
};
/**
 * @param {string} string Any string
 * @param {Object} data Additional data
 * @return {string}
 */ function $d558274f28a688d2$var$format(string, data) {
    const regexp = /@(\w+(\.\w+)*)/g;
    const replacer = (_, group)=>group.split(".").reduce((acc, value)=>acc[value], data);
    return string.replace(regexp, replacer);
}
var $d558274f28a688d2$export$2e2bcd8739ae039 = {
    render: (value, node)=>(0, $1bf5d568346a5aa2$export$b3890eb0ae9dca99)(node, {
            class: `log ${value.type ?? ""}`
        }, [
            $d558274f28a688d2$var$format(value.message, value.data)
        ]),
    styles: {
        ".log": {
            "&.quote": {
                "font-style": "italic",
                "font-size": "1.5em",
                color: (0, $a18ed44ada1e4192$export$44c6a27b41bcee9f).grey,
                "&:before": {
                    content: "'\xab'"
                },
                "&:after": {
                    content: "'\xbb'"
                }
            }
        }
    }
};




const $7b17dadf09a1ff76$export$4bf9923669ad6c63 = {
    arrive: "person-arrive",
    die: "person-die"
};
var $7b17dadf09a1ff76$export$2e2bcd8739ae039 = {
    render (value, node) {
        const element = (0, $1bf5d568346a5aa2$export$b3890eb0ae9dca99)(node, {
            class: "person",
            [`@${(0, $a5a8dc8cb9c107ce$export$4bf9923669ad6c63).start}`]: ({ detail: detail })=>{
                if (detail.consume) (0, $820877bea407f5fe$export$635e15bbd66f01ea)((0, $41f6e0b01b0859bd$export$4bf9923669ad6c63).consume, element, detail.consume);
            },
            [`@${(0, $a5a8dc8cb9c107ce$export$4bf9923669ad6c63).end}`]: ({ detail: detail })=>{
                const data = {
                    person: value,
                    action: detail
                };
                if (detail.once) value.actions.splice(value.actions.indexOf(detail), 1);
                if (detail.unlock?.length) {
                    data.unlock = detail.unlock;
                    value.actions.push(...detail.unlock.filter((unlocked)=>!value.actions.includes(unlocked)));
                }
                if (detail.lock?.length) {
                    data.lock = detail.lock;
                    value.actions = value.actions.filter((locked)=>!detail.lock.includes(locked));
                }
                if (detail.earn?.length) {
                    data.earn = (0, $820877bea407f5fe$export$f7e2c8231c57a8bd)(detail.earn.map(([amount, resource])=>(0, $820877bea407f5fe$export$cefb40c9962541b5)(resource.name, amount)));
                    (0, $820877bea407f5fe$export$635e15bbd66f01ea)((0, $41f6e0b01b0859bd$export$4bf9923669ad6c63).earn, element, detail.earn);
                }
                if (detail.log) (0, $820877bea407f5fe$export$635e15bbd66f01ea)((0, $d558274f28a688d2$export$4bf9923669ad6c63).addLog, element, {
                    message: detail.log,
                    data: data
                });
            }
        }, [
            (0, $1bf5d568346a5aa2$export$b3890eb0ae9dca99)("h2", {
                class: "name"
            }, [
                value.name
            ]),
            (0, $17a0552230a278a9$export$2e2bcd8739ae039)(value, "actions", (init, list)=>(0, $1bf5d568346a5aa2$export$b3890eb0ae9dca99)(list, {
                    class: "actions"
                }, init), (0, $a5a8dc8cb9c107ce$export$2e2bcd8739ae039).render)
        ]);
        return element;
    },
    styles: {
        ".person": {
            padding: "1em",
            border: `1px dashed ${(0, $a18ed44ada1e4192$export$44c6a27b41bcee9f).primary}`,
            ".actions": {
                ...(0, $a18ed44ada1e4192$export$ccc7b0636abaffc3).flex(),
                ...(0, $a5a8dc8cb9c107ce$export$2e2bcd8739ae039).styles
            }
        }
    }
};






const $2a9f999bc54a0719$export$bc99aaabaf7b70a7 = {
    // ## GATHERABLES ##
    // COMMON
    water: {
        name: "water",
        description: "Much needed to survive"
    },
    food: {
        name: "food",
        description: "Expiration date says 2 years ago, but it's not a time to be picky."
    },
    rock: {
        name: "rock",
        description: '"There\'s rocks everywhere ! Why would you bring this back ?"'
    },
    scrap: {
        name: "scrap",
        description: "An old and rusty piece of metal."
    },
    // UNCOMMON
    bolt: {
        name: "nuts and bolts",
        description: "Little metal nuts and bolts to fasten anything in place."
    },
    sand: {
        name: "sand",
        description: "Just pure fine sand."
    },
    fuel: {
        name: "fuel",
        description: "About a liter of gas-oil."
    },
    // RARE
    medication: {
        name: "medication",
        description: "An unlabeled medication, hope it's still good."
    },
    electronics: {
        name: "electronics",
        description: "Some basic micro-electronics components."
    },
    // SPECIAL
    ruin: {
        name: "ruin",
        description: "Directions to a point of interest found earlier."
    },
    quartz: {
        name: "quartz",
        description: "A rough uncut gem of quartz. Quite valuable."
    },
    // ## CRAFTABLES ##
    // BASIC
    component: {
        name: "component",
        description: "Some mechanical parts for others craftables."
    },
    stone: {
        name: "stone",
        description: "A round and well polish stone."
    },
    tool: {
        name: "tool",
        description: "A makeshift tool, good for a few uses."
    },
    // COMPLEX
    brick: {
        name: "brick",
        description: "Will give walls for larger constructions."
    },
    circuit: {
        name: "circuit",
        description: "That's a little rough, but it's actually a functioning circuit board."
    },
    pipe: {
        name: "metal pipe",
        description: "Forged from junk metal."
    },
    // ADVANCED
    jewelry: {
        name: "jewelry",
        description: "A really beautiful ornament useful for trading."
    },
    engine: {
        name: "engine",
        description: "Amazing what can be done with all those scraps !"
    },
    computer: {
        name: "computer",
        description: "Well, Internet is down since 2025 but it can still be useful."
    }
};
$2a9f999bc54a0719$export$bc99aaabaf7b70a7.gatherables = {
    common: [
        $2a9f999bc54a0719$export$bc99aaabaf7b70a7.water,
        $2a9f999bc54a0719$export$bc99aaabaf7b70a7.food,
        $2a9f999bc54a0719$export$bc99aaabaf7b70a7.rock,
        $2a9f999bc54a0719$export$bc99aaabaf7b70a7.scrap
    ],
    uncommon: [
        $2a9f999bc54a0719$export$bc99aaabaf7b70a7.bolt,
        $2a9f999bc54a0719$export$bc99aaabaf7b70a7.sand,
        $2a9f999bc54a0719$export$bc99aaabaf7b70a7.fuel
    ],
    rare: [
        $2a9f999bc54a0719$export$bc99aaabaf7b70a7.medication,
        $2a9f999bc54a0719$export$bc99aaabaf7b70a7.electronics
    ]
};
$2a9f999bc54a0719$export$bc99aaabaf7b70a7.craftables = {
    basic: [
        $2a9f999bc54a0719$export$bc99aaabaf7b70a7.component,
        $2a9f999bc54a0719$export$bc99aaabaf7b70a7.stone,
        $2a9f999bc54a0719$export$bc99aaabaf7b70a7.tool
    ],
    complex: [
        $2a9f999bc54a0719$export$bc99aaabaf7b70a7.brick,
        $2a9f999bc54a0719$export$bc99aaabaf7b70a7.circuit,
        $2a9f999bc54a0719$export$bc99aaabaf7b70a7.pipe
    ],
    advanced: [
        $2a9f999bc54a0719$export$bc99aaabaf7b70a7.jewelry,
        $2a9f999bc54a0719$export$bc99aaabaf7b70a7.engine,
        $2a9f999bc54a0719$export$bc99aaabaf7b70a7.computer
    ]
};
const $2a9f999bc54a0719$var$roam = {
    name: "Roam",
    time: 2000,
    energy: 15,
    consume: [
        [
            1,
            $2a9f999bc54a0719$export$bc99aaabaf7b70a7.water
        ]
    ],
    log: "After some roaming around, @person.name found nothing."
};
const $2a9f999bc54a0719$var$gather = {
    name: "Gather",
    time: 1000,
    energy: 10,
    earn: [
        [
            5,
            $2a9f999bc54a0719$export$bc99aaabaf7b70a7.water
        ],
        [
            2,
            $2a9f999bc54a0719$export$bc99aaabaf7b70a7.food
        ]
    ],
    log: "@person.name brings back @earn",
    unlock: [
        $2a9f999bc54a0719$var$roam
    ]
};
const $2a9f999bc54a0719$var$settle = {
    name: "Settle",
    time: 3000,
    energy: 10,
    log: "Regrouping some aluminum panels and torn clothes, @person.name manage to construct a basic shelter.",
    once: true,
    unlock: [
        $2a9f999bc54a0719$var$gather
    ]
};
const $2a9f999bc54a0719$var$lookAround = {
    name: "Look around",
    time: 500,
    log: "@person.name looks around, but find nothing but a burning shipwreck with @earn inside.",
    once: true,
    earn: [
        [
            10,
            $2a9f999bc54a0719$export$bc99aaabaf7b70a7.water
        ],
        [
            5,
            $2a9f999bc54a0719$export$bc99aaabaf7b70a7.food
        ]
    ],
    unlock: [
        $2a9f999bc54a0719$var$settle
    ]
};
const $2a9f999bc54a0719$var$wakeUp = {
    name: "Wake up",
    log: "@person.name wake up with difficulty.",
    once: true,
    unlock: [
        $2a9f999bc54a0719$var$lookAround
    ],
    onEnd ({ parentNode: parentNode }) {
        (0, $01ccc13c74d3501f$export$2e2bcd8739ae039)(()=>{
            (0, $820877bea407f5fe$export$635e15bbd66f01ea)((0, $d558274f28a688d2$export$4bf9923669ad6c63).addLog, parentNode, {
                type: (0, $d558274f28a688d2$export$b14ad400b1d09e0f).quote,
                message: "Where am I ?"
            });
        }, 500);
    }
};
const $2a9f999bc54a0719$export$e324594224ef24da = {
    wakeUp: $2a9f999bc54a0719$var$wakeUp,
    lookAround: $2a9f999bc54a0719$var$lookAround,
    settle: $2a9f999bc54a0719$var$settle,
    gather: $2a9f999bc54a0719$var$gather,
    roam: $2a9f999bc54a0719$var$roam
};




// Basics
var $26d060ef72148247$exports = {};

$parcel$export($26d060ef72148247$exports, "constrain", () => $26d060ef72148247$export$c4e2ecac49351ef2);
$parcel$export($26d060ef72148247$exports, "equals", () => $26d060ef72148247$export$e9bab7fafb253603);
$parcel$export($26d060ef72148247$exports, "random", () => $26d060ef72148247$export$4385e60b38654f68);
$parcel$export($26d060ef72148247$exports, "truncate", () => $26d060ef72148247$export$6a506b36fdea397d);
$parcel$export($26d060ef72148247$exports, "radianCircle", () => $26d060ef72148247$export$10ec9ebfd343bc9a);
$parcel$export($26d060ef72148247$exports, "degreeCircle", () => $26d060ef72148247$export$47d0a01eedb6cd22);
$parcel$export($26d060ef72148247$exports, "phi", () => $26d060ef72148247$export$324943737027944a);
$parcel$export($26d060ef72148247$exports, "modulo", () => $26d060ef72148247$export$ba467bec01d66def);
$parcel$export($26d060ef72148247$exports, "distribute", () => $26d060ef72148247$export$f02a9ddbe4480f19);
$parcel$export($26d060ef72148247$exports, "sum", () => $26d060ef72148247$export$8a63f25cc62965f1);
$parcel$export($26d060ef72148247$exports, "average", () => $26d060ef72148247$export$cc6710ee5f037d57);
$parcel$export($26d060ef72148247$exports, "map", () => $26d060ef72148247$export$871de8747c9eaa88);
$parcel$export($26d060ef72148247$exports, "lerp", () => $26d060ef72148247$export$3a89f8d6f6bf6c9f);
/**
 * @module Math
 */ /**
 * Constrain a number between two limits.
 * @param {Number} value - Any number
 * @param {Number} min - Minimal limit for the value
 * @param {Number} max - Maximal limit for the value
 * @return {Number}
 * @example
 * constrain(999, 0, 50); // => 50
 * constrain(-999, 0, 50); // => 0
 */ const $26d060ef72148247$export$c4e2ecac49351ef2 = (value, min, max)=>Math.min(Math.max(value, min), max);
/**
 * Determine if two number can considered equals accounting for JS precision.
 * @param {Number} number1 - Any number
 * @param {Number} number2 - Any number
 * @param {Number} [epsilon=Number.EPSILON] - Maximum difference to consider two number equal.
 * @return {Boolean}
 * @example
 * equals(0.1 + 0.2, 0.3); // => true
 */ const $26d060ef72148247$export$e9bab7fafb253603 = (number1, number2, epsilon = Number.EPSILON)=>Math.abs(number1 - number2) < epsilon;
/**
 * Return a random number between limits
 * @param {Number} [min=1] - Lower limit, or upper limit if max is omitted
 * @param {Number} [max] - Upper limit, can be omitted
 * @return {Number}
 * @example
 * random(); // => 0.5918807307648482
 * random(10); // => 4.4856764978326735
 * random(100, 200); // => 134.57047268453047
 */ const $26d060ef72148247$export$4385e60b38654f68 = (min = 1, max)=>{
    let from = min;
    let to = max;
    if (max === undefined) {
        from = 0;
        to = min;
    }
    return Math.random() * (to - from) + from;
};
/**
 * Truncate a number to its integer part.
 * @param {Number} value - Any number
 * @return {Number}
 * @example
 * truncate(12.3); // => 12
 * truncate(-4.9); // => -4
 */ // eslint-disable-next-line no-bitwise
const $26d060ef72148247$export$6a506b36fdea397d = (value)=>value << 0;
/**
 * Full rotation on radian circle
 * @type {Number}
 */ const $26d060ef72148247$export$10ec9ebfd343bc9a = Math.PI * 2;
/**
 * Full rotation on degree circle
 * @type {Number}
 */ const $26d060ef72148247$export$47d0a01eedb6cd22 = 360;
/**
 * Golden ratio number
 * @type {Number}
 */ const $26d060ef72148247$export$324943737027944a = (Math.sqrt(5) + 1) / 2;
/**
 * Return modulo with the same sign as the divisor (Floored division)
 * @param {Number} value - Dividend
 * @param {Number} divisor - Divisor
 * @return {Number}
 * @example
 * modulo(10, 3); // => 1
 * modulo(10, -3); // => -2
 */ const $26d060ef72148247$export$ba467bec01d66def = (value, divisor)=>{
    const remainder = value % divisor;
    return !value || Math.sign(value) === Math.sign(divisor) ? remainder : remainder + divisor;
};
/**
 * Returns an array of evenly distributed value across a range
 * @param {Number} nbValue - Number of value to generate
 * @param {Number} [min=0] - Starting value of the range
 * @param {Number} [max=1] - Ending value of the range
 * @return {Array<Number>}
 * @example
 * distribute(10); // => Number[10] evenly distributed across [0, 1]
 * distribute(5, 10, 20); // => Number[5] evenly distributed across [10, 20]
 */ const $26d060ef72148247$export$f02a9ddbe4480f19 = (nbValue, min = 0, max = 1)=>{
    const start = $26d060ef72148247$export$4385e60b38654f68(min, max);
    const diff = max - min;
    return [
        ...new Array(nbValue)
    ].map((_, i)=>min + $26d060ef72148247$export$ba467bec01d66def(start + i * $26d060ef72148247$export$324943737027944a * diff, diff));
};
/**
 * Add up all values passed as argument
 * @param {...Number} values - Any set of number
 * @return {Number}
 * @example
 * sum(1, 2, 3); // => 6
 */ const $26d060ef72148247$export$8a63f25cc62965f1 = (...values)=>values.reduce((acc, value)=>acc + value, 0);
/**
 * Return the average of all values
 * @param {...Number} values - Any set of number
 * @return {Number}
 * @example
 * sum(1, 2, 3); // => 2
 */ const $26d060ef72148247$export$cc6710ee5f037d57 = (...values)=>$26d060ef72148247$export$8a63f25cc62965f1(...values) / values.length;
/**
 * Return the equivalent of a value from a scale to another
 * @param {Number} value - Value to use
 * @param {Number} fromMin - Start of the origin scale
 * @param {Number} fromMax - End of the origin scale
 * @param {Number} [toMin=0] - Start of the target scale
 * @param {Number} [toMax=1] - End of the target scale
 * @return {Number}
 * @example
 * map(5, 0, 10, 100, 200); // => 150
 */ const $26d060ef72148247$export$871de8747c9eaa88 = (value, fromMin, fromMax, toMin = 0, toMax = 1)=>(value - fromMin) / (fromMax - fromMin) * (toMax - toMin) + toMin;
/**
 * Linear extrapolation computation, useful when doing animation
 * @param {Number} from - Starting value
 * @param {Number} to - Ending value
 * @param {Number} ratio - Extrapolation ratio, 0 is the starting value and 1 the ending value
 * @return {Number}
 */ const $26d060ef72148247$export$3a89f8d6f6bf6c9f = (from, to, ratio)=>from + (to - from) * ratio;


class $ce200116bfeffd8f$export$2e2bcd8739ae039 {
    /**
     * Position constructor
     * @param {Number} x - Vertical component
     * @param {Number} y - Horizontal component
     */ constructor(x = 0, y = 0){
        this.x = +x;
        this.y = +y;
    }
    /**
     * Define this position value
     * @param {PositionDefinition|Number} definition - Horizontal position or another position
     * @param {Number} [diffY] - Vertical position if "definition" is a number
     * @return {Position} Itself
     */ set(definition, diffY) {
        let x;
        let y;
        if (typeof definition === "number") {
            x = definition;
            y = diffY === undefined ? definition : diffY;
        } else {
            const position = $ce200116bfeffd8f$export$2e2bcd8739ae039.from(definition);
            ({ x: x, y: y } = position);
        }
        this.x = x;
        this.y = y;
        return this;
    }
    /**
     * Create a copy of this position
     * @return {Position} New instance
     */ clone() {
        return new $ce200116bfeffd8f$export$2e2bcd8739ae039(this.x, this.y);
    }
    /**
     * Determine if is equal to another position
     * @param {PositionDefinition} positionDefinition - Any other position
     * @return {Boolean}
     */ equals(positionDefinition) {
        const position = $ce200116bfeffd8f$export$2e2bcd8739ae039.from(positionDefinition);
        return (0, $26d060ef72148247$export$e9bab7fafb253603)(this.x, position.x) && (0, $26d060ef72148247$export$e9bab7fafb253603)(this.y, position.y);
    }
    /**
     * Apply an operation to this position values
     * @param {Function} operation - Function to apply on value
     * @param {PositionDefinition|Number} definition - Another position or a number
     * @param {Number} [diffY] - Value to apply on "y" if "definition" is a number
     * @return {Position} Itself
     */ calc(operation, definition, diffY) {
        let x = 0;
        let y = 0;
        if (typeof definition === "number") {
            x = operation(this.x, definition);
            y = operation(this.y, diffY === undefined ? definition : diffY);
        } else {
            const position = $ce200116bfeffd8f$export$2e2bcd8739ae039.from(definition);
            x = operation(this.x, position.x);
            y = operation(this.y, position.y);
        }
        return this.set(x, y);
    }
    /**
     * Add another position or number
     * @param {PositionDefinition|Number} definition - Another position or a number
     * @param {Number} [y] - Value for "y" if "position" is a number
     * @return {Position} Itself
     */ add(definition, y) {
        return this.calc((self, other)=>self + other, definition, y);
    }
    /**
     * Subtract another position or number
     * @param {PositionDefinition|Number} definition - Another position or a number
     * @param {Number} [y] - Value for "y" if "position" is a number
     * @return {Position} Itself
     */ subtract(definition, y) {
        return this.calc((self, other)=>self - other, definition, y);
    }
    /**
     * Multiply by another position or number
     * @param {PositionDefinition|Number} definition - Another position or a number
     * @param {Number} [y] - Value for "y" if "position" is a number
     * @return {Position} Itself
     */ multiply(definition, y) {
        return this.calc((self, other)=>self * other, definition, y);
    }
    /**
     * Divide by another position or number
     * @param {PositionDefinition|Number} definition - Another position or a number
     * @param {Number} [y] - Value for "y" if "position" is a number
     * @return {Position} Itself
     */ divide(definition, y) {
        return this.calc((self, other)=>self / other, definition, y);
    }
    /**
     * Gives the modulo by another position or number
     * @param {PositionDefinition|Number} definition - Another position or a number
     * @param {Number} [y] - Value for "y" if "position" is a number
     * @return {Position} Itself
     */ modulo(definition, y) {
        return this.calc((self, other)=>(0, $26d060ef72148247$export$ba467bec01d66def)(self, other), definition, y);
    }
    /**
     * Raise to a power
     * @param {PositionDefinition|Number} definition - Another position or a number
     * @param {Number} [y] - Value for "y" if "position" is a number
     * @return {Position} Itself
     */ power(definition, y) {
        return this.calc((self, other)=>self ** other, definition, y);
    }
    /**
     * Rotate the position around the origin clockwise
     * @param {Number} [angle=0] - Angle of rotation in ratio of full circle
     * (0 means no rotation, 1 means go full circle back to same position)
     * @param {PositionDefinition} [originDefinition] - Point of origin to rotate around (by default (0, 0))
     * @return {Position} Itself
     */ rotate(angle = 0, originDefinition) {
        const { cos: cos, sin: sin } = Math;
        const degree = angle * (0, $26d060ef72148247$export$10ec9ebfd343bc9a);
        const origin = $ce200116bfeffd8f$export$2e2bcd8739ae039.from(originDefinition);
        const clone = this.clone().subtract(origin);
        const x = clone.x * cos(degree) - clone.y * sin(degree);
        const y = clone.y * cos(degree) + clone.x * sin(degree);
        return this.set(x, y).add(origin);
    }
    /**
     * Constrain the position to a rectangle define by two positions
     * @param {PositionDefinition} startDefinition - Starting position of the constrain (upper-left corner)
     * @param {PositionDefinition} endDefinition - Ending position of the constrain (lower-right corner)
     * @return {Position} Itself
     */ constrain(startDefinition, endDefinition) {
        const start = $ce200116bfeffd8f$export$2e2bcd8739ae039.from(startDefinition);
        const end = $ce200116bfeffd8f$export$2e2bcd8739ae039.from(endDefinition);
        const x = (0, $26d060ef72148247$export$c4e2ecac49351ef2)(this.x, Math.min(start.x, end.x), Math.max(start.x, end.x));
        const y = (0, $26d060ef72148247$export$c4e2ecac49351ef2)(this.y, Math.min(start.y, end.y), Math.max(start.y, end.y));
        return this.set(x, y);
    }
    /**
     * Move the position towards another by a ratio
     * @param {PositionDefinition} positionDefinition - Any other position
     * @param {Number} ratio - Ratio of distance to move, 0 mean no change, 1 mean arrive at position
     * @return {Position} Itself
     */ lerp(positionDefinition, ratio) {
        const difference = $ce200116bfeffd8f$export$2e2bcd8739ae039.from(positionDefinition).clone().subtract(this).multiply(ratio);
        return this.add(difference);
    }
    /**
     * Compute distance with another position
     * @param {PositionDefinition} positionDefinition - Any position
     * @return {Number}
     */ distance(positionDefinition) {
        const position = $ce200116bfeffd8f$export$2e2bcd8739ae039.from(positionDefinition);
        return Math.hypot(position.x - this.x, position.y - this.y);
    }
    /**
     * Dot product
     * @param {PositionDefinition} positionDefinition - Another position
     * @return {Number}
     */ dotProduct(positionDefinition) {
        const position = $ce200116bfeffd8f$export$2e2bcd8739ae039.from(positionDefinition);
        return this.x * position.x + this.y * position.y;
    }
    /**
     * Cross product
     * @param {PositionDefinition} positionDefinition - Another position
     * @return {Number}
     */ crossProduct(positionDefinition) {
        const position = $ce200116bfeffd8f$export$2e2bcd8739ae039.from(positionDefinition);
        return this.x * position.y - this.y * position.x;
    }
    /**
     * Define if this is on the same side of a vector as another position
     * @param {PositionDefinition} positionDefinition - Another position
     * @param {Vector} vector - Any vector
     * @return {Boolean}
     */ isOnSameSide(positionDefinition, vector) {
        const position = $ce200116bfeffd8f$export$2e2bcd8739ae039.from(positionDefinition);
        const thisMoved = this.clone().subtract(vector.start);
        const positionMoved = position.clone().subtract(vector.start);
        const delta = vector.getDelta();
        const { sign: sign } = Math;
        return sign(thisMoved.crossProduct(delta)) === sign(positionMoved.crossProduct(delta));
    }
    /**
     * Get vector length
     * @return {Number}
     */ get length() {
        return this.distance();
    }
    /**
     * Get the angle of a position relative to the horizontal axis
     * @return {Number}
     */ get angle() {
        if (this.x === 0 && this.y === 0) return 0;
        return Math.atan(this.y / this.x) / (0, $26d060ef72148247$export$10ec9ebfd343bc9a) + (this.x < 0 ? 0.75 : 0.25);
    }
    /**
     * Return a JSON ready Position definition
     * @return {Array<Number>}
     */ toJSON() {
        const { x: x, y: y } = this;
        return [
            x,
            y
        ];
    }
    /**
     * @typedef {Object} AbstractPosition
     * @prop {Number} [x=0] - Vertical position
     * @prop {Number} [y=0] - Horizontal position
     */ /**
     * @typedef {Array<Number>|AbstractPosition} PositionDefinition
     */ /**
     * Create a Position from a generic definition or do nothing if already a Position
     * @param {PositionDefinition} [positionDefinition] - Position definition
     * @return {Position}
     */ static from(positionDefinition = new $ce200116bfeffd8f$export$2e2bcd8739ae039()) {
        if (positionDefinition instanceof $ce200116bfeffd8f$export$2e2bcd8739ae039) return positionDefinition;
        if (Array.isArray(positionDefinition)) return new $ce200116bfeffd8f$export$2e2bcd8739ae039(...positionDefinition);
        try {
            return new $ce200116bfeffd8f$export$2e2bcd8739ae039(positionDefinition.x, positionDefinition.y);
        } catch  {
            throw TypeError(`Unexpected type for position: ${JSON.stringify(positionDefinition)}.`);
        }
    }
    /**
     * Compute the average for a set of positions
     * @param {...PositionDefinition} positionDefinitions - List of positions to average
     * @return {Position}
     */ static average(...positionDefinitions) {
        let result = new $ce200116bfeffd8f$export$2e2bcd8739ae039();
        positionDefinitions.forEach((one)=>result = result.add($ce200116bfeffd8f$export$2e2bcd8739ae039.from(one)));
        const nbPositions = positionDefinitions.length;
        return result.divide(nbPositions);
    }
}



/**
 * @module Vector
 */ const $92b1416d713d9082$var$allEquals = (...args)=>args.slice(1).every((a)=>a === args[0]);
/**
 * Accept all kind of type and return only Number or Position
 * @param {VectorDefinition|PositionDefinition|Number} definition - Value definition
 * @return {Position|Number}
 */ function $92b1416d713d9082$var$sanitizeParameters(definition) {
    // Number or Position
    if (typeof definition === "number" || definition instanceof (0, $ce200116bfeffd8f$export$2e2bcd8739ae039)) return definition;
    // Anything with a getDelta function
    if (typeof definition.getDelta === "function") return definition.getDelta();
    // PositionDefinition
    if (typeof definition[0] === "number" && typeof definition[1] === "number") return (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(definition);
    // eslint-disable-next-line no-use-before-define
    return $92b1416d713d9082$export$2e2bcd8739ae039.from(definition).getDelta();
}
class $92b1416d713d9082$export$2e2bcd8739ae039 {
    /**
     * Vector constructor
     * @param {PositionDefinition} start - Starting vector's position
     * @param {PositionDefinition} end - Ending vector's position
     */ constructor(start, end){
        this.start = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(start);
        this.end = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(end);
    }
    /**
     * Get this vector horizontal component
     * @return {Number}
     */ get width() {
        return Math.abs(this.start.x - this.end.x);
    }
    /**
     * Get this vector vertical component
     * @return {Number}
     */ get height() {
        return Math.abs(this.start.y - this.end.y);
    }
    /**
     * Return this vector's length
     * @return {Number}
     */ get length() {
        return this.start.distance(this.end);
    }
    /**
     * Create a new copy of this vector
     * @return {Vector}
     */ clone() {
        return new $92b1416d713d9082$export$2e2bcd8739ae039(this.start.clone(), this.end.clone());
    }
    /**
     * Determine if is equal to another vector
     * @param {VectorDefinition} vectorDefinition - Any vector
     * @return {Boolean}
     */ equals(vectorDefinition) {
        const vector = $92b1416d713d9082$export$2e2bcd8739ae039.from(vectorDefinition);
        return this.start.equals(vector.start) && this.end.equals(vector.end);
    }
    /**
     * Get the vector move with start at (0, 0)
     * @return {Position}
     */ getDelta() {
        return this.end.clone().subtract(this.start);
    }
    /**
     * Add a vector
     * @param {VectorDefinition|PositionDefinition|Number} modification - Any Vector or Position or Number
     * @return {Vector} Itself
     */ add(modification) {
        const toAdd = $92b1416d713d9082$var$sanitizeParameters(modification);
        this.end.add(toAdd);
        return this;
    }
    /**
     * Move this vector
     * @param {VectorDefinition|PositionDefinition|Number} modification - Any Vector or Position or Number
     * @return {Vector} Itself
     */ translate(modification) {
        const toAdd = $92b1416d713d9082$var$sanitizeParameters(modification);
        this.start.add(toAdd);
        this.end.add(toAdd);
        return this;
    }
    /**
     * Multiply this vector
     * @param {VectorDefinition|PositionDefinition|Number} modification - Any Vector or Position or Number
     * @return {Vector} Itself
     */ multiply(modification) {
        if (typeof modification === "number") {
            this.add(this.getDelta().multiply(modification - 1));
            return this;
        }
        const toMultiply = $92b1416d713d9082$var$sanitizeParameters(modification);
        this.end.multiply(toMultiply);
        return this;
    }
    /**
     * Define if this vector intersect another
     * @param {VectorDefinition} vectorDefinition - Any vector
     * @return {Boolean}
     */ intersect(vectorDefinition) {
        const vector = $92b1416d713d9082$export$2e2bcd8739ae039.from(vectorDefinition);
        if (!(this.start.isOnSameSide(this.end, vector) || vector.start.isOnSameSide(vector.end, this))) return true;
        const delta = this.getDelta();
        const startDiff = vector.start.clone().subtract(this.start);
        // Collinear
        if (delta.crossProduct(startDiff) === 0 && delta.crossProduct(vector.getDelta()) === 0) // Overlap
        return !$92b1416d713d9082$var$allEquals(this.start.x < vector.start.x, this.start.x < vector.end.x, this.end.x < vector.start.x, this.end.x < vector.end.x) || !$92b1416d713d9082$var$allEquals(this.start.y < vector.start.y, this.start.y < vector.end.y, this.end.y < vector.start.y, this.end.y < vector.end.y);
        return false;
    }
    /**
     * Return the intersection point between two vector or null if no intersection happen
     * @param {VectorDefinition} vectorDefinition - Any vector
     * @return {Position}
     */ getIntersectionPoint(vectorDefinition) {
        const vector = $92b1416d713d9082$export$2e2bcd8739ae039.from(vectorDefinition);
        if (!this.intersect(vector)) return null;
        const delta = vector.getDelta();
        const determinant = this.getDelta().crossProduct(delta);
        if (determinant === 0) return this.start.clone().constrain(vector.start, vector.end).lerp(this.end.clone().constrain(vector.start, vector.end), 0.5);
        const diff = this.start.clone().subtract(vector.start);
        return this.start.clone().lerp(this.end, delta.crossProduct(diff) / determinant);
    }
    /**
     * Find the closest position to a point on this vector
     * @param {PositionDefinition} positionDefinition - Any position
     * @return {Position}
     */ getClosestToPoint(positionDefinition) {
        const position = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(positionDefinition);
        const aToP = new $92b1416d713d9082$export$2e2bcd8739ae039(this.start, position).getDelta();
        const aToB = this.getDelta();
        const t = aToP.dotProduct(aToB) / this.length ** 2;
        return this.start.clone().add(aToB.multiply(t)).constrain(this.start, this.end);
    }
    /**
     * Return a JSON ready Vector definition
     * @return {Array<Array<Number>>}
     */ toJSON() {
        const { start: start, end: end } = this;
        return [
            start,
            end
        ];
    }
    /**
     * @typedef {Object} AbstractVector
     * @prop {PositionDefinition} [start] - Start coordinates
     * @prop {PositionDefinition} [end] - End coordinates
     */ /**
     * @typedef {Array<PositionDefinition>|AbstractVector} VectorDefinition
     */ /**
     * Create a Vector from a generic definition
     * @param {VectorDefinition} [vectorDefinition] - Vector definition
     * @return {Vector}
     */ static from(vectorDefinition = new $92b1416d713d9082$export$2e2bcd8739ae039()) {
        if (vectorDefinition instanceof $92b1416d713d9082$export$2e2bcd8739ae039) return vectorDefinition;
        if (Array.isArray(vectorDefinition) && vectorDefinition.length === 2) return new $92b1416d713d9082$export$2e2bcd8739ae039(...vectorDefinition);
        try {
            return new $92b1416d713d9082$export$2e2bcd8739ae039(vectorDefinition.start, vectorDefinition.end);
        } catch  {
            throw new TypeError(`Unexpected type for vector: ${JSON.stringify(vectorDefinition)}.`);
        }
    }
}



/**
 * @module EventEmitter
 */ /**
 * Able to listen and fire events
 * @abstract
 * @class
 */ class $e3eecb02d2839ca2$export$2e2bcd8739ae039 {
    /**
     * EventEmitter constructor
     */ constructor(){
        /**
         * @typedef {Object} EventListener
         * @prop {Function} callback - Function called when event is fired
         * @prop {EventEmitter} element - Element on which to listen for the event
         * @prop {Boolean} isTargeted - Will call the callback only when the event target is the element
         * @prop {String} [modifier] - Additional data about the event
         */ /**
         * Set of event listeners of this component
         * @type {Object<string, Array<EventListener>>}
         */ this.eventListeners = {};
    }
    /**
     * Listen to an event or multiple events
     * @param {String|Array<String>} eventName - Name of event (or a list of event names) to listen to.<br>
     * The event name can be followed by a modifier (separated by a ".")
     * @param {Function} callback - Function to call when event fire
     * @param {Boolean} [isTargeted=false] - Should only listen to event targeting itself
     * @return {EventEmitter} Itself
     * @example component.on("event.modifier", () => console.log("Event fired with modifier"));
     */ on(eventName, callback, isTargeted = false) {
        const event = {
            callback: callback,
            element: this,
            isTargeted: isTargeted
        };
        (Array.isArray(eventName) ? eventName : [
            eventName
        ]).forEach((name)=>{
            const [baseName, modifier] = name.split(".");
            if (!this.eventListeners[baseName]) this.eventListeners[baseName] = [];
            this.eventListeners[baseName].push({
                ...event,
                modifier: modifier
            });
        });
        return this;
    }
    /**
     * Trigger an event
     * @param {BaseEvent} event - Event to trigger
     * @return {EventEmitter} Itself
     */ fire(event) {
        const listeners = this.eventListeners[event.name];
        if (listeners) listeners.forEach((listener)=>{
            if (!listener.isTargeted || listener.element === event.target) {
                const modifier = event.getModifier && event.getModifier();
                if (!listener.modifier || listener.modifier === modifier) listener.callback.call(this, event);
            }
        });
        return this;
    }
    /**
     * Remove an event or multiple events
     * @param {String|Array<String>} eventName - Name of event (or a list of event names) to remove
     * @param {Function} [callback] - Specify the callback to remove, if not defined remove all listeners
     * @return {EventEmitter} Itself
     */ removeListener(eventName, callback) {
        (Array.isArray(eventName) ? eventName : [
            eventName
        ]).forEach((name)=>{
            const [baseName, modifier] = name.split(".");
            if (callback || modifier) this.eventListeners[baseName] = this.eventListeners[baseName].filter((event)=>callback && event.callback !== callback || modifier && event.modifier !== modifier);
            else delete this.eventListeners[baseName];
        });
        return this;
    }
    /**
     * Remove all event listener
     * @return {EventEmitter} Itself
     */ removeAllListener() {
        this.eventListeners = {};
        return this;
    }
    /**
     * @typedef {Object} EventEmitterEvents
     */ /**
     * @type {EventEmitterEvents}
     */ static get events() {
        return {};
    }
}


/**
 * @module BaseEvent
 */ /**
 * Base event class
 * @class
 */ class $1aed883b78728e08$export$2e2bcd8739ae039 {
    /**
     * BaseEvent constructor
     * @param {String} name - Name of the event
     * @param {EventEmitter} target - Component concerned by the event
     * @param {UIEvent} [event] - Original HTML event
     */ constructor(name, target, event){
        this.name = name;
        this.target = target;
        this.event = event;
        this.bubble = true;
    }
    /**
     * Mark this event as stopped
     * @return {BaseEvent} Itself
     */ stop() {
        this.bubble = false;
        return this;
    }
    /**
     * Get the event modifier (should be overridden by child classes)
     * @return {null}
     */ getModifier() {
        return null;
    }
    /**
     * Prevent the initial event default behavior
     * @return {BaseEvent} Itself
     */ prevent() {
        this.event.preventDefault();
        return this;
    }
}




/**
 * @module Container
 */ const $38771a883d186a4e$var$scenePromiseKey = Symbol("_scenePromise");
class $38771a883d186a4e$export$2e2bcd8739ae039 extends (0, $e3eecb02d2839ca2$export$2e2bcd8739ae039) {
    /**
     * Container constructor
     * @param {PositionDefinition} [positionDefinition] - Position in its container
     * @param {ContainerOptions} [options] - Specific options
     */ constructor(positionDefinition = new (0, $ce200116bfeffd8f$export$2e2bcd8739ae039)(), options){
        super();
        /**
         * @type {Position}
         */ this.position = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(positionDefinition);
        /**
         * @type {ContainerOptions}
         */ this.options = {};
        this.setOptions(options);
        /**
         * @type {Array<Container>}
         */ this.children = [];
        /**
         * @type {Container}
         */ this.parent = null;
        /**
         * @type {Number}
         */ this.frameCount = 0;
        /**
         * @type {Promise<Scene>}
         * @private
         */ this[$38771a883d186a4e$var$scenePromiseKey] = new Promise((resolve)=>{
            this.on($38771a883d186a4e$export$2e2bcd8739ae039.events.attach, ()=>{
                const root = this.getRoot();
                if (root.isScene) resolve(root);
                else root.getScene().then((scene)=>resolve(scene));
            }, true);
        });
    }
    /**
     * Define options for this container
     * @param {ContainerOptions} [options={}] - Options to override
     * @return {Container} Itself
     */ setOptions(options = {}) {
        this.options = {
            ...this.constructor.defaultOptions,
            ...this.options,
            ...options
        };
        this.options.rotationCenter = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(this.options.rotationCenter);
        if (typeof this.options.scale !== "number") this.options.scale = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(this.options.scale);
        return this;
    }
    /**
     * Container can't be hovered
     * @return {Boolean}
     */ isHover() {
        return false;
    }
    /**
     * Add another container as a child
     * @param {...Container} child - Another container
     * @return {Container} Itself
     */ add(...child) {
        child.forEach((one)=>{
            if (one === this) throw new RangeError("A container can't contain itself.");
            if (one.isScene) throw new RangeError("A scene can't be contained in another container.");
            if (one.parent) one.parent.remove(one);
            one.parent = this;
            this.children.push(one);
            one.fire(new (0, $1aed883b78728e08$export$2e2bcd8739ae039)($38771a883d186a4e$export$2e2bcd8739ae039.events.attach, one));
        });
        return this;
    }
    /**
     * Remove a child from the list
     * @param {...Container} child - Child to remove
     * @return {Container} Itself
     */ remove(...child) {
        child.forEach((one)=>{
            if (this.children.includes(one)) {
                const removed = this.children.splice(this.children.indexOf(one), 1)[0];
                removed.parent = null;
                removed.fire(new (0, $1aed883b78728e08$export$2e2bcd8739ae039)($38771a883d186a4e$export$2e2bcd8739ae039.events.detach, removed));
            }
        });
        return this;
    }
    /**
     * Remove all its children
     * @return {Container} Itself
     */ empty() {
        return this.remove(...this.children);
    }
    /**
     * Remove itself from its parent
     * @return {Container} Itself
     */ delete() {
        if (this.parent) this.parent.remove(this);
        return this;
    }
    /**
     * Return a promise for the associated scene
     * @return {Promise<Scene>}
     */ getScene() {
        return this[$38771a883d186a4e$var$scenePromiseKey];
    }
    /**
     * Return its highest parent
     * @return {Container} Itself
     */ getRoot() {
        if (this.parent) return this.parent.getRoot();
        return this;
    }
    /**
     * Get this container's absolute position (up to it's utmost parent)
     * @return {Position}
     */ getAbsolutePosition() {
        const position = new (0, $ce200116bfeffd8f$export$2e2bcd8739ae039)();
        // FIXME: don't work for scale and don't take origin into account
        this.climbAncestry((ancestor)=>{
            position.rotate(ancestor.options.rotation, ancestor.options.rotationCenter).add(ancestor.position);
        });
        return position;
    }
    /**
     * Bubble the event to its parent
     * @param {BaseEvent} event - Event to fire
     * @return {Container} Itself
     */ fire(event) {
        super.fire(event);
        if (this.parent && event.bubble) this.parent.fire(event);
        return this;
    }
    /**
     * Find the target at a position
     * @param {Position} position - Any position
     * @param {CanvasRenderingContext2D} ctx - Drawing context to apply paths
     * @return {Container} Itself
     */ getTarget(position, ctx) {
        if (!this.options.shown) return null;
        ctx.save();
        ctx.translate(this.position.x, this.position.y);
        this.setContext(ctx);
        let lastHovered = null;
        let lookup = this.children.length - 1;
        while(!lastHovered && lookup >= 0){
            lastHovered = this.children[lookup].getTarget(position, ctx);
            --lookup;
        }
        let target = lastHovered;
        // No found or behind this
        if (!lastHovered || lastHovered.options.zIndex < 0 && lastHovered.parent === this) {
            if (this.isHover(position, ctx)) target = this;
        }
        ctx.restore();
        return target;
    }
    /**
     * Set variables of the context according to specified options
     * @param {CanvasRenderingContext2D} ctx - Drawing context
     * @return {Container} Itself
     */ setContext(ctx) {
        if (this.options.clip) {
            const clipping = new window.Path2D();
            const { clip: clip } = this.options;
            const { x: x, y: y } = clip.position;
            ctx.translate(x, y);
            if (clip.trace) clip.trace(clipping);
            ctx.clip(clipping);
            ctx.translate(-x, -y);
        }
        if (this.options.rotation) {
            const anchor = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(this.options.rotationCenter);
            ctx.translate(anchor.x, anchor.y);
            ctx.rotate(this.options.rotation * (0, $26d060ef72148247$export$10ec9ebfd343bc9a));
            ctx.translate(-anchor.x, -anchor.y);
        }
        if (typeof this.options.scale === "number") {
            if (this.options.scale !== 1) ctx.scale(this.options.scale, this.options.scale);
        } else {
            const scale = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(this.options.scale);
            if (scale.x !== 1 || scale.y !== 1) ctx.scale(scale.x, scale.y);
        }
        return this;
    }
    /**
     * Call the render method of all children
     * @param {CanvasRenderingContext2D} ctx - Drawing context
     * @return {Container} Itself
     */ render(ctx) {
        if (!this.options.shown) return this;
        this.frameCount++;
        this.fire(new (0, $1aed883b78728e08$export$2e2bcd8739ae039)($38771a883d186a4e$export$2e2bcd8739ae039.events.draw, this));
        ctx.save();
        ctx.translate(this.position.x, this.position.y);
        this.setContext(ctx);
        this.children.sort((a, b)=>a.options.zIndex - b.options.zIndex);
        $38771a883d186a4e$export$2e2bcd8739ae039.setOpacity(ctx, this.options.opacity);
        const firstPositiveIndex = this.children.findIndex((child)=>child.options.zIndex >= 0);
        const pivotIndex = firstPositiveIndex === -1 ? this.children.length : firstPositiveIndex;
        // Render children behind
        for(let i = 0, l = pivotIndex; i < l; ++i)this.children[i].render(ctx);
        this.makePath(ctx);
        // Render children in front
        for(let i = pivotIndex, l = this.children.length; i < l; ++i)this.children[i].render(ctx);
        ctx.restore();
        return this;
    }
    /**
     * Do nothing on Container, override it to add behavior
     * @return {Container} Itself
     */ makePath() {
        return this;
    }
    /**
     * Display it
     * @return {Container} Itself
     */ show() {
        this.options.shown = true;
        this.fire(new (0, $1aed883b78728e08$export$2e2bcd8739ae039)($38771a883d186a4e$export$2e2bcd8739ae039.events.show, this));
        return this;
    }
    /**
     * Hide it
     * @return {Container} Itself
     */ hide() {
        this.options.shown = false;
        this.fire(new (0, $1aed883b78728e08$export$2e2bcd8739ae039)($38771a883d186a4e$export$2e2bcd8739ae039.events.hide, this));
        return this;
    }
    /**
     * Define if this is an ancestor of another container
     * @param {Container} container - Any container
     * @return {Boolean}
     */ isAncestorOf(container) {
        if (container && container.parent) {
            if (container.parent === this) return true;
            return this.isAncestorOf(container.parent);
        }
        return false;
    }
    /**
     * @callback ancestryCallback
     * @param {Container} ancestor
     */ /**
     * Execute an action on every ancestor of this
     * @param {ancestryCallback} callback - Function to execute on each ancestor
     * @param {Container} [until=null] - Define a ancestor where to stop the climbing
     */ climbAncestry(callback, until) {
        callback(this);
        if (this.parent && this.parent !== until) this.parent.climbAncestry(callback);
    }
    /**
     * Return a json ready object
     * @return {Object}
     */ toJSON() {
        const { defaultOptions: defaultOptions } = this.constructor;
        const optionsCopy = {};
        Object.keys(this.options).forEach((key)=>{
            const value = this.options[key];
            if (!(value && value.equals ? value.equals(defaultOptions[key]) : Object.is(value, defaultOptions[key]))) optionsCopy[key] = value;
        });
        const json = {
            constructor: this.constructor.name,
            position: this.position
        };
        if (this.children.length) json.children = this.children.map((child)=>child.toJSON());
        if (Object.keys(optionsCopy).length) json.options = optionsCopy;
        return json;
    }
    /**
     * Create a copy of any descendant of Container
     * @return {Container}
     */ clone() {
        return this.constructor.from(this.toJSON());
    }
    /**
     * Define context opacity
     * @param {CanvasRenderingContext2D} ctx - Drawing context
     * @param {Number} opacity - Opacity value
     */ static setOpacity(ctx, opacity) {
        if (opacity !== null && ctx.globalAlpha !== opacity) ctx.globalAlpha = opacity;
    }
    /**
     * Return an instance from a generic object
     * @param {Object} definition - Container definition
     * @return {Container}
     */ static from(definition) {
        return new $38771a883d186a4e$export$2e2bcd8739ae039(definition.position, definition.options);
    }
    /**
     * @typedef {Object} ContainerOptions
     * @prop {Boolean} [shown=true] - Is shown
     * @prop {Number} [opacity=null] - Opacity level from 0 to 1 (null mean inherited from parent)
     * @prop {Number} [rotation=0] - Rotation ratio from 0 to 1 (clockwise)
     * @prop {PositionDefinition} [rotationCenter=new Position()] - Center of rotation relative to this position
     * @prop {Number|PositionDefinition} [scale=1] - Scaling ratio or a pair of value for horizontal and vertical scaling
     * @prop {Number} [zIndex=1] - Depth ordering
     * @prop {Component} [clip=null] - Other component used to clip the rendering
     */ /**
     * @type {ContainerOptions}
     */ static get defaultOptions() {
        return {
            shown: true,
            opacity: null,
            rotation: 0,
            rotationCenter: new (0, $ce200116bfeffd8f$export$2e2bcd8739ae039)(),
            scale: 1,
            zIndex: 1,
            clip: null
        };
    }
    /**
     * @typedef {Object} ContainerEvent
     * @extends EventEmitterEvents
     * @prop {String} attach - Container is append to a new parent
     * @prop {String} detach - Container remove from it's parent
     * @prop {String} draw - Container is drawn
     * @prop {String} hide -
     * @prop {String} show -
     */ /**
     * @type {ContainerEvent}
     */ static get events() {
        return {
            ...super.events,
            attach: "attach",
            detach: "detach",
            draw: "draw",
            hide: "hide",
            show: "show"
        };
    }
}





class $254037bcf672ea5f$export$2e2bcd8739ae039 extends (0, $38771a883d186a4e$export$2e2bcd8739ae039) {
    /**
     * Off-screen canvas constructor
     * @param {Number} [width=1] - Width of the canvas
     * @param {Number} [height=1] - Height of the canvas
     * @param {ContainerOptions} [options] - Specific options
     */ constructor(width = 1, height = 1, options){
        super(undefined, options);
        /**
         * @type {CanvasRenderingContext2D}
         */ this.ctx = this.constructor.getDrawingContext(width, height);
    }
    /**
     * Change the behavior for upscaled images, smoothing is good for pictures but bad for pixel-art
     * @param {Boolean} enable - Should the smoothing be active or not
     * @return {OffScreenCanvas} Itself
     */ setImageSmoothing(enable) {
        this.ctx.imageSmoothingEnabled = enable;
        return this;
    }
    /**
     * Erase the canvas
     * @return {OffScreenCanvas} Itself
     */ clear() {
        this.ctx.clearRect(0, 0, this.width, this.height);
        if (this.options.fill) {
            $254037bcf672ea5f$export$2e2bcd8739ae039.setOpacity(this.ctx, this.options.opacity);
            const { width: width, height: height } = this;
            this.ctx.fillStyle = this.options.fill.toString(this.ctx);
            this.ctx.fillRect(0, 0, width, height);
        }
        return this;
    }
    /**
     * Render a container and its children into the canvas
     * @return {OffScreenCanvas} Itself
     */ render() {
        this.clear();
        super.render(this.ctx);
        return this;
    }
    /**
     * @return {Number}
     */ get width() {
        return this.ctx.canvas.width;
    }
    /**
     * @param {Number} width - New width value
     */ set width(width) {
        this.ctx.canvas.width = +width;
    }
    /**
     * @return {Number}
     */ get height() {
        return this.ctx.canvas.height;
    }
    /**
     * @param {Number} height - New height value
     */ set height(height) {
        this.ctx.canvas.height = +height;
    }
    /**
     * Return the whole scene size
     * @return {Position}
     */ get size() {
        return new (0, $ce200116bfeffd8f$export$2e2bcd8739ae039)(this.width, this.height);
    }
    /**
     * Return this scene center point
     * @return {Position}
     */ get center() {
        return this.size.divide(2);
    }
    /**
     * Return a random position within the scene
     * @return {Position}
     */ getRandomPosition() {
        return new (0, $ce200116bfeffd8f$export$2e2bcd8739ae039)((0, $26d060ef72148247$export$4385e60b38654f68)(this.width), (0, $26d060ef72148247$export$4385e60b38654f68)(this.height));
    }
    /**
     * Return the whole canvas as data
     * @param {VectorDefinition} [vectorDefinition] - Box of data to extract
     * @return {ImageData}
     */ getImageData(vectorDefinition) {
        let vector;
        if (vectorDefinition) vector = (0, $92b1416d713d9082$export$2e2bcd8739ae039).from(vectorDefinition);
        else vector = new (0, $92b1416d713d9082$export$2e2bcd8739ae039)(undefined, this.size);
        this.render();
        return this.ctx.getImageData(vector.start.x, vector.start.y, vector.end.x, vector.end.y);
    }
    /**
     * Put data into the canvas
     * @param {ImageData} imageData - Data to add to the canvas
     * @param {PositionDefinition} [positionDefinition] - Position of the data
     */ setImageData(imageData, positionDefinition) {
        const position = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(positionDefinition);
        this.ctx.putImageData(imageData, position.x, position.y);
    }
    /**
     * Return an image composed of its content
     * @param {VectorDefinition} [vectorDefinition] - Box to restrict exported data
     * @param {String} [type="image/png"] - Data format. Supported format depend on the browser implementation (png or jpeg are the only safe choices)
     * @return {HTMLImageElement}
     */ toImage(vectorDefinition, type = "image/png") {
        let vector;
        if (vectorDefinition) vector = (0, $92b1416d713d9082$export$2e2bcd8739ae039).from(vectorDefinition);
        else vector = new (0, $92b1416d713d9082$export$2e2bcd8739ae039)(undefined, [
            this.width,
            this.height
        ]);
        const img = window.document.createElement("img");
        const { width: width, height: height } = this;
        const size = vector.getDelta();
        this.width = size.x;
        this.height = size.y;
        img.width = this.width;
        img.height = this.height;
        this.ctx.translate(-vector.start.x, -vector.start.y);
        this.render();
        img.src = this.ctx.canvas.toDataURL(type);
        this.width = width;
        this.height = height;
        return img;
    }
    /**
     * Build a canvas context and returns it
     * @param {Number} width - Width of the canvas
     * @param {Number} height - Height of the canvas
     * @return {CanvasRenderingContext2D}
     */ static getDrawingContext(width = 1, height = 1) {
        const canvas = window.document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas.getContext("2d");
    }
    /**
     * @typedef {Object} OffscreenCanvasOptions
     * @prop {String|Color} [fill=null] - Background color
     * @prop {Number} [opacity=1] - Global opacity
     */ /**
     * @type {OffscreenCanvasOptions}
     */ static get defaultOptions() {
        return {
            ...super.defaultOptions,
            fill: null,
            opacity: 1
        };
    }
}


var $00fdc0fdfd66324b$var$r = {
    grad: .9,
    turn: 360,
    rad: 360 / (2 * Math.PI)
}, $00fdc0fdfd66324b$var$t = function(r) {
    return "string" == typeof r ? r.length > 0 : "number" == typeof r;
}, $00fdc0fdfd66324b$var$n = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = Math.pow(10, t)), Math.round(n * r) / n + 0;
}, $00fdc0fdfd66324b$var$e = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = 1), r > n ? n : r > t ? r : t;
}, $00fdc0fdfd66324b$var$u = function(r) {
    return (r = isFinite(r) ? r % 360 : 0) > 0 ? r : r + 360;
}, $00fdc0fdfd66324b$var$a = function(r) {
    return {
        r: $00fdc0fdfd66324b$var$e(r.r, 0, 255),
        g: $00fdc0fdfd66324b$var$e(r.g, 0, 255),
        b: $00fdc0fdfd66324b$var$e(r.b, 0, 255),
        a: $00fdc0fdfd66324b$var$e(r.a)
    };
}, $00fdc0fdfd66324b$var$o = function(r) {
    return {
        r: $00fdc0fdfd66324b$var$n(r.r),
        g: $00fdc0fdfd66324b$var$n(r.g),
        b: $00fdc0fdfd66324b$var$n(r.b),
        a: $00fdc0fdfd66324b$var$n(r.a, 3)
    };
}, $00fdc0fdfd66324b$var$i = /^#([0-9a-f]{3,8})$/i, $00fdc0fdfd66324b$var$s = function(r) {
    var t = r.toString(16);
    return t.length < 2 ? "0" + t : t;
}, $00fdc0fdfd66324b$var$h = function(r) {
    var t = r.r, n = r.g, e = r.b, u = r.a, a = Math.max(t, n, e), o = a - Math.min(t, n, e), i = o ? a === t ? (n - e) / o : a === n ? 2 + (e - t) / o : 4 + (t - n) / o : 0;
    return {
        h: 60 * (i < 0 ? i + 6 : i),
        s: a ? o / a * 100 : 0,
        v: a / 255 * 100,
        a: u
    };
}, $00fdc0fdfd66324b$var$b = function(r) {
    var t = r.h, n = r.s, e = r.v, u = r.a;
    t = t / 360 * 6, n /= 100, e /= 100;
    var a = Math.floor(t), o = e * (1 - n), i = e * (1 - (t - a) * n), s = e * (1 - (1 - t + a) * n), h = a % 6;
    return {
        r: 255 * [
            e,
            i,
            o,
            o,
            s,
            e
        ][h],
        g: 255 * [
            s,
            e,
            e,
            i,
            o,
            o
        ][h],
        b: 255 * [
            o,
            o,
            s,
            e,
            e,
            i
        ][h],
        a: u
    };
}, $00fdc0fdfd66324b$var$g = function(r) {
    return {
        h: $00fdc0fdfd66324b$var$u(r.h),
        s: $00fdc0fdfd66324b$var$e(r.s, 0, 100),
        l: $00fdc0fdfd66324b$var$e(r.l, 0, 100),
        a: $00fdc0fdfd66324b$var$e(r.a)
    };
}, $00fdc0fdfd66324b$var$d = function(r) {
    return {
        h: $00fdc0fdfd66324b$var$n(r.h),
        s: $00fdc0fdfd66324b$var$n(r.s),
        l: $00fdc0fdfd66324b$var$n(r.l),
        a: $00fdc0fdfd66324b$var$n(r.a, 3)
    };
}, $00fdc0fdfd66324b$var$f = function(r) {
    var t, n, e;
    return $00fdc0fdfd66324b$var$b((n = (t = r).s, {
        h: t.h,
        s: (n *= ((e = t.l) < 50 ? e : 100 - e) / 100) > 0 ? 2 * n / (e + n) * 100 : 0,
        v: e + n,
        a: t.a
    }));
}, $00fdc0fdfd66324b$var$c = function(r) {
    var t, n, e, u;
    return {
        h: (t = $00fdc0fdfd66324b$var$h(r)).h,
        s: (u = (200 - (n = t.s)) * (e = t.v) / 100) > 0 && u < 200 ? n * e / 100 / (u <= 100 ? u : 200 - u) * 100 : 0,
        l: u / 2,
        a: t.a
    };
}, $00fdc0fdfd66324b$var$l = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $00fdc0fdfd66324b$var$p = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $00fdc0fdfd66324b$var$v = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $00fdc0fdfd66324b$var$m = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $00fdc0fdfd66324b$var$y = {
    string: [
        [
            function(r) {
                var t = $00fdc0fdfd66324b$var$i.exec(r);
                return t ? (r = t[1]).length <= 4 ? {
                    r: parseInt(r[0] + r[0], 16),
                    g: parseInt(r[1] + r[1], 16),
                    b: parseInt(r[2] + r[2], 16),
                    a: 4 === r.length ? $00fdc0fdfd66324b$var$n(parseInt(r[3] + r[3], 16) / 255, 2) : 1
                } : 6 === r.length || 8 === r.length ? {
                    r: parseInt(r.substr(0, 2), 16),
                    g: parseInt(r.substr(2, 2), 16),
                    b: parseInt(r.substr(4, 2), 16),
                    a: 8 === r.length ? $00fdc0fdfd66324b$var$n(parseInt(r.substr(6, 2), 16) / 255, 2) : 1
                } : null : null;
            },
            "hex"
        ],
        [
            function(r) {
                var t = $00fdc0fdfd66324b$var$v.exec(r) || $00fdc0fdfd66324b$var$m.exec(r);
                return t ? t[2] !== t[4] || t[4] !== t[6] ? null : $00fdc0fdfd66324b$var$a({
                    r: Number(t[1]) / (t[2] ? 100 / 255 : 1),
                    g: Number(t[3]) / (t[4] ? 100 / 255 : 1),
                    b: Number(t[5]) / (t[6] ? 100 / 255 : 1),
                    a: void 0 === t[7] ? 1 : Number(t[7]) / (t[8] ? 100 : 1)
                }) : null;
            },
            "rgb"
        ],
        [
            function(t) {
                var n = $00fdc0fdfd66324b$var$l.exec(t) || $00fdc0fdfd66324b$var$p.exec(t);
                if (!n) return null;
                var e, u, a = $00fdc0fdfd66324b$var$g({
                    h: (e = n[1], u = n[2], void 0 === u && (u = "deg"), Number(e) * ($00fdc0fdfd66324b$var$r[u] || 1)),
                    s: Number(n[3]),
                    l: Number(n[4]),
                    a: void 0 === n[5] ? 1 : Number(n[5]) / (n[6] ? 100 : 1)
                });
                return $00fdc0fdfd66324b$var$f(a);
            },
            "hsl"
        ]
    ],
    object: [
        [
            function(r) {
                var n = r.r, e = r.g, u = r.b, o = r.a, i = void 0 === o ? 1 : o;
                return $00fdc0fdfd66324b$var$t(n) && $00fdc0fdfd66324b$var$t(e) && $00fdc0fdfd66324b$var$t(u) ? $00fdc0fdfd66324b$var$a({
                    r: Number(n),
                    g: Number(e),
                    b: Number(u),
                    a: Number(i)
                }) : null;
            },
            "rgb"
        ],
        [
            function(r) {
                var n = r.h, e = r.s, u = r.l, a = r.a, o = void 0 === a ? 1 : a;
                if (!$00fdc0fdfd66324b$var$t(n) || !$00fdc0fdfd66324b$var$t(e) || !$00fdc0fdfd66324b$var$t(u)) return null;
                var i = $00fdc0fdfd66324b$var$g({
                    h: Number(n),
                    s: Number(e),
                    l: Number(u),
                    a: Number(o)
                });
                return $00fdc0fdfd66324b$var$f(i);
            },
            "hsl"
        ],
        [
            function(r) {
                var n = r.h, a = r.s, o = r.v, i = r.a, s = void 0 === i ? 1 : i;
                if (!$00fdc0fdfd66324b$var$t(n) || !$00fdc0fdfd66324b$var$t(a) || !$00fdc0fdfd66324b$var$t(o)) return null;
                var h = function(r) {
                    return {
                        h: $00fdc0fdfd66324b$var$u(r.h),
                        s: $00fdc0fdfd66324b$var$e(r.s, 0, 100),
                        v: $00fdc0fdfd66324b$var$e(r.v, 0, 100),
                        a: $00fdc0fdfd66324b$var$e(r.a)
                    };
                }({
                    h: Number(n),
                    s: Number(a),
                    v: Number(o),
                    a: Number(s)
                });
                return $00fdc0fdfd66324b$var$b(h);
            },
            "hsv"
        ]
    ]
}, $00fdc0fdfd66324b$var$N = function(r, t) {
    for(var n = 0; n < t.length; n++){
        var e = t[n][0](r);
        if (e) return [
            e,
            t[n][1]
        ];
    }
    return [
        null,
        void 0
    ];
}, $00fdc0fdfd66324b$var$x = function(r) {
    return "string" == typeof r ? $00fdc0fdfd66324b$var$N(r.trim(), $00fdc0fdfd66324b$var$y.string) : "object" == typeof r && null !== r ? $00fdc0fdfd66324b$var$N(r, $00fdc0fdfd66324b$var$y.object) : [
        null,
        void 0
    ];
}, $00fdc0fdfd66324b$export$f61ac8b6f1f46202 = function(r) {
    return $00fdc0fdfd66324b$var$x(r)[1];
}, $00fdc0fdfd66324b$var$M = function(r, t) {
    var n = $00fdc0fdfd66324b$var$c(r);
    return {
        h: n.h,
        s: $00fdc0fdfd66324b$var$e(n.s + 100 * t, 0, 100),
        l: n.l,
        a: n.a
    };
}, $00fdc0fdfd66324b$var$H = function(r) {
    return (299 * r.r + 587 * r.g + 114 * r.b) / 1e3 / 255;
}, $00fdc0fdfd66324b$var$$ = function(r, t) {
    var n = $00fdc0fdfd66324b$var$c(r);
    return {
        h: n.h,
        s: n.s,
        l: $00fdc0fdfd66324b$var$e(n.l + 100 * t, 0, 100),
        a: n.a
    };
}, $00fdc0fdfd66324b$export$4d30ed660ff08d0 = function() {
    function r(r) {
        this.parsed = $00fdc0fdfd66324b$var$x(r)[0], this.rgba = this.parsed || {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
    }
    return r.prototype.isValid = function() {
        return null !== this.parsed;
    }, r.prototype.brightness = function() {
        return $00fdc0fdfd66324b$var$n($00fdc0fdfd66324b$var$H(this.rgba), 2);
    }, r.prototype.isDark = function() {
        return $00fdc0fdfd66324b$var$H(this.rgba) < .5;
    }, r.prototype.isLight = function() {
        return $00fdc0fdfd66324b$var$H(this.rgba) >= .5;
    }, r.prototype.toHex = function() {
        var r, t, e, u, a, i;
        return r = $00fdc0fdfd66324b$var$o(this.rgba), t = r.r, e = r.g, u = r.b, i = (a = r.a) < 1 ? $00fdc0fdfd66324b$var$s($00fdc0fdfd66324b$var$n(255 * a)) : "", "#" + $00fdc0fdfd66324b$var$s(t) + $00fdc0fdfd66324b$var$s(e) + $00fdc0fdfd66324b$var$s(u) + i;
    }, r.prototype.toRgb = function() {
        return $00fdc0fdfd66324b$var$o(this.rgba);
    }, r.prototype.toRgbString = function() {
        var r, t, n, e, u;
        return r = $00fdc0fdfd66324b$var$o(this.rgba), t = r.r, n = r.g, e = r.b, (u = r.a) < 1 ? "rgba(" + t + ", " + n + ", " + e + ", " + u + ")" : "rgb(" + t + ", " + n + ", " + e + ")";
    }, r.prototype.toHsl = function() {
        return $00fdc0fdfd66324b$var$d($00fdc0fdfd66324b$var$c(this.rgba));
    }, r.prototype.toHslString = function() {
        var r, t, n, e, u;
        return r = $00fdc0fdfd66324b$var$d($00fdc0fdfd66324b$var$c(this.rgba)), t = r.h, n = r.s, e = r.l, (u = r.a) < 1 ? "hsla(" + t + ", " + n + "%, " + e + "%, " + u + ")" : "hsl(" + t + ", " + n + "%, " + e + "%)";
    }, r.prototype.toHsv = function() {
        var r;
        return r = $00fdc0fdfd66324b$var$h(this.rgba), {
            h: $00fdc0fdfd66324b$var$n(r.h),
            s: $00fdc0fdfd66324b$var$n(r.s),
            v: $00fdc0fdfd66324b$var$n(r.v),
            a: $00fdc0fdfd66324b$var$n(r.a, 3)
        };
    }, r.prototype.invert = function() {
        var r;
        return $00fdc0fdfd66324b$export$c8efe09109f9cb9e({
            r: 255 - (r = this.rgba).r,
            g: 255 - r.g,
            b: 255 - r.b,
            a: r.a
        });
    }, r.prototype.saturate = function(r) {
        return void 0 === r && (r = .1), $00fdc0fdfd66324b$export$c8efe09109f9cb9e($00fdc0fdfd66324b$var$M(this.rgba, r));
    }, r.prototype.desaturate = function(r) {
        return void 0 === r && (r = .1), $00fdc0fdfd66324b$export$c8efe09109f9cb9e($00fdc0fdfd66324b$var$M(this.rgba, -r));
    }, r.prototype.grayscale = function() {
        return $00fdc0fdfd66324b$export$c8efe09109f9cb9e($00fdc0fdfd66324b$var$M(this.rgba, -1));
    }, r.prototype.lighten = function(r) {
        return void 0 === r && (r = .1), $00fdc0fdfd66324b$export$c8efe09109f9cb9e($00fdc0fdfd66324b$var$$(this.rgba, r));
    }, r.prototype.darken = function(r) {
        return void 0 === r && (r = .1), $00fdc0fdfd66324b$export$c8efe09109f9cb9e($00fdc0fdfd66324b$var$$(this.rgba, -r));
    }, r.prototype.rotate = function(r) {
        return void 0 === r && (r = 15), this.hue(this.hue() + r);
    }, r.prototype.alpha = function(r) {
        var t;
        return "number" == typeof r ? $00fdc0fdfd66324b$export$c8efe09109f9cb9e({
            r: (t = this.rgba).r,
            g: t.g,
            b: t.b,
            a: r
        }) : $00fdc0fdfd66324b$var$n(this.rgba.a, 3);
    }, r.prototype.hue = function(r) {
        var t = $00fdc0fdfd66324b$var$c(this.rgba);
        return "number" == typeof r ? $00fdc0fdfd66324b$export$c8efe09109f9cb9e({
            h: r,
            s: t.s,
            l: t.l,
            a: t.a
        }) : $00fdc0fdfd66324b$var$n(t.h);
    }, r.prototype.isEqual = function(r) {
        return this.toHex() === $00fdc0fdfd66324b$export$c8efe09109f9cb9e(r).toHex();
    }, r;
}(), $00fdc0fdfd66324b$export$c8efe09109f9cb9e = function(r) {
    return r instanceof $00fdc0fdfd66324b$export$4d30ed660ff08d0 ? r : new $00fdc0fdfd66324b$export$4d30ed660ff08d0(r);
}, $00fdc0fdfd66324b$var$S = [], $00fdc0fdfd66324b$export$8b58be045bf06082 = function(r) {
    r.forEach(function(r) {
        $00fdc0fdfd66324b$var$S.indexOf(r) < 0 && (r($00fdc0fdfd66324b$export$4d30ed660ff08d0, $00fdc0fdfd66324b$var$y), $00fdc0fdfd66324b$var$S.push(r));
    });
}, $00fdc0fdfd66324b$export$4385e60b38654f68 = function() {
    return new $00fdc0fdfd66324b$export$4d30ed660ff08d0({
        r: 255 * Math.random(),
        g: 255 * Math.random(),
        b: 255 * Math.random()
    });
};


var $4d140387fb4c3902$exports = {};
$4d140387fb4c3902$exports = function(e, f) {
    var a = {
        white: "#ffffff",
        bisque: "#ffe4c4",
        blue: "#0000ff",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        azure: "#f0ffff",
        whitesmoke: "#f5f5f5",
        papayawhip: "#ffefd5",
        plum: "#dda0dd",
        blanchedalmond: "#ffebcd",
        black: "#000000",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gainsboro: "#dcdcdc",
        cornsilk: "#fff8dc",
        cornflowerblue: "#6495ed",
        burlywood: "#deb887",
        aquamarine: "#7fffd4",
        beige: "#f5f5dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkkhaki: "#bdb76b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        peachpuff: "#ffdab9",
        darkmagenta: "#8b008b",
        darkred: "#8b0000",
        darkorchid: "#9932cc",
        darkorange: "#ff8c00",
        darkslateblue: "#483d8b",
        gray: "#808080",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        wheat: "#f5deb3",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        ghostwhite: "#f8f8ff",
        darkviolet: "#9400d3",
        magenta: "#ff00ff",
        green: "#008000",
        dodgerblue: "#1e90ff",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        blueviolet: "#8a2be2",
        forestgreen: "#228b22",
        lawngreen: "#7cfc00",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        fuchsia: "#ff00ff",
        brown: "#a52a2a",
        maroon: "#800000",
        mediumblue: "#0000cd",
        lightcoral: "#f08080",
        darkturquoise: "#00ced1",
        lightcyan: "#e0ffff",
        ivory: "#fffff0",
        lightyellow: "#ffffe0",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        linen: "#faf0e6",
        mediumaquamarine: "#66cdaa",
        lemonchiffon: "#fffacd",
        lime: "#00ff00",
        khaki: "#f0e68c",
        mediumseagreen: "#3cb371",
        limegreen: "#32cd32",
        mediumspringgreen: "#00fa9a",
        lightskyblue: "#87cefa",
        lightblue: "#add8e6",
        midnightblue: "#191970",
        lightpink: "#ffb6c1",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        mintcream: "#f5fffa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        navajowhite: "#ffdead",
        navy: "#000080",
        mediumvioletred: "#c71585",
        powderblue: "#b0e0e6",
        palegoldenrod: "#eee8aa",
        oldlace: "#fdf5e6",
        paleturquoise: "#afeeee",
        mediumturquoise: "#48d1cc",
        mediumorchid: "#ba55d3",
        rebeccapurple: "#663399",
        lightsteelblue: "#b0c4de",
        mediumslateblue: "#7b68ee",
        thistle: "#d8bfd8",
        tan: "#d2b48c",
        orchid: "#da70d6",
        mediumpurple: "#9370db",
        purple: "#800080",
        pink: "#ffc0cb",
        skyblue: "#87ceeb",
        springgreen: "#00ff7f",
        palegreen: "#98fb98",
        red: "#ff0000",
        yellow: "#ffff00",
        slateblue: "#6a5acd",
        lavenderblush: "#fff0f5",
        peru: "#cd853f",
        palevioletred: "#db7093",
        violet: "#ee82ee",
        teal: "#008080",
        slategray: "#708090",
        slategrey: "#708090",
        aliceblue: "#f0f8ff",
        darkseagreen: "#8fbc8f",
        darkolivegreen: "#556b2f",
        greenyellow: "#adff2f",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        tomato: "#ff6347",
        silver: "#c0c0c0",
        sienna: "#a0522d",
        lavender: "#e6e6fa",
        lightgreen: "#90ee90",
        orange: "#ffa500",
        orangered: "#ff4500",
        steelblue: "#4682b4",
        royalblue: "#4169e1",
        turquoise: "#40e0d0",
        yellowgreen: "#9acd32",
        salmon: "#fa8072",
        saddlebrown: "#8b4513",
        sandybrown: "#f4a460",
        rosybrown: "#bc8f8f",
        darksalmon: "#e9967a",
        lightgoldenrodyellow: "#fafad2",
        snow: "#fffafa",
        lightgrey: "#d3d3d3",
        lightgray: "#d3d3d3",
        dimgray: "#696969",
        dimgrey: "#696969",
        olivedrab: "#6b8e23",
        olive: "#808000"
    }, r = {};
    for(var d in a)r[a[d]] = d;
    var l = {};
    e.prototype.toName = function(f) {
        if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
        var d, i, o = r[this.toHex()];
        if (o) return o;
        if (null == f ? void 0 : f.closest) {
            var n = this.toRgb(), t = 1 / 0, b = "black";
            if (!l.length) for(var c in a)l[c] = new e(a[c]).toRgb();
            for(var g in a){
                var u = (d = n, i = l[g], Math.pow(d.r - i.r, 2) + Math.pow(d.g - i.g, 2) + Math.pow(d.b - i.b, 2));
                u < t && (t = u, b = g);
            }
            return b;
        }
    };
    f.string.push([
        function(f) {
            var r = f.toLowerCase(), d = "transparent" === r ? "#0000" : a[r];
            return d ? new e(d).toRgb() : null;
        },
        "name"
    ]);
};


var $e78277fc055447be$exports = {};
var $e78277fc055447be$var$t = function(t, a, n) {
    return void 0 === a && (a = 0), void 0 === n && (n = 1), t > n ? n : t > a ? t : a;
}, $e78277fc055447be$var$a = function(t) {
    var a = t / 255;
    return a < .04045 ? a / 12.92 : Math.pow((a + .055) / 1.055, 2.4);
}, $e78277fc055447be$var$n = function(t) {
    return 255 * (t > .0031308 ? 1.055 * Math.pow(t, 1 / 2.4) - .055 : 12.92 * t);
}, $e78277fc055447be$var$r = 96.422, $e78277fc055447be$var$o = 100, $e78277fc055447be$var$u = 82.521, $e78277fc055447be$var$e = function(a) {
    var r, o, u = {
        x: .9555766 * (r = a).x + -0.0230393 * r.y + .0631636 * r.z,
        y: -0.0282895 * r.x + 1.0099416 * r.y + .0210077 * r.z,
        z: .0122982 * r.x + -0.020483 * r.y + 1.3299098 * r.z
    };
    return o = {
        r: $e78277fc055447be$var$n(.032404542 * u.x - .015371385 * u.y - .004985314 * u.z),
        g: $e78277fc055447be$var$n(-0.00969266 * u.x + .018760108 * u.y + 41556e-8 * u.z),
        b: $e78277fc055447be$var$n(556434e-9 * u.x - .002040259 * u.y + .010572252 * u.z),
        a: a.a
    }, {
        r: $e78277fc055447be$var$t(o.r, 0, 255),
        g: $e78277fc055447be$var$t(o.g, 0, 255),
        b: $e78277fc055447be$var$t(o.b, 0, 255),
        a: $e78277fc055447be$var$t(o.a)
    };
}, $e78277fc055447be$var$i = function(n) {
    var e = $e78277fc055447be$var$a(n.r), i = $e78277fc055447be$var$a(n.g), p = $e78277fc055447be$var$a(n.b);
    return function(a) {
        return {
            x: $e78277fc055447be$var$t(a.x, 0, $e78277fc055447be$var$r),
            y: $e78277fc055447be$var$t(a.y, 0, $e78277fc055447be$var$o),
            z: $e78277fc055447be$var$t(a.z, 0, $e78277fc055447be$var$u),
            a: $e78277fc055447be$var$t(a.a)
        };
    }(function(t) {
        return {
            x: 1.0478112 * t.x + .0228866 * t.y + -0.050127 * t.z,
            y: .0295424 * t.x + .9904844 * t.y + -0.0170491 * t.z,
            z: -0.0092345 * t.x + .0150436 * t.y + .7521316 * t.z,
            a: t.a
        };
    }({
        x: 100 * (.4124564 * e + .3575761 * i + .1804375 * p),
        y: 100 * (.2126729 * e + .7151522 * i + .072175 * p),
        z: 100 * (.0193339 * e + .119192 * i + .9503041 * p),
        a: n.a
    }));
}, $e78277fc055447be$var$p = 216 / 24389, $e78277fc055447be$var$h = 24389 / 27, $e78277fc055447be$var$f = function(t) {
    var a = $e78277fc055447be$var$i(t), n = a.x / $e78277fc055447be$var$r, e = a.y / $e78277fc055447be$var$o, f = a.z / $e78277fc055447be$var$u;
    return n = n > $e78277fc055447be$var$p ? Math.cbrt(n) : ($e78277fc055447be$var$h * n + 16) / 116, {
        l: 116 * (e = e > $e78277fc055447be$var$p ? Math.cbrt(e) : ($e78277fc055447be$var$h * e + 16) / 116) - 16,
        a: 500 * (n - e),
        b: 200 * (e - (f = f > $e78277fc055447be$var$p ? Math.cbrt(f) : ($e78277fc055447be$var$h * f + 16) / 116)),
        alpha: a.a
    };
}, $e78277fc055447be$var$c = function(a, n, i) {
    var c, y = $e78277fc055447be$var$f(a), x = $e78277fc055447be$var$f(n);
    return function(t) {
        var a = (t.l + 16) / 116, n = t.a / 500 + a, i = a - t.b / 200;
        return $e78277fc055447be$var$e({
            x: (Math.pow(n, 3) > $e78277fc055447be$var$p ? Math.pow(n, 3) : (116 * n - 16) / $e78277fc055447be$var$h) * $e78277fc055447be$var$r,
            y: (t.l > 8 ? Math.pow((t.l + 16) / 116, 3) : t.l / $e78277fc055447be$var$h) * $e78277fc055447be$var$o,
            z: (Math.pow(i, 3) > $e78277fc055447be$var$p ? Math.pow(i, 3) : (116 * i - 16) / $e78277fc055447be$var$h) * $e78277fc055447be$var$u,
            a: t.alpha
        });
    }({
        l: $e78277fc055447be$var$t((c = {
            l: y.l * (1 - i) + x.l * i,
            a: y.a * (1 - i) + x.a * i,
            b: y.b * (1 - i) + x.b * i,
            alpha: y.alpha * (1 - i) + x.alpha * i
        }).l, 0, 400),
        a: c.a,
        b: c.b,
        alpha: $e78277fc055447be$var$t(c.alpha)
    });
};
$e78277fc055447be$exports = function(t) {
    function a(t, a, n) {
        void 0 === n && (n = 5);
        for(var r = [], o = 1 / (n - 1), u = 0; u <= n - 1; u++)r.push(t.mix(a, o * u));
        return r;
    }
    t.prototype.mix = function(a, n) {
        void 0 === n && (n = .5);
        var r = a instanceof t ? a : new t(a), o = $e78277fc055447be$var$c(this.toRgb(), r.toRgb(), n);
        return new t(o);
    }, t.prototype.tints = function(t) {
        return a(this, "#fff", t);
    }, t.prototype.shades = function(t) {
        return a(this, "#000", t);
    }, t.prototype.tones = function(t) {
        return a(this, "#808080", t);
    };
};



(0, $00fdc0fdfd66324b$export$8b58be045bf06082)([
    (0, (/*@__PURE__*/$parcel$interopDefault($4d140387fb4c3902$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($e78277fc055447be$exports)))
]);
/**
 * @module Color
 */ const $f69eec5534190452$var$parsedKey = Symbol("_parsed");
class $f69eec5534190452$export$2e2bcd8739ae039 {
    /**
     * @typedef {Color|String|Number|Array<Number>} ColorDefinition
     */ /**
     * Color constructor
     * @param {ColorDefinition} colorDefinition - Many types accepted (other Color instance, color name, hex string, hex number, red/green/blue/alpha value)
     * @example
     * new Color("indigo"); // Any valid CSS color name
     * new Color("#123456"); // Hex string definition
     * new Color("#123"); // Hex shorthand string definition, #123 <=> #112233
     * new Color(0x123456); // Hex number definition
     * new Color(0.1, 0.2, 0.3); // Red, Green, Blue definition
     * Every definition can have one more optional parameter for alpha (opacity)
     * new Color("violet", 0.5);
     */ constructor(...colorDefinition){
        this[$f69eec5534190452$var$parsedKey] = null;
        this.set(...colorDefinition);
    }
    /**
     * Create a new copy of this color
     * @return {Color}
     */ clone() {
        return new $f69eec5534190452$export$2e2bcd8739ae039(this);
    }
    /**
     * Get the red channel value
     * @return {Number}
     */ get red() {
        return this[$f69eec5534190452$var$parsedKey].rgba.r / 255;
    }
    /**
     * Set the red channel
     * @param {Number} value - New value
     */ set red(value) {
        this[$f69eec5534190452$var$parsedKey].rgba.r = (0, $26d060ef72148247$export$c4e2ecac49351ef2)(value * 255, 0, 255);
    }
    /**
     * Get the green channel value
     * @return {Number}
     */ get green() {
        return this[$f69eec5534190452$var$parsedKey].rgba.g / 255;
    }
    /**
     * Set the green channel
     * @param {Number} value - New value
     */ set green(value) {
        this[$f69eec5534190452$var$parsedKey].rgba.g = (0, $26d060ef72148247$export$c4e2ecac49351ef2)(value * 255, 0, 255);
    }
    /**
     * Get the blue channel value
     * @return {Number}
     */ get blue() {
        return this[$f69eec5534190452$var$parsedKey].rgba.b / 255;
    }
    /**
     * Set the blue channel
     * @param {Number} value - New value
     */ set blue(value) {
        this[$f69eec5534190452$var$parsedKey].rgba.b = (0, $26d060ef72148247$export$c4e2ecac49351ef2)(value * 255, 0, 255);
    }
    /**
     * Get the transparency channel value
     * @return {Number}
     */ get alpha() {
        return this[$f69eec5534190452$var$parsedKey].rgba.a;
    }
    /**
     * Set the transparency channel
     * @param {Number} value - New value
     */ set alpha(value) {
        this[$f69eec5534190452$var$parsedKey].rgba.a = (0, $26d060ef72148247$export$c4e2ecac49351ef2)(value, 0, 1);
    }
    /**
     * Return an array with red, green and blue value
     * @example [0.1, 0.2, 0.3]
     * @return {Array<Number>}
     */ get array() {
        return [
            this.red,
            this.green,
            this.blue
        ];
    }
    /**
     * Return hexadecimal rgb notation
     * @example "#123456"
     * @return {String}
     */ get hex() {
        return this[$f69eec5534190452$var$parsedKey].toHex();
    }
    /**
     * Return hexadecimal rgb notation
     * @example "#123456"
     * @return {String}
     */ get rgb() {
        return this.hex;
    }
    /**
     * Return the closest CSS color name
     * @example "aliceblue"
     * @return {String}
     */ get name() {
        return this[$f69eec5534190452$var$parsedKey].toName({
            closest: true
        });
    }
    // TODO: do we need more getters ? User only need to interact with Color, not read values.
    /**
     * Change this values
     * @param {ColorDefinition} colorDefinition - Any supported color definition (see constructor)
     * @return {Color} Itself
     */ set(...colorDefinition) {
        const [first] = colorDefinition;
        let input;
        let alpha;
        if (first instanceof $f69eec5534190452$export$2e2bcd8739ae039) {
            input = first[$f69eec5534190452$var$parsedKey].rgba;
            [, alpha = input.a] = colorDefinition;
        } else if (typeof first === "string") {
            input = first;
            [, alpha = 1] = colorDefinition;
        } else if (first === undefined || first === null) {
            input = "#000";
            alpha = 1;
        } else if (colorDefinition.length < 3) {
            input = `#${(0, $26d060ef72148247$export$6a506b36fdea397d)(colorDefinition[0]).toString(16)}`;
            [, alpha = 1] = colorDefinition;
        } else {
            const [r, g, b] = colorDefinition.slice(0, 3).map((value)=>value * 255);
            [, , , alpha = 1] = colorDefinition;
            input = {
                r: r,
                g: g,
                b: b
            };
        }
        this[$f69eec5534190452$var$parsedKey] = (0, $00fdc0fdfd66324b$export$c8efe09109f9cb9e)(input).alpha(alpha);
        return this;
    }
    /**
     * Change to its greyscale value
     * @return {Color} Itself
     */ grey() {
        this[$f69eec5534190452$var$parsedKey] = this[$f69eec5534190452$var$parsedKey].grayscale();
        return this;
    }
    /**
     * Change hue value (0 = red, 0.5 = blue, 1 = red, 1.5 = blue ...)
     * @param {Number} value - Any value between 0 and 1
     * @return {Color} Itself
     */ hue(value) {
        this[$f69eec5534190452$var$parsedKey] = this[$f69eec5534190452$var$parsedKey].hue(value * (0, $26d060ef72148247$export$47d0a01eedb6cd22));
        return this;
    }
    /**
     * Change saturation value (0 = grey, 1 = pure color)
     * @param {Number} value - Any value between 0 and 1
     * @return {Color} Itself
     */ saturation(value) {
        const hsl = this[$f69eec5534190452$var$parsedKey].toHsl();
        hsl.s = value * 100;
        this[$f69eec5534190452$var$parsedKey] = (0, $00fdc0fdfd66324b$export$c8efe09109f9cb9e)(hsl);
        return this;
    }
    /**
     * Change lightness value (0 = black, 0.5 = pure color, 1 = white)
     * @param {Number} value - Any value between 0 and 1
     * @return {Color} Itself
     */ lightness(value) {
        const hsl = this[$f69eec5534190452$var$parsedKey].toHsl();
        hsl.l = value * 100;
        this[$f69eec5534190452$var$parsedKey] = (0, $00fdc0fdfd66324b$export$c8efe09109f9cb9e)(hsl);
        return this;
    }
    /**
     * Invert the color value
     * @return {Color} Itself
     */ reverse() {
        this[$f69eec5534190452$var$parsedKey] = this[$f69eec5534190452$var$parsedKey].invert();
        return this;
    }
    /**
     * Restrict the color space to an amount of possible value
     * @param {Number} number - Number of allowed value
     * @return {Color} Itself
     */ level(number) {
        const { r: r, g: g, b: b } = this[$f69eec5534190452$var$parsedKey].rgba;
        const p = 255 / number;
        this[$f69eec5534190452$var$parsedKey].rgba.r = (0, $26d060ef72148247$export$6a506b36fdea397d)(r / p) * p + p / 2;
        this[$f69eec5534190452$var$parsedKey].rgba.g = (0, $26d060ef72148247$export$6a506b36fdea397d)(g / p) * p + p / 2;
        this[$f69eec5534190452$var$parsedKey].rgba.b = (0, $26d060ef72148247$export$6a506b36fdea397d)(b / p) * p + p / 2;
        return this;
    }
    /**
     * Change the color toward another color
     * @param {ColorDefinition} colorDefinition - Any other color
     * @param {Number} ratio - Ratio of distance to move (0 = no change, 0.5 = equal mix, 1 = same as target color)
     * @return {Color} Itself
     */ lerp(colorDefinition, ratio) {
        const color = $f69eec5534190452$export$2e2bcd8739ae039.from(colorDefinition);
        this[$f69eec5534190452$var$parsedKey] = this[$f69eec5534190452$var$parsedKey].mix(color[$f69eec5534190452$var$parsedKey], ratio);
        return this;
    }
    /**
     * @return {String}
     */ toString() {
        return this.hex;
    }
    /**
     * Return a json ready array
     * @return {Array<Number>}
     */ toJSON() {
        return [
            ...this.array,
            this.alpha
        ];
    }
    /**
     * Return an instance from a generic definition
     * @param {ColorDefinition} colorDefinition - Any valid color definition (see constructor)
     * @return {Color}
     */ static from(...colorDefinition) {
        const param = colorDefinition[0];
        if (param instanceof $f69eec5534190452$export$2e2bcd8739ae039) return param;
        return new $f69eec5534190452$export$2e2bcd8739ae039(...colorDefinition);
    }
}
$f69eec5534190452$export$2e2bcd8739ae039.prototype.gray = $f69eec5534190452$export$2e2bcd8739ae039.prototype.grey;
$f69eec5534190452$export$2e2bcd8739ae039.prototype.mix = $f69eec5534190452$export$2e2bcd8739ae039.prototype.lerp;



class $96c9ad69e5873844$export$2e2bcd8739ae039 {
    /**
     * Linear-gradient constructor
     * @param {PositionDefinition} fromPosition - Starting position of the gradient
     * @param {PositionDefinition} toPosition - Ending position of the gradient
     * @param {Object} colorStops - Set of colors to go through (key is position [from 0 to 1], value is the color)
     * @example new LinearGradient(from, to, { 0: "red", 1: "green" });
     */ constructor(fromPosition, toPosition, colorStops){
        this.from = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(fromPosition);
        this.to = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(toPosition);
        this.colorStops = colorStops;
    }
    /**
     * Return a drawing context compatible gradient
     * @param {CanvasRenderingContext2D} ctx - Drawing context
     * @return {CanvasGradient}
     */ toString(ctx) {
        const from = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(this.from);
        const to = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(this.to);
        const gradient = ctx.createLinearGradient(from.x, from.y, to.x, to.y);
        Object.keys(this.colorStops).forEach((key)=>gradient.addColorStop(key, this.colorStops[key].toString()));
        return gradient;
    }
}



class $f299e79e5e44b044$export$2e2bcd8739ae039 {
    /**
     * Radial-gradient constructor
     * @param {PositionDefinition} positionDefinition - Center of the gradient
     * @param {Number} radius - Radius of the gradient
     * @param {Object} colorStops - Set of colors to go through (key is position [from 0 to 1], value is the color)
     * @example new RadialGradient(from, radius, { 0: "red", 1: "green" });
     */ constructor(positionDefinition, radius, colorStops){
        this.position = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(positionDefinition);
        this.radius = radius;
        this.colorStops = colorStops;
    }
    /**
     * Return a drawing context compatible gradient
     * @param {CanvasRenderingContext2D} ctx - Drawing context
     * @return {CanvasGradient}
     */ toString(ctx) {
        const from = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(this.position);
        const gradient = ctx.createRadialGradient(from.x, from.y, 0, from.x, from.y, this.radius);
        Object.keys(this.colorStops).forEach((key)=>gradient.addColorStop(key, this.colorStops[key].toString()));
        return gradient;
    }
}




class $cae15293d24a770e$export$2e2bcd8739ae039 {
    /**
     * Conic-gradient constructor
     * @param {PositionDefinition} positionDefinition - Center of the gradient
     * @param {Number} startAngle - Starting angle (0 is top, 0.5 is bottom and 1 is full circle back to top)
     * @param {Object} colorStops - Set of colors to go through (key is position [from 0 to 1], value is the color)
     * @example new ConicGradient(center, 0, { 0: "red", 0.25: "orange", 0.5: "yellow", 0.75: "green", 1: "blue" });
     */ constructor(positionDefinition, startAngle, colorStops){
        this.position = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(positionDefinition);
        this.startAngle = startAngle;
        this.colorStops = colorStops;
    }
    /**
     * Return a drawing context compatible gradient
     * @param {CanvasRenderingContext2D} ctx - Drawing context
     * @return {CanvasGradient}
     */ toString(ctx) {
        const from = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(this.position);
        const gradient = ctx.createConicGradient((this.startAngle - 0.25) * (0, $26d060ef72148247$export$10ec9ebfd343bc9a), from.x, from.y);
        Object.keys(this.colorStops).forEach((key)=>{
            gradient.addColorStop(Number(key), this.colorStops[key].toString());
        });
        return gradient;
    }
}






class $0fd58fd98fd800e4$export$2e2bcd8739ae039 extends (0, $38771a883d186a4e$export$2e2bcd8739ae039) {
    /**
     * Component constructor
     * @param {PositionDefinition} positionDefinition - Position in space
     * @param {ComponentOptions} [options] - Drawing options
     */ constructor(positionDefinition, options = {}){
        super(positionDefinition, options);
        /**
         * @type {Path2D}
         */ this.path = null;
        /**
         * @type {Boolean}
         */ this.isClicked = false;
        /**
         * @type {Boolean}
         */ this.isHovered = false;
    }
    /**
     * Return the relative origin position of draw
     * @return {Position}
     */ getOrigin() {
        return (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(this.options.origin);
    }
    /**
     * Define options for this component
     * @param {ComponentOptions} [options={}] - Options to override
     * @return {Component} Itself
     */ setOptions(options = {}) {
        const { shadow: shadow } = this.options;
        super.setOptions(options);
        if (typeof this.options.origin !== "string") this.options.origin = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(this.options.origin);
        this.options.shadow = {
            ...$0fd58fd98fd800e4$export$2e2bcd8739ae039.defaultOptions.shadow,
            ...shadow,
            ...options.shadow
        };
        this.options.shadow.position = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(this.options.shadow.position);
        return this;
    }
    /**
     * Tell if a component will need to be filled
     * @return {Boolean}
     */ get willFill() {
        return Boolean(this.options.fill);
    }
    /**
     * Tell if a component will need to be stroked
     * @return {*|boolean}
     */ get willStroke() {
        return Boolean(this.options.stroke) && this.options.strokeWidth > 0;
    }
    /**
     * @inheritDoc
     * @return {Component} Itself
     */ setContext(ctx) {
        super.setContext(ctx);
        if (this.options.shadow.color) {
            const shadowPosition = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(this.options.shadow.position);
            ctx.shadowColor = this.options.shadow.color.toString();
            ctx.shadowBlur = this.options.shadow.blur;
            ctx.shadowOffsetX = shadowPosition.x;
            ctx.shadowOffsetY = shadowPosition.y;
        } else {
            ctx.shadowBlur = 0;
            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = 0;
        }
        if (this.willFill) ctx.fillStyle = this.options.fill.toString(ctx);
        if (this.willStroke) {
            ctx.lineJoin = this.options.join;
            ctx.lineCap = this.options.cap;
            ctx.strokeStyle = this.options.stroke.toString(ctx);
            ctx.lineWidth = this.options.strokeWidth;
            if (this.options.dashed) {
                const { dashed: dashed, strokeWidth: strokeWidth } = this.options;
                const pattern = Array.isArray(dashed) ? dashed : $0fd58fd98fd800e4$export$2e2bcd8739ae039.dashes.default;
                ctx.setLineDash(pattern.map((v)=>v * strokeWidth));
            } else ctx.setLineDash([]);
        }
        return this;
    }
    /**
     * Make the path and trace it
     * @param {CanvasRenderingContext2D} ctx - Drawing context
     * @return {Component} Itself
     */ makePath(ctx) {
        if (this.willFill || this.willStroke) {
            const origin = this.getOrigin();
            ctx.translate(origin.x, origin.y);
            this.path = new window.Path2D();
            this.trace(this.path);
            if (this.willFill) ctx.fill(this.path);
            if (this.willStroke) ctx.stroke(this.path);
            ctx.translate(-origin.x, -origin.y);
        }
        return this;
    }
    /**
     * Every component should have a trace function
     * @throws {ReferenceError}
     */ trace() {
        throw new ReferenceError(`Unimplemented [trace] function in ${this.constructor.name}.`);
    }
    /**
     * Define if is hover a position
     * @param {PositionDefinition} positionDefinition - Any position
     * @param {CanvasRenderingContext2D} [ctx] - Context use for calculation
     * @return {Boolean}
     */ isHover(positionDefinition, ctx = (0, $254037bcf672ea5f$export$2e2bcd8739ae039).getDrawingContext()) {
        if (!this.options.shown) return false;
        ctx.save();
        const position = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(positionDefinition);
        const origin = this.getOrigin();
        ctx.translate(origin.x, origin.y);
        if (!this.willFill && !this.willStroke) {
            ctx.restore();
            return false;
        }
        if (!this.path) {
            this.path = new window.Path2D();
            this.trace(this.path);
        }
        let result = this.willFill && ctx.isPointInPath(this.path, position.x, position.y) || this.willStroke && ctx.isPointInStroke(this.path, position.x, position.y);
        if (this.options.clip) result = result && this.options.clip.isHover(position, ctx);
        ctx.restore();
        return result;
    }
    /**
     * @typedef {Object} ShadowOptions
     * @prop {Number} [blur=0] - Spread of the shadow around the component
     * @prop {PositionDefinition} [position=new Position()] - Position of the shadow relative to the component
     * @prop {String|ColorDefinition} [color=null] - Color of the shadow
     */ /**
     * @typedef {Object} ComponentOptions
     * @extends ContainerOptions
     * @prop {String|ColorDefinition} [fill="#000"] - Color used to fill, set to null for transparent
     * @prop {String|ColorDefinition} [stroke=null] - Color used to stroke, set to null for transparent
     * @prop {Number} [strokeWidth=2] - Stroke line thickness in pixels
     * @prop {Boolean|Array} [dashed=false] - Should the line be dashed, you can also specify the dash pattern (ex: [4, 4] or Component.dashes.dots)
     * @prop {String} [cursor=Component.cursors.default] - Cursor to use when hover
     * @prop {String} [join=Component.joins.miter] - How lines join between them
     * @prop {PositionDefinition} [origin=new Position()] - Relative offset
     * @prop {ShadowOptions} [shadow] - Set of options to set a shadow
     */ /**
     * @type {ComponentOptions}
     */ static get defaultOptions() {
        return {
            ...super.defaultOptions,
            fill: "#000",
            stroke: null,
            strokeWidth: 2,
            dashed: false,
            cursor: $0fd58fd98fd800e4$export$2e2bcd8739ae039.cursors.default,
            join: $0fd58fd98fd800e4$export$2e2bcd8739ae039.joins.miter,
            origin: new (0, $ce200116bfeffd8f$export$2e2bcd8739ae039)(),
            shadow: {
                blur: 0,
                position: new (0, $ce200116bfeffd8f$export$2e2bcd8739ae039)(),
                color: null
            }
        };
    }
    /**
     * @typedef {Object} Cursors
     * @prop {String} default - Normal behavior
     * @prop {String} none - No visible cursor
     * @prop {String} contextMenu - Possible to extends context-menu
     * @prop {String} help - Display help
     * @prop {String} pointer - Can be clicked
     * @prop {String} progress - Process running in background
     * @prop {String} wait - Process running in foreground
     * @prop {String} cell - Table cell selection
     * @prop {String} crosshair - Precise selection
     * @prop {String} text - Text selection
     * @prop {String} textVertical - Vertical test selection
     * @prop {String} alias - Can create a shortcut
     * @prop {String} copy - Can be copied
     * @prop {String} move - Move around
     * @prop {String} noDrop - Drop not allowed
     * @prop {String} notAllowed - Action not allowed
     * @prop {String} grab - Can be grabbed
     * @prop {String} grabbing - Currently grabbing
     * @prop {String} allScroll - Scroll in all direction
     * @prop {String} colResize - Horizontal resize
     * @prop {String} rowResize - Vertical resize
     * @prop {String} nResize - Resize the north border
     * @prop {String} eResize - Resize the east border
     * @prop {String} sResize - Resize the south border
     * @prop {String} wResize - Resize the west border
     * @prop {String} neResize - Resize the north-east corner
     * @prop {String} seResize - Resize the south-east corner
     * @prop {String} swResize - Resize the north-west corner
     * @prop {String} nwResize - Resize the north-west corner
     * @prop {String} ewResize - Horizontal resize
     * @prop {String} nsResize - Vertical resize
     * @prop {String} neswResize - Diagonal resize (top-right to bottom-left)
     * @prop {String} nwseResize - Diagonal resize (top-left to bottom-right)
     * @prop {String} zoomIn - Zoom in
     * @prop {String} zoomOut - Zoom out
     * @prop {String} link - Alias for "alias"
     * @prop {String} verticalResize - Alias for "rowResize"
     * @prop {String} horizontalResize - Alias for "colResize"
     * @prop {String} topResize - Alias for "nResize"
     * @prop {String} rightResize - Alias for "eResize"
     * @prop {String} bottomResize - Alias for "sResize"
     * @prop {String} leftResize - Alias for "wResize"
     */ /**
     * All available cursors
     * {@link https://www.w3.org/TR/2017/WD-css-ui-4-20171222/#cursor}
     * @type {Cursors}
     */ static get cursors() {
        const cursors = {
            default: "default",
            none: "none",
            contextMenu: "context-menu",
            help: "help",
            pointer: "pointer",
            progress: "progress",
            wait: "wait",
            cell: "cell",
            crosshair: "crosshair",
            text: "text",
            textVertical: "vertical-text",
            alias: "alias",
            copy: "copy",
            move: "move",
            noDrop: "no-drop",
            notAllowed: "not-allowed",
            grab: "grab",
            grabbing: "grabbing",
            allScroll: "all-scroll",
            colResize: "col-resize",
            rowResize: "row-resize",
            nResize: "n-resize",
            eResize: "e-resize",
            sResize: "s-resize",
            wResize: "w-resize",
            neResize: "ne-resize",
            seResize: "se-resize",
            swResize: "sw-resize",
            nwResize: "nw-resize",
            ewResize: "ew-resize",
            nsResize: "ns-resize",
            neswResize: "nesw-resize",
            nwseResize: "nwse-resize",
            zoomIn: "zoom-in",
            zoomOut: "zoom-out"
        };
        // Aliases
        cursors.link = cursors.alias;
        cursors.verticalResize = cursors.rowResize;
        cursors.horizontalResize = cursors.colResize;
        cursors.topResize = cursors.nResize;
        cursors.rightResize = cursors.eResize;
        cursors.bottomResize = cursors.sResize;
        cursors.leftResize = cursors.wResize;
        return cursors;
    }
    /**
     * @typedef {Object} LineJoins
     * @prop {String} miter - Join segment by extending the line edges until they meet
     * @prop {String} round - Join with a circle tangent to line edges
     * @prop {String} bevel - Join with a straight line between the line edges
     */ /**
     * @type {LineJoins}
     */ static get joins() {
        return {
            miter: "miter",
            round: "round",
            bevel: "bevel"
        };
    }
    /**
     * @typedef {Object} DashPatterns
     * @prop {Array<Number>} default - Simple dash
     * @prop {Array<Number>} dots - Simple dots
     * @prop {Array<Number>} long - Longer dash
     * @prop {Array<Number>} sewing - Alternating pattern of short and long dash
     */ /**
     * @type {DashPatterns}
     */ static get dashes() {
        const pattern = {
            default: [
                4,
                4
            ],
            dots: [
                1,
                4
            ],
            long: [
                9,
                4
            ]
        };
        pattern.sewing = [
            ...pattern.default,
            ...pattern.dots
        ];
        return pattern;
    }
}



class $b5f43a4eeef4cb6f$export$2e2bcd8739ae039 extends (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039) {
    /**
     * Rectangle constructor
     * @param {PositionDefinition} positionDefinition - Position in space
     * @param {Number} [width=0] - Horizontal size
     * @param {Number} [height=0] - Vertical size
     * @param {RectangleOptions} [options] - Drawing options
     */ constructor(positionDefinition, width = 0, height = 0, options){
        super(positionDefinition, options);
        /**
         * @type {Number}
         */ this.width = width;
        /**
         * @type {Number}
         */ this.height = height;
    }
    /**
     * Draw the rectangle
     * @param {path} path - Drawing context
     * @return {Rectangle} Itself
     */ trace(path) {
        const { rounded: rounded } = this.options;
        if (rounded) path.roundRect(0, 0, this.width, this.height, ...Array.isArray(rounded) ? rounded : [
            rounded
        ]);
        else path.rect(0, 0, this.width, this.height);
        return this;
    }
    /**
     * @inheritDoc
     */ getOrigin() {
        const { origin: origin } = this.options;
        if (typeof origin === "string") {
            const { origins: origins } = $b5f43a4eeef4cb6f$export$2e2bcd8739ae039;
            const position = new (0, $ce200116bfeffd8f$export$2e2bcd8739ae039)();
            // Horizontal
            if ([
                origins.topRight,
                origins.centerRight,
                origins.bottomRight
            ].includes(origin)) position.x = -this.width;
            else if ([
                origins.topCenter,
                origins.center,
                origins.bottomCenter
            ].includes(origin)) position.x = -this.width / 2;
            // Vertical
            if ([
                origins.bottomLeft,
                origins.bottomCenter,
                origins.bottomRight
            ].includes(origin)) position.y = -this.height;
            else if ([
                origins.centerLeft,
                origins.center,
                origins.centerRight
            ].includes(origin)) position.y = -this.height / 2;
            return position;
        }
        return super.getOrigin();
    }
    /**
     * @inheritDoc
     */ toJSON() {
        const { width: width, height: height } = this;
        return {
            ...super.toJSON(),
            width: width,
            height: height
        };
    }
    /**
     * @inheritDoc
     * @param {Object} definition - Rectangle definition
     * @return {Rectangle}
     */ static from(definition) {
        return new $b5f43a4eeef4cb6f$export$2e2bcd8739ae039(definition.position, definition.width, definition.height, definition.options);
    }
    /**
     * @typedef {Object} RectangleOptions
     * @extends ComponentOptions
     * @prop {Number|Array<Number>} rounded - Corner radius or an array of radii [top-left, top-right, bottom-right, bottom-left]
     */ /**
     * @type {RectangleOptions}
     */ static get defaultOptions() {
        return {
            ...super.defaultOptions,
            rounded: 0
        };
    }
    /**
     * @typedef {Object} RectangleOrigins
     * @prop {String} topLeft
     * @prop {String} topRight
     * @prop {String} topCenter
     * @prop {String} center
     * @prop {String} centerLeft
     * @prop {String} centerRight
     * @prop {String} bottomLeft
     * @prop {String} bottomRight
     * @prop {String} bottomCenter
     */ /**
     * @type {RectangleOrigins}
     */ static get origins() {
        return {
            topLeft: "topLeft",
            topRight: "topRight",
            topCenter: "topCenter",
            center: "center",
            centerLeft: "centerLeft",
            centerRight: "centerRight",
            bottomLeft: "bottomLeft",
            bottomRight: "bottomRight",
            bottomCenter: "bottomCenter"
        };
    }
}




class $1a62a1afb6cf7c06$export$2e2bcd8739ae039 extends (0, $1aed883b78728e08$export$2e2bcd8739ae039) {
    /**
     * @typedef {Object} NetworkEvents
     * @prop {String} ready - Content has been loaded
     * @prop {String} error - Content load has fail
     */ /**
     * @type {NetworkEvents}
     */ static get events() {
        return {
            ready: "ready",
            error: "error"
        };
    }
}



/**
 * @module Image
 */ const $b61520fd682d0ff5$var$urlKey = Symbol("_url");
const $b61520fd682d0ff5$var$offscreenKey = Symbol("_offscreen");
class $b61520fd682d0ff5$export$2e2bcd8739ae039 extends (0, $b5f43a4eeef4cb6f$export$2e2bcd8739ae039) {
    /**
     * Image constructor
     * @param {PositionDefinition} positionDefinition - Top-left corner of the image
     * @param {String|Image|HTMLImageElement} source - Link to an image file, another Image instance or the image file itself
     * @param {ComponentOptions} [options] - Drawing options
     */ constructor(positionDefinition, source, options){
        super(positionDefinition, undefined, undefined, options);
        /**
         * @type {HTMLImageElement}
         */ this.file = null;
        /**
         * @type {Boolean}
         */ this.isLoaded = false;
        /**
         * @type {String}
         * @private
         */ this[$b61520fd682d0ff5$var$urlKey] = null;
        /**
         * @type {{ tint: String, cache: OffScreenCanvas }}
         * @private
         */ this[$b61520fd682d0ff5$var$offscreenKey] = {};
        this.url = source;
    }
    /**
     * Change the image URL
     * @param {String|Image|HTMLImageElement} source - Link to an image file, another Image instance or the image file itself
     */ set url(source) {
        if (this.url === source) return;
        this.file = null;
        this.isLoaded = false;
        this[$b61520fd682d0ff5$var$urlKey] = source;
        if (source) {
            const done = (img)=>{
                this[$b61520fd682d0ff5$var$urlKey] = img.src;
                this.file = img;
                this.isLoaded = true;
                this.width = img.width;
                this.height = img.height;
                this.fire(new (0, $1a62a1afb6cf7c06$export$2e2bcd8739ae039)((0, $1a62a1afb6cf7c06$export$2e2bcd8739ae039).events.ready, this));
            };
            if (source instanceof window.HTMLImageElement) done(source);
            else if (source instanceof $b61520fd682d0ff5$export$2e2bcd8739ae039) {
                if (source.isLoaded) done(source.file);
                else source.on((0, $1a62a1afb6cf7c06$export$2e2bcd8739ae039).events.ready, ()=>done(source.file));
            } else $b61520fd682d0ff5$export$2e2bcd8739ae039.load(source).then(done).catch(()=>{
                this.fire(new (0, $1a62a1afb6cf7c06$export$2e2bcd8739ae039)((0, $1a62a1afb6cf7c06$export$2e2bcd8739ae039).events.error, this));
            });
        }
    }
    /**
     * Get the image URL
     * @return {String}
     */ get url() {
        return this[$b61520fd682d0ff5$var$urlKey];
    }
    /**
     * Draw it on a context
     * @param {CanvasRenderingContext2D} ctx - Drawing context
     * @return {Image} Itself
     */ makePath(ctx) {
        if (this.isLoaded) {
            ctx.save();
            const origin = this.getOrigin();
            ctx.translate(origin.x, origin.y);
            const path = new window.Path2D();
            this.trace(path);
            this.path = path;
            if (this.willFill) {
                ctx.fill(path);
                ctx.shadowBlur = 0;
            }
            if (this.willStroke) ctx.stroke(path);
            this.draw(ctx);
            ctx.restore();
        }
        return this;
    }
    /**
     * Draw the image itself
     * @param {CanvasRenderingContext2D} ctx - Drawing context
     * @return {Image} Itself
     */ draw(ctx) {
        if (this.options.tint) {
            if (!this[$b61520fd682d0ff5$var$offscreenKey].cache) this[$b61520fd682d0ff5$var$offscreenKey].cache = (0, $254037bcf672ea5f$export$2e2bcd8739ae039).getDrawingContext(this.width, this.height);
            const { cache: cache } = this[$b61520fd682d0ff5$var$offscreenKey];
            const tintString = this.options.tint.toString();
            if (tintString !== this[$b61520fd682d0ff5$var$offscreenKey].tint) {
                cache.clearRect(0, 0, cache.canvas.width, cache.canvas.height);
                cache.drawImage(this.file, 0, 0);
                cache.globalCompositeOperation = "source-atop";
                cache.fillStyle = tintString;
                cache.fillRect(0, 0, cache.canvas.width, cache.canvas.height);
                this[$b61520fd682d0ff5$var$offscreenKey].tint = tintString;
            }
            ctx.drawImage(this[$b61520fd682d0ff5$var$offscreenKey].cache.canvas, 0, 0, this.width, this.height);
        } else ctx.drawImage(this.file, 0, 0, this.width, this.height);
        return this;
    }
    /**
     * @inheritDoc
     */ isHover(...args) {
        if (!this.isLoaded) return false;
        const previous = this.options.fill;
        this.options.fill = true;
        const result = super.isHover(...args);
        this.options.fill = previous;
        return result;
    }
    /**
     * @inheritDoc
     */ toJSON() {
        const json = super.toJSON();
        delete json.width;
        delete json.height;
        const { url: url } = this;
        return {
            ...json,
            url: url
        };
    }
    /**
     * @inheritDoc
     * @param {Object} definition - Image definition
     * @return {Image}
     */ static from(definition) {
        return new $b61520fd682d0ff5$export$2e2bcd8739ae039(definition.position, definition.url, definition.options);
    }
    /**
     * Promise to load an image file.
     * @param {String|Array<String>} url - Link or an array of links to image files
     * @return {Promise<HTMLImageElement>}
     */ static load(url) {
        if (Array.isArray(url)) return Promise.all(url.map((singleUrl)=>$b61520fd682d0ff5$export$2e2bcd8739ae039.load(singleUrl)));
        return new Promise((resolve, reject)=>{
            const img = window.document.createElement("img");
            img.crossOrigin = "Anonymous";
            img.src = url;
            img.addEventListener("load", ()=>resolve(img));
            img.addEventListener("error", ()=>reject(new URIError(`Fail to load ${url}.`)));
        });
    }
    /**
     * @typedef {Object} ImageOptions
     * @extends ComponentOptions
     * @prop {String|Color} [fill=null] - Color used as background
     * @prop {String|Color} [tint=null] - Multiply the image pixels with a color
     * @prop {String} [description=""] - Description of the image (can be used to for better accessibility)
     */ /**
     * @type {ImageOptions}
     */ static get defaultOptions() {
        return {
            ...super.defaultOptions,
            fill: null,
            tint: null,
            description: ""
        };
    }
}




/**
 * @module Pattern
 */ const $f720b88b21c518e1$var$sourceKey = Symbol("_source");
class $f720b88b21c518e1$export$2e2bcd8739ae039 {
    /**
     * Pattern constructor
     * @param {HTMLImageElement|Image|HTMLCanvasElement|OffScreenCanvas} source - Source of the pattern
     * @param {PatternOptions} options - Some options
     */ constructor(source, options){
        this.options = {
            ...$f720b88b21c518e1$export$2e2bcd8739ae039.defaultOptions,
            ...options
        };
        this.source = source;
    }
    /**
     * @return {HTMLImageElement}
     */ get source() {
        const source = this[$f720b88b21c518e1$var$sourceKey];
        if (source instanceof (0, $254037bcf672ea5f$export$2e2bcd8739ae039)) {
            if (!source.isLooped) source.render();
            return source.ctx.canvas;
        }
        return source;
    }
    /**
     * @param {HTMLImageElement|Image} newSource - New source for the pattern
     */ set source(newSource) {
        if (newSource instanceof window.HTMLImageElement || newSource instanceof window.HTMLCanvasElement || newSource instanceof (0, $254037bcf672ea5f$export$2e2bcd8739ae039)) this[$f720b88b21c518e1$var$sourceKey] = newSource;
        else if (newSource instanceof (0, $b61520fd682d0ff5$export$2e2bcd8739ae039)) {
            if (newSource.isLoaded) this[$f720b88b21c518e1$var$sourceKey] = newSource.file;
            else newSource.on((0, $1a62a1afb6cf7c06$export$2e2bcd8739ae039).events.ready, ()=>{
                this[$f720b88b21c518e1$var$sourceKey] = newSource.file;
            });
        } else if (newSource instanceof $f720b88b21c518e1$export$2e2bcd8739ae039) this[$f720b88b21c518e1$var$sourceKey] = newSource.source;
    }
    /**
     * @return {Number}
     */ get width() {
        return this[$f720b88b21c518e1$var$sourceKey].width;
    }
    /**
     * @return {Number}
     */ get height() {
        return this[$f720b88b21c518e1$var$sourceKey].height;
    }
    /**
     * Return the pattern object
     * @param {CanvasRenderingContext2D} ctx - Drawing context
     * @return {CanvasPattern}
     */ toString(ctx) {
        const { repeat: repeat, scale: scale } = this.options;
        const pattern = ctx.createPattern(this.source, repeat);
        const matrix = new window.DOMMatrix();
        if (typeof scale === "number") {
            matrix.a = scale;
            matrix.d = scale;
        } else {
            const s = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(scale);
            matrix.a = s.x;
            matrix.d = s.y;
        }
        const origin = (0, $b5f43a4eeef4cb6f$export$2e2bcd8739ae039).prototype.getOrigin.call(this);
        matrix.e = origin.x * matrix.a;
        matrix.f = origin.y * matrix.d;
        pattern.setTransform(matrix);
        return pattern;
    }
    // TODO: add toJSON and static from function
    /**
     * @typedef {Object} PatternOptions
     * @prop {String} [repeat=Pattern.repetition.repeat] - Repetition rule
     * @prop {PositionDefinition} [origin=new Position()] - Relative offset
     * @prop {Number|PositionDefinition} [scale=1] - Scaling ratio or a pair of value for horizontal and vertical scaling
     */ /**
     * @return {PatternOptions}
     */ static get defaultOptions() {
        return {
            repeat: this.repetition.repeat,
            origin: new (0, $ce200116bfeffd8f$export$2e2bcd8739ae039)(),
            scale: 1
        };
    }
    /**
     * @typedef {Object} PatternRepetitions
     * @prop {String} repeat -
     * @prop {String} x -
     * @prop {String} y -
     * @prop {String} none -
     */ /**
     * @return {PatternRepetitions}
     */ static get repetition() {
        return {
            repeat: "repeat",
            x: "repeat-x",
            y: "repeat-y",
            none: "no-repeat"
        };
    }
}


var $fb421388df2e4f8d$exports = {};

$parcel$export($fb421388df2e4f8d$exports, "getCurrentScene", () => $fb421388df2e4f8d$export$48842b4e092430a8);
$parcel$export($fb421388df2e4f8d$exports, "displayScene", () => $fb421388df2e4f8d$export$692e14a36eeba24c);
$parcel$export($fb421388df2e4f8d$exports, "back", () => $fb421388df2e4f8d$export$7c341cb16fc91138);
$parcel$export($fb421388df2e4f8d$exports, "prepareScenes", () => $fb421388df2e4f8d$export$79495df221db286c);



class $c9f089248e02e4ab$export$2e2bcd8739ae039 extends (0, $1aed883b78728e08$export$2e2bcd8739ae039) {
    /**
     * MouseEvent constructor
     * @param {String} name - Name of the event
     * @param {EventEmitter} target - Component concerned by the event
     * @param {UIEvent} [event] - Original HTML event
     * For the complete list of key values:
     * https://developer.mozilla.org/en/docs/Web/API/KeyboardEvent/key/Key_Values
     */ constructor(name, target, event){
        super(name, target, event);
        this.key = event.key;
    }
    /**
     * @inheritDoc
     */ getModifier() {
        return this.key;
    }
    /**
     * @typedef {Object} KeyboardEvents
     * @prop {String} down - Keyboard key pressed
     * @prop {String} up - Keyboard key released
     */ /**
     * Set of supported event name for easy access
     * @example component.on(KeyboardEvent.events.up, () => console.log("User release a key"));
     * @type {KeyboardEvents}
     */ static get events() {
        return {
            down: "keydown",
            up: "keyup"
        };
    }
    /**
     * @typedef {Object} ArrowKeys
     * @prop {String} up - Up arrow
     * @prop {String} right - Right arrow
     * @prop {String} down - Down arrow
     * @prop {String} left - Left arrow
     */ /**
     * @typedef {Object} KeyboardKeys
     * @prop {String} backspace - Remove last character or return previous screen
     * @prop {String} enter - Add line-break or validate entry
     * @prop {String} delete - Remove character in front
     * @prop {String} escape - Cancel or leave screen
     * @prop {String} control - Modifying key (control)
     * @prop {String} shift - Modifying key (uppercase)
     * @prop {String} fn - Modifying key (function)
     * @prop {ArrowKeys}
     * @prop {String} tab - Next input or toggle focus
     * @prop {String} alt - Modifying key (alternative)
     * @prop {String} altGr - Modifying key (alternative grapheme)
     * @prop {String} pageUp - Move up one page
     * @prop {String} pageDown - Move down one page
     * @prop {String} start - Go to start
     * @prop {String} end - Go to end
     * @prop {String} insert - Insert here or toggle insert mode
     */ /**
     * Set of keys for easy access
     * @example if (key === KeyboardEvent.keys.enter) {
     *     console.log("This is the enter key");
     * }
     * @type {KeyboardKeys}
     */ static get keys() {
        return {
            backspace: "Backspace",
            enter: "Enter",
            delete: "Delete",
            escape: "Escape",
            control: "Control",
            shift: "Shift",
            fn: "Fn",
            arrows: {
                up: "ArrowUp",
                right: "ArrowRight",
                down: "ArrowDown",
                left: "ArrowLeft"
            },
            tab: "Tab",
            alt: "Alt",
            altGr: "AltGraph",
            pageUp: "PageUp",
            pageDown: "PageDown",
            start: "Home",
            end: "End",
            insert: "Insert"
        };
    }
}




class $06750c2c311f70ee$export$2e2bcd8739ae039 extends (0, $1aed883b78728e08$export$2e2bcd8739ae039) {
    /**
     * MouseEvent constructor
     * @param {String} name - Name of the event
     * @param {EventEmitter} target - Component concerned by the event
     * @param {PositionDefinition} positionDefinition - Position of the mouse when event trigger
     * @param {UIEvent} [event] - Original HTML event
     */ constructor(name, target, positionDefinition, event){
        super(name, target, event);
        this.position = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(positionDefinition);
        this.button = event ? event.button : null;
    }
    /**
     * @inheritDoc
     */ getModifier() {
        return this.button;
    }
    /**
     * @typedef {Object} MouseButtons
     * @prop {String} left - Left button on a classic right-handed mouse
     * @prop {String} main - Main button
     * @prop {String} wheel - The scroll wheel
     * @prop {String} middle - Middle button, usually the scroll wheel
     * @prop {String} right - Right button on a classic right-handed mouse
     * @prop {String} secondary - Secondary button
     * @prop {String} backward - Browse backward button
     * @prop {String} aux1 - First auxiliary button, usually the browse backward button
     * @prop {String} forward - Browse forward button
     * @prop {String} aux2 - Second auxiliary button, usually the browse forward button
     */ /**
     * Set of buttons on a pointing device for easy access
     * @example scene.on(`${MouseEvent.events.down}.${MouseEvent.buttons.middle}`, () => {
     *     console.log("User pressed the middle mouse button");
     * });
     * @return {MouseButtons}
     */ static get buttons() {
        return {
            left: "0",
            main: "0",
            wheel: "1",
            middle: "1",
            right: "2",
            secondary: "2",
            backward: "3",
            aux1: "3",
            forward: "4",
            aux2: "4"
        };
    }
    /**
     * @typedef {Object} MouseEvents
     * @prop {String} down - Mouse button is pressed
     * @prop {String} up - Mouse button is released
     * @prop {String} click - Mouse button is pressed then released without moving
     * @prop {String} move - Mouse is moved
     * @prop {String} hover - Mouse goes hover a component
     * @prop {String} leave - Mouse leave a component
     * @prop {String} wheel - Mouse wheel is scrolled in any direction
     * @prop {String} scrollDown - Mouse wheel is scrolled down
     * @prop {String} scrollUp - Mouse wheel is scrolled up
     * @prop {String} zoomOut - Mouse wheel is scrolled down (away from the screen)
     * @prop {String} zoomIn - Mouse wheel is scrolled up (toward the screen)
     * @prop {String} grab - Mouse is clicked on a draggable component
     * @prop {String} drag - Mouse is moved while grabbing a component
     * @prop {String} drop - Mouse is release after dragging a component
     * @prop {String} resize - Mouse is moved while holding the handle of a resizable component
     * @prop {String} rotate - Mouse is rotating a component
     * @prop {String} doubleClick - Mouse is clicked twice rapidly
     */ /**
     * Set of events for easy access
     * @type {MouseEvents}
     */ static get events() {
        return {
            down: "mousedown",
            up: "mouseup",
            click: "click",
            contextMenu: "contextmenu",
            move: "mousemove",
            hover: "hover",
            leave: "leave",
            wheel: "mousewheel",
            scrollDown: "scrolldown",
            scrollUp: "scrollup",
            zoomOut: "zoomout",
            zoomIn: "zoomin",
            grab: "grab",
            drag: "drag",
            drop: "drop",
            resize: "resize",
            rotate: "rotate",
            doubleClick: "dblclick"
        };
    }
}



/**
 * @module Scene
 */ const $2f1bdb7a84694571$var$listenForEventsKey = Symbol("_listenForEvents");
class $2f1bdb7a84694571$export$2e2bcd8739ae039 extends (0, $254037bcf672ea5f$export$2e2bcd8739ae039) {
    /**
     * Scene constructor
     * @param {HTMLElement} [container=document.body] - Container of the renderer
     * @param {SceneOptions} [options] - Specific options
     */ constructor(container = window.document.body, options){
        if (container === window.document.body) {
            container.style.margin = 0;
            container.style.height = `${window.innerHeight}px`;
        }
        const measures = container.getBoundingClientRect();
        if (container instanceof window.HTMLCanvasElement) {
            super(null, 0, options);
            this.ctx = container.getContext("2d");
        } else {
            super(container, 0, options);
            container.appendChild(this.ctx.canvas);
        }
        /**
         * @type {Position}
         */ this.cursorPosition = new (0, $ce200116bfeffd8f$export$2e2bcd8739ae039)();
        /**
         * @type {Position}
         */ this.containerPosition = new (0, $ce200116bfeffd8f$export$2e2bcd8739ae039)(measures.left + window.scrollX, measures.top + window.scrollY);
        /**
         * @type {Boolean}
         */ this.isScene = true;
        /**
         * @type {Boolean}
         */ this.isLooped = false;
        /**
         * @type {Boolean}
         */ this.isClicked = false;
        /**
         * @type {Number}
         */ this.fps = 0;
        /**
         * @type {Number}
         */ this.lastTick = null;
        this[$2f1bdb7a84694571$var$listenForEventsKey](container);
    }
    /**
     *
     * @param {String} [cursor=Component.cursors.default] - Cursor string
     * @return {Scene} Itself
     */ setCursor(cursor = (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).cursors.default) {
        this.ctx.canvas.style.cursor = cursor;
        return this;
    }
    /**
     * Draw the whole scene
     * @return {Scene} Itself
     */ render() {
        const animationId = this.isLooped ? window.requestAnimationFrame(this.render.bind(this, undefined)) : null;
        try {
            super.render(this.ctx);
        } catch (error) {
            window.cancelAnimationFrame(animationId);
            this.stopLoop();
            throw error;
        }
        const now = window.performance.now();
        if (this.isLooped && this.lastTick) this.fps = 1000 / (now - this.lastTick);
        this.lastTick = now;
        return this;
    }
    /**
     * Define if is hovered
     * @return {Boolean}
     */ isHover() {
        return this.options.shown;
    }
    /**
     * Start to render the scene each frame
     * @return {Scene} Itself
     */ startLoop() {
        this.isLooped = true;
        this.render();
        return this;
    }
    /**
     * Stop scene from being rendered
     * @return {Scene} Itself
     */ stopLoop() {
        this.isLooped = false;
        this.fps = 0;
        return this;
    }
    /**
     * @inheritDoc
     * @return {Scene} Itself
     */ hide() {
        this.ctx.canvas.style.visibility = "hidden";
        return super.hide();
    }
    /**
     * @inheritDoc
     * @return {Scene} Itself
     */ show() {
        this.ctx.canvas.style.visibility = "";
        return super.show();
    }
    /**
     * @inheritDoc
     * @param {Object} definition - Scene definition
     * @return {Scene}
     */ static from(definition) {
        return new $2f1bdb7a84694571$export$2e2bcd8739ae039(undefined, definition.options);
    }
    /**
     * Build a canvas and set it to fill the entire document.body
     * @param {HTMLElement} [container=window.document.body] - Element holding the canvas
     * @inheritDoc
     */ static getDrawingContext(container = window.document.body) {
        if (container) {
            const { scrollWidth: scrollWidth, scrollHeight: scrollHeight } = container;
            const ctx = super.getDrawingContext(scrollWidth, scrollHeight);
            ctx.canvas.style.display = "block";
            ctx.canvas.style.position = "absolute";
            return ctx;
        }
        return null;
    }
    /**
     * @typedef {Object} SceneOptions
     * @extends OffscreenCanvasOptions
     * @prop {String} [cursor=Component.cursors.defaultOptions] - Cursor on hover
     */ /**
     * @type {SceneOptions}
     */ static get defaultOptions() {
        return {
            ...super.defaultOptions,
            cursor: (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).cursors.default
        };
    }
    /**
     * @typedef {Object} SceneEvents
     * @extends ContainerEvent
     * @prop {String} change -
     */ /**
     * @type {SceneEvents}
     */ static get events() {
        return {
            ...super.events,
            change: "change-scene"
        };
    }
}
/**
 * Bind events and call them on targets (can't be called twice)
 * @param {HTMLElement} container - Container to bind event to
 * @memberOf Scene#
 */ $2f1bdb7a84694571$export$2e2bcd8739ae039.prototype[$2f1bdb7a84694571$var$listenForEventsKey] = function listenForEvents(container) {
    if (this.isReady) throw new EvalError("Can't rebind event a second time.");
    let hovered = null;
    let startPosition = null;
    const mouseListeners = {
        [(0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.down]: (target, eventPosition)=>{
            target.isClicked = true;
            startPosition = eventPosition;
        },
        [(0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.move]: (target, eventPosition)=>{
            if (startPosition) target.isClicked = target.isClicked && eventPosition.distance(startPosition) < 10;
            if (target !== hovered) {
                if (hovered) {
                    hovered.isHovered = false;
                    if (!hovered.isAncestorOf(target)) hovered.fire(new (0, $06750c2c311f70ee$export$2e2bcd8739ae039)((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.leave, hovered, eventPosition));
                }
                hovered = target;
            }
            if (!target.isHovered) {
                target.isHovered = true;
                target.fire(new (0, $06750c2c311f70ee$export$2e2bcd8739ae039)((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.hover, target, eventPosition));
            }
            this.setCursor(target.options.cursor);
            this.cursorPosition.set(eventPosition);
        },
        [(0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.up]: (target, eventPosition, event)=>{
            startPosition = null;
            if (target.isClicked) {
                target.fire(new (0, $06750c2c311f70ee$export$2e2bcd8739ae039)((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.click, target, eventPosition, event));
                target.isClicked = false;
            }
        },
        [(0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.wheel]: (target, eventPosition, event)=>{
            const mouseEvents = (0, $06750c2c311f70ee$export$2e2bcd8739ae039).events;
            const events = event.deltaY > 0 ? [
                mouseEvents.scrollDown,
                mouseEvents.zoomOut
            ] : [
                mouseEvents.scrollUp,
                mouseEvents.zoomIn
            ];
            target.fire(new (0, $06750c2c311f70ee$export$2e2bcd8739ae039)(events[0], target, eventPosition, event)).fire(new (0, $06750c2c311f70ee$export$2e2bcd8739ae039)(events[1], target, eventPosition, event));
        },
        mouseout: (target, eventPosition, event)=>{
            target.fire(new (0, $06750c2c311f70ee$export$2e2bcd8739ae039)((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.leave, target, eventPosition, event));
        },
        mouseenter: (target, eventPosition, event)=>{
            target.fire(new (0, $06750c2c311f70ee$export$2e2bcd8739ae039)((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.hover, target, eventPosition, event));
        },
        [(0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.contextMenu]: null,
        [(0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.doubleClick]: null
    };
    Object.keys(mouseListeners).forEach((eventName)=>{
        container.addEventListener(eventName, (event)=>{
            if (this.options.shown) {
                const eventPosition = new (0, $ce200116bfeffd8f$export$2e2bcd8739ae039)(event.clientX, event.clientY).subtract(this.containerPosition).add(window.scrollX, window.scrollY);
                const target = this.getTarget(eventPosition, this.ctx);
                if (target) {
                    target.fire(new (0, $06750c2c311f70ee$export$2e2bcd8739ae039)(eventName, target, eventPosition, event));
                    if (mouseListeners[eventName] instanceof Function) mouseListeners[eventName](target, eventPosition, event);
                }
            }
        }, {
            passive: false
        });
    });
    const keyboardListener = {
        [(0, $c9f089248e02e4ab$export$2e2bcd8739ae039).events.down]: null,
        [(0, $c9f089248e02e4ab$export$2e2bcd8739ae039).events.up]: null
    };
    Object.keys(keyboardListener).forEach((eventName)=>{
        window.document.addEventListener(eventName, (event)=>{
            if (this.options.shown) {
                this.fire(new (0, $c9f089248e02e4ab$export$2e2bcd8739ae039)(eventName, this, event));
                if (keyboardListener[eventName] instanceof Function) keyboardListener[eventName](event);
            }
        });
    });
};


/**
 * @module Navigation
 */ let $fb421388df2e4f8d$var$currentScene = null;
const $fb421388df2e4f8d$var$history = [];
/**
 * Return the current scene
 * @return {Scene}
 */ const $fb421388df2e4f8d$export$48842b4e092430a8 = ()=>$fb421388df2e4f8d$var$currentScene;
/**
 * Hide the current scene and display a new scene
 * @param {Scene} scene - Any scene to show
 * @param {Boolean} [save=true] - Should it be saved in history
 * @return {Scene} Shown scene
 */ const $fb421388df2e4f8d$export$692e14a36eeba24c = (scene, save = true)=>{
    if ($fb421388df2e4f8d$var$currentScene) $fb421388df2e4f8d$var$currentScene.hide().stopLoop();
    if (save) $fb421388df2e4f8d$var$history.push($fb421388df2e4f8d$var$currentScene);
    scene.show().startLoop();
    $fb421388df2e4f8d$var$currentScene = scene;
    return scene;
};
/**
 * Go back in history
 * @return {Scene}
 */ const $fb421388df2e4f8d$export$7c341cb16fc91138 = ()=>$fb421388df2e4f8d$export$692e14a36eeba24c($fb421388df2e4f8d$var$history.pop(), false);
/**
 * Build all scene and display the first one
 * @param {Object<Function>} builders - Set of function building the scenes
 * @param {HTMLElement} [container] - Container for all the scenes
 * @return {Object<Scene>} Prepared scenes
 */ const $fb421388df2e4f8d$export$79495df221db286c = (builders, container = window.document.body)=>{
    let canvas = container;
    if (!(canvas instanceof window.HTMLCanvasElement)) {
        ({ canvas: canvas } = (0, $2f1bdb7a84694571$export$2e2bcd8739ae039).getDrawingContext(container));
        container.appendChild(canvas);
    }
    const scenesNames = Object.keys(builders);
    const scenes = {};
    scenesNames.forEach((sceneName)=>{
        const scene = new (0, $2f1bdb7a84694571$export$2e2bcd8739ae039)(canvas);
        builders[sceneName](scene);
        scenes[sceneName] = scene;
        scene.hide();
        scene.on((0, $2f1bdb7a84694571$export$2e2bcd8739ae039).events.change, (event)=>$fb421388df2e4f8d$export$692e14a36eeba24c(scenes[event.target]));
    });
    $fb421388df2e4f8d$export$692e14a36eeba24c(scenes[scenesNames[0]]);
    return scenes;
};













class $cd5768e945a9e13e$export$2e2bcd8739ae039 extends (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039) {
    /**
     * @callback OptionsGenerator
     * @param {Number} index - Index of the particle
     * @return ParticleData
     */ /**
     * @callback ParticlesCallback
     * @param {ParticleData} data - One particle data
     * @param {Number} index - Index of the particle
     * @param {...*} params - Additional parameters
     */ /**
     * Particles constructor
     * @param {PositionDefinition} positionDefinition - Origin for all particles
     * @param {Component} base - Blueprint for each particle
     * @param {OptionsGenerator} [generator] - Initialization function for all particles data
     * @param {ParticlesCallback} [updater] - Function called on each particle draw (should not be computation intensive)
     * @param {ParticleOptions} [options] -
     */ constructor(positionDefinition, base, generator, updater, options){
        super(positionDefinition, {
            ...base.options,
            ...options
        });
        this.base = base;
        this.generator = generator;
        this.updater = updater;
        this.data = [];
    }
    /**
     * Create new particles
     * @param {Number} number - Number of particles to generate
     * @param {...*} params - Additional parameters for the generator function
     * @return {Particles} Itself
     */ generate(number, ...params) {
        this.data = this.data.concat([
            ...new Array(number)
        ].map((_, index)=>{
            const data = {
                ...$cd5768e945a9e13e$export$2e2bcd8739ae039.defaultData,
                ...this.generator ? this.generator(index, ...params) : {}
            };
            data.position = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(data.position);
            return data;
        }));
        return this;
    }
    /**
     * @inheritDoc
     */ trace(path) {
        const basePath = new window.Path2D();
        this.base.trace(basePath);
        const matrix = new window.DOMMatrix();
        const { cos: cos, sin: sin } = Math;
        this.data = this.data.filter((data, index)=>{
            if (this.updater) this.updater(data, index);
            const { position: position, scale: scale = 1, rotation: rotation = 0, ttl: ttl } = data;
            const scaleOptions = typeof scale === "number" ? [
                scale,
                scale
            ] : (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(scale).toJSON();
            const rotationRadian = rotation * (0, $26d060ef72148247$export$10ec9ebfd343bc9a);
            matrix.a = cos(rotationRadian) * scaleOptions[0];
            matrix.b = sin(rotationRadian) * scaleOptions[0];
            matrix.c = -sin(rotationRadian) * scaleOptions[1];
            matrix.d = cos(rotationRadian) * scaleOptions[1];
            matrix.e = position.x;
            matrix.f = position.y;
            path.addPath(basePath, matrix);
            return !ttl || --data.ttl > 0;
        });
        if (this.options.emit && (0, $26d060ef72148247$export$4385e60b38654f68)() < this.options.frequency) {
            const nb = Array.isArray(this.options.emit) ? (0, $26d060ef72148247$export$4385e60b38654f68)(...this.options.emit) : this.options.emit;
            this.generate(Math.floor(nb), ...this.options.args);
        }
        return this;
    }
    /**
     * @inheritDoc
     */ isHover() {
        return false;
    }
    /**
     * @inheritDoc
     */ toJSON() {
        const { base: base, data: data } = this;
        return {
            ...super.toJSON(),
            base: base,
            data: data
        };
    }
    /**
     * @inheritDoc
     * @param {Object} definition - Particles definition
     * @return {Particles}
     */ static from(definition) {
        // FIXME
        const base = from(definition.base);
        const particles = new $cd5768e945a9e13e$export$2e2bcd8739ae039(definition.position, base, 0);
        particles.data = definition.data;
        return particles;
    }
    /**
     * @typedef {Object} ParticleOptions
     * @extends ComponentOptions
     * @prop {Number} [frequency=1] - Frequency of emission (randomized)
     * @prop {Number|Array<Number>} [emit] - Number or range of particles emitted
     * @prop {Array} [args] - Arguments passed to the generator function
     */ /**
     * @type {ParticleOptions}
     */ static get defaultOptions() {
        return {
            ...super.defaultOptions,
            frequency: 1,
            emit: null,
            args: []
        };
    }
    /**
     * @typedef {Object} ParticleData
     * @prop {Position} [position=new Position()] - Position of the particle
     * @prop {Number} [rotation=0] - Rotation applied to the particle
     * @prop {Number|Position} [scale=1] - Scaling ratio or a pair of value for horizontal and vertical scaling
     * @prop {Number} [ttl] - Time to live, number of frames the particle is displayed. This number will be decremented and the data removed when it reach 0
     */ /**
     * @type {ParticleData}
     */ static get defaultData() {
        return {
            position: new (0, $ce200116bfeffd8f$export$2e2bcd8739ae039)()
        };
    }
}





class $e90a03c16dccc7f7$export$2e2bcd8739ae039 extends (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039) {
    /**
     * Line constructor
     * @param {PositionDefinition} positionDefinition - First point
     * @param {Array<PositionDefinition>} points - List of points
     * @param {LineOptions} [options] - Drawing options
     */ constructor(positionDefinition, points, options){
        super(positionDefinition, options);
        /**
         * @type {Array<Position>}
         */ this.points = points.map((0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from);
    }
    /**
     * Draw the line
     * @param {Path2D} path - Drawing context
     * @return {Line} Itself
     */ trace(path) {
        path.moveTo(0, 0);
        const { x: x = 0, y: y = 0 } = this.options.absolute ? this.position : {};
        this.points.forEach((point)=>path.lineTo(point.x - x, point.y - y));
        return this;
    }
    /**
     * @inheritDoc
     */ toJSON() {
        const { points: points } = this;
        return {
            ...super.toJSON(),
            points: points
        };
    }
    /**
     * @inheritDoc
     * @param {Object} definition -Line definition
     * @return {Line}
     */ static from(definition) {
        return new $e90a03c16dccc7f7$export$2e2bcd8739ae039(definition.position, definition.points, definition.options);
    }
    /**
     * @typedef {Object} LineOptions
     * @extends ComponentOptions
     * @prop {String} [cap=Line.caps.round] - How the line end points looks
     * @prop {String} [join=Line.joins.round] - How the line segment are join
     * @prop {String|ColorDefinition} [fill=null] - Color used to fill, set to null for transparent
     * @prop {String|ColorDefinition} [stroke=Component.defaultOptions.fill] - Color used to stroke, set to null for transparent
     * @prop {Boolean} [absolute=false] - Should points be treated as absolute coordinates
     */ /**
     * @type {LineOptions}
     */ static get defaultOptions() {
        return {
            ...super.defaultOptions,
            cap: $e90a03c16dccc7f7$export$2e2bcd8739ae039.caps.round,
            join: $e90a03c16dccc7f7$export$2e2bcd8739ae039.joins.round,
            fill: null,
            stroke: super.defaultOptions.fill,
            absolute: false
        };
    }
    /**
     * @typedef {Object} LineCaps
     * @prop {String} butt - Caps cut straight at end points
     * @prop {String} round - Round caps by adding a circle at end points, with a radius of lineWidth
     * @prop {String} square - Square caps by adding a square at end points, with a size of lineWidth
     */ /**
     * @type {LineCaps}
     */ static get caps() {
        return {
            butt: "butt",
            round: "round",
            square: "square"
        };
    }
}



class $8b03e4ec6db32fa2$export$2e2bcd8739ae039 extends (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039) {
    /**
     * Arc constructor
     * @param {PositionDefinition} positionDefinition - Center of arc
     * @param {Number} [width=0] - Horizontal radius
     * @param {Number} [height=0] - Vertical radius
     * @param {Number} [startAngle=0] - Angle to start from (0 is top, 0.5 is bottom and 1 is full circle back to top)
     * @param {Number} [endAngle=0.5] - Angle to end to (from startAngle and in clockwise rotation)
     * @param {LineOptions} [options] - Drawing options
     */ constructor(positionDefinition, width = 0, height = 0, startAngle = 0, endAngle = 0.5, options){
        super(positionDefinition, options);
        this.width = width;
        this.height = height;
        this.startAngle = startAngle;
        this.endAngle = endAngle;
    }
    /**
     * Draw the arc
     * @param {Path2D} path - Drawing context
     * @return {Arc} Itself
     */ trace(path) {
        const correction = -0.25;
        const startAngle = (this.startAngle + correction) * (0, $26d060ef72148247$export$10ec9ebfd343bc9a);
        const endAngle = (this.endAngle + correction) * (0, $26d060ef72148247$export$10ec9ebfd343bc9a);
        path.ellipse(0, 0, this.width, this.height, 0, startAngle, endAngle);
        return this;
    }
    /**
     * @inheritDoc
     */ toJSON() {
        const { width: width, height: height, startAngle: startAngle, endAngle: endAngle } = this;
        return {
            ...super.toJSON(),
            width: width,
            height: height,
            startAngle: startAngle,
            endAngle: endAngle
        };
    }
    /**
     * @inheritDoc
     * @param {Object} definition - Arc definition
     * @return {Arc}
     */ static from(definition) {
        return new $8b03e4ec6db32fa2$export$2e2bcd8739ae039(definition.position, definition.width, definition.height, definition.startAngle, definition.endAngle, definition.options);
    }
    /**
     * @type {LineOptions}
     */ static get defaultOptions() {
        return (0, $e90a03c16dccc7f7$export$2e2bcd8739ae039).defaultOptions;
    }
    /**
     * @type {LineCaps}
     */ static get caps() {
        return (0, $e90a03c16dccc7f7$export$2e2bcd8739ae039).caps;
    }
}




class $3c25639b66649cfc$export$2e2bcd8739ae039 extends (0, $8b03e4ec6db32fa2$export$2e2bcd8739ae039) {
    /**
     * Pie constructor
     * @param {PositionDefinition} positionDefinition - Position of the center
     * @param {Number} radius - Circle radius
     * @param {Number} startAngle - Angle beginning the arc
     * @param {Number} endAngle - Angle ending the arc
     * @param {ComponentOptions} [options] - Specific options
     */ constructor(positionDefinition, radius, startAngle, endAngle, options){
        super(positionDefinition, radius, radius, startAngle, endAngle, options);
    }
    /**
     * @inheritDoc
     */ trace(path) {
        path.moveTo(0, 0);
        return super.trace(path);
    }
    /**
     * Return this pie's radius
     * @return {Number}
     */ get radius() {
        return this.width;
    }
    /**
     * Change this pie's radius
     * @param {Number} radius - New radius value
     */ set radius(radius) {
        this.width = radius;
        this.height = radius;
    }
    /**
     * @inheritDoc
     */ toJSON() {
        const { radius: radius } = this;
        const json = {
            ...super.toJSON(),
            radius: radius
        };
        delete json.width;
        delete json.height;
        return json;
    }
    /**
     * @return {ComponentOptions}
     */ static get defaultOptions() {
        return (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).defaultOptions;
    }
}




class $38f1308b79e8c5d9$export$2e2bcd8739ae039 extends (0, $8b03e4ec6db32fa2$export$2e2bcd8739ae039) {
    /**
     * Ellipse constructor
     * @param {PositionDefinition} positionDefinition - Position of the center of the ellipse
     * @param {Number} [width=0] - Horizontal radius
     * @param {Number} [height=0] - Vertical radius
     * @param {ComponentOptions} [options] - Drawing options
     */ constructor(positionDefinition, width, height, options){
        super(positionDefinition, width, height, 0, 1, options);
    }
    /**
     * @inheritDoc
     */ toJSON() {
        const json = super.toJSON();
        delete json.startAngle;
        delete json.endAngle;
        return json;
    }
    /**
     * @inheritDoc
     * @param {Object} definition - Ellipse definition
     * @return {Ellipse}
     */ static from(definition) {
        return new $38f1308b79e8c5d9$export$2e2bcd8739ae039(definition.position, definition.width, definition.height, definition.options);
    }
    /**
     * @type {ComponentOptions}
     */ static get defaultOptions() {
        return (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).defaultOptions;
    }
}




class $34ea7009dfd1f98d$export$2e2bcd8739ae039 extends (0, $38f1308b79e8c5d9$export$2e2bcd8739ae039) {
    /**
     * Circle constructor
     * @param {PositionDefinition} positionDefinition - Center of circle
     * @param {Number} radius - Distance from center to outer edge
     * @param {ComponentOptions} [options] - Drawing options
     */ constructor(positionDefinition, radius, options){
        super(positionDefinition, radius, radius, options);
    }
    /**
     * Return this circle's radius
     * @return {Number}
     */ get radius() {
        return this.width;
    }
    /**
     * Change this circle's radius
     * @param {Number} radius - New radius value
     */ set radius(radius) {
        this.width = radius;
        this.height = radius;
    }
    /**
     * @inheritDoc
     * @return {Circle} Itself
     */ trace(path) {
        path.arc(0, 0, this.radius, 0, (0, $26d060ef72148247$export$10ec9ebfd343bc9a));
        return this;
    }
    /**
     * @inheritDoc
     */ toJSON() {
        const { radius: radius } = this;
        const json = {
            ...super.toJSON(),
            radius: radius
        };
        delete json.width;
        delete json.height;
        return json;
    }
    /**
     * @inheritDoc
     * @param {Object} definition - Circle definition
     * @return {Circle}
     */ static from(definition) {
        return new $34ea7009dfd1f98d$export$2e2bcd8739ae039(definition.position, definition.radius, definition.options);
    }
}






class $821a4ca27fcc1e1f$export$2e2bcd8739ae039 extends (0, $e90a03c16dccc7f7$export$2e2bcd8739ae039) {
    /**
     * Spline constructor
     * @param {PositionDefinition} positionDefinition - First point
     * @param {Array<PositionDefinition>|PositionDefinition} points - Set of points to go through or a single target point
     * @param {Number} [tension=Spline.defaultTension] - Ratio of tension between points (0 means straight line, can take any value, but with weird results above 1)
     * @param {LineOptions} [options] - Drawing options
     */ constructor(positionDefinition, points, tension = $821a4ca27fcc1e1f$export$2e2bcd8739ae039.defaultTension, options){
        super(positionDefinition, points, options);
        /**
         * @type {Number}
         */ this.tension = tension;
    }
    /**
     * Draw the spline
     * @param {Path2D} path - Current drawing path
     * @return {Spline} Itself
     */ trace(path) {
        if (this.points.length === 1 || (0, $26d060ef72148247$export$e9bab7fafb253603)(this.tension, 0)) super.trace(path);
        else {
            path.moveTo(0, 0);
            const correction = this.options.absolute ? this.position : new (0, $ce200116bfeffd8f$export$2e2bcd8739ae039)();
            $821a4ca27fcc1e1f$export$2e2bcd8739ae039.splineThrough(path, [
                new (0, $ce200116bfeffd8f$export$2e2bcd8739ae039)(),
                ...this.points
            ], this.tension, correction);
        }
        return this;
    }
    /**
     * @inheritDoc
     */ toJSON() {
        const { tension: tension } = this;
        return {
            ...super.toJSON(),
            tension: tension
        };
    }
    /**
     * @inheritDoc
     * @param {Object} definition - Spline definition
     * @return {Spline}
     */ static from(definition) {
        return new $821a4ca27fcc1e1f$export$2e2bcd8739ae039(definition.position, definition.points, definition.tension, definition.options);
    }
    /**
     * Default ratio of tension
     * @type {Number}
     */ static get defaultTension() {
        return 0.2;
    }
    /**
     * Draw a spline through points using a tension (first point should be current position)
     * @param {Path2D|CanvasRenderingContext2D} path - Current drawing path
     * @param {Array<PositionDefinition>} points - Points to use (need at least 2 points)
     * @param {Number} [tension=Spline.defaultTension] - Ratio of tension
     * @param {PositionDefinition} [_correction] - Apply position correction to all points (used by the library)
     */ static splineThrough(path, points, tension = $821a4ca27fcc1e1f$export$2e2bcd8739ae039.defaultTension, _correction) {
        if (points.length < 2) throw new RangeError(`Need at least 2 points to spline, but only ${points.length} given.`);
        const shift = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(_correction);
        if (points.length === 2) {
            const target = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(points[1]);
            path.lineTo(target.x - shift.x, target.y - shift.y);
            return;
        }
        const positions = points.map((point)=>(0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(point).clone().subtract(shift));
        for(let i = 1; i < positions.length; ++i){
            const slice = [
                ...new Array(4)
            ].map((_, n)=>positions[i + n - 2]);
            // eslint-disable-next-line no-use-before-define
            const [before, after] = $821a4ca27fcc1e1f$var$getControlPoint(slice, tension);
            path.bezierCurveTo(before.x, before.y, after.x, after.y, positions[i].x, positions[i].y);
        }
    }
}
/**
 * Returns control points for a point in a spline (needs before and after, 3 points in total)
 * @param {Array<Position>} points - 4 points to use (before, one, two, after)
 * @param {Number} [tension=Spline.defaultTension] - Ratio of tension
 * @return {Array<Position>}
 */ function $821a4ca27fcc1e1f$var$getControlPoint(points, tension = $821a4ca27fcc1e1f$export$2e2bcd8739ae039.defaultTension) {
    const [previous, current, target, next] = points;
    let diffBefore;
    let diffAfter;
    if (previous) diffBefore = target.clone().subtract(previous).multiply(tension);
    if (next) diffAfter = current.clone().subtract(next).multiply(tension);
    return [
        points[1].clone().add(diffBefore),
        points[2].clone().add(diffAfter)
    ];
}




class $975d882a2cf46c71$export$2e2bcd8739ae039 extends (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039) {
    /**
     * Polygon constructor
     * @param {PositionDefinition} positionDefinition - Any position
     * @param {Array<PositionDefinition>} points - Set of vertices relative to position defining the polygon
     * @param {ComponentOptions} [options] - Drawing options
     */ constructor(positionDefinition, points = [], options){
        if (points.length < 3) throw new RangeError(`A polygon can't have less than 3 vertices, but only ${points.length} given.`);
        super(positionDefinition, options);
        /**
         * @type {Array<Position>}
         */ this.points = points.map((point)=>(0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(point));
    }
    /**
     * Draw the polygon
     * @param {Path2D} path - Current drawing path
     * @return {Polygon} Itself
     */ trace(path) {
        this.points.concat(...this.points.slice(0, 2)).forEach((point)=>path.lineTo(point.x, point.y));
        return this;
    }
    /**
     * @inheritDoc
     */ toJSON() {
        const { points: points } = this;
        return {
            ...super.toJSON(),
            points: points
        };
    }
    /**
     * @inheritDoc
     * @param {Object} definition - Polygon definition
     * @return {Polygon}
     */ static from(definition) {
        return new $975d882a2cf46c71$export$2e2bcd8739ae039(definition.position, definition.points, definition.options);
    }
}





const $0c1dc17496d983ce$var$radiusKey = Symbol("_radius");
class $0c1dc17496d983ce$export$2e2bcd8739ae039 extends (0, $975d882a2cf46c71$export$2e2bcd8739ae039) {
    /**
     * Regular polygon constructor
     * @param {PositionDefinition} position - Center of the polygon
     * @param {Number} nbSides - Number of sides
     * @param {Number} [radius=0] - Distance between center and outer points
     * @param {ComponentOptions} [options] - Drawing options
     */ constructor(position, nbSides, radius = 0, options){
        super(position, $0c1dc17496d983ce$export$2e2bcd8739ae039.getRotatingPoints(nbSides, radius), options);
        this[$0c1dc17496d983ce$var$radiusKey] = radius;
    }
    /**
     * Set a new radius
     * @param {Number} radius - New radius value
     */ set radius(radius) {
        const newPoints = $0c1dc17496d983ce$export$2e2bcd8739ae039.getRotatingPoints(this.points.length, radius);
        this.points.forEach((point, index)=>point.set(newPoints[index]));
        this[$0c1dc17496d983ce$var$radiusKey] = radius;
    }
    /**
     * Get the current radius
     * @return {Number}
     */ get radius() {
        return this[$0c1dc17496d983ce$var$radiusKey];
    }
    /**
     * @inheritDoc
     */ toJSON() {
        const { points: points, radius: radius } = this;
        const json = {
            ...super.toJSON(),
            nbSides: points.length,
            radius: radius
        };
        delete json.points;
        return json;
    }
    /**
     * @inheritDoc
     * @param {Object} definition - Regular polygon definition
     * @return {RegularPolygon}
     */ static from(definition) {
        return new $0c1dc17496d983ce$export$2e2bcd8739ae039(definition.position, definition.nbSides, definition.radius, definition.options);
    }
    /**
     * Return positions at regular intervals around a circle
     * @param {Number} nbPoints - Number of points
     * @param {Number} radius - Distance from origin
     * @param {Number} [startAngle=0] - Starting angle of the points (between 0 and 1)
     * @param {PositionDefinition} [center] - Relative center of all the points
     * @return {Array<Position>}
     */ static getRotatingPoints(nbPoints, radius, startAngle = 0, center) {
        const angle = startAngle - 1 / 4;
        const points = [];
        for(let i = 0; i < nbPoints; ++i){
            const rotation = (i / nbPoints + angle) * (0, $26d060ef72148247$export$10ec9ebfd343bc9a);
            const point = new (0, $ce200116bfeffd8f$export$2e2bcd8739ae039)(Math.cos(rotation) * radius, Math.sin(rotation) * radius);
            points.push(point.add(center));
        }
        return points;
    }
}



class $7adea6df750c4d07$export$2e2bcd8739ae039 extends (0, $0c1dc17496d983ce$export$2e2bcd8739ae039) {
    /**
     * Triangle constructor
     * @param {PositionDefinition} positionDefinition - Center of the triangle
     * @param {Number} radius - Distance of branches from center
     * @param {ComponentOptions} [options] - Drawing options
     */ constructor(positionDefinition, radius, options){
        super(positionDefinition, 3, radius, options);
    }
    /**
     * @inheritDoc
     */ toJSON() {
        const json = super.toJSON();
        delete json.nbSides;
        return json;
    }
    /**
     * @inheritDoc
     * @param {Object} definition - Triangle definition
     * @return {Triangle}
     */ static from(definition) {
        return new $7adea6df750c4d07$export$2e2bcd8739ae039(definition.position, definition.radius, definition.options);
    }
}



const $a3bf5d175c7a8e0e$var$bevelRatioKey = Symbol("_bevelKey");
class $a3bf5d175c7a8e0e$export$2e2bcd8739ae039 extends (0, $0c1dc17496d983ce$export$2e2bcd8739ae039) {
    /**
     * Star constructor
     * @param {PositionDefinition} positionDefinition - Center of the star
     * @param {Number} [nbBranches=5] - Number of branches to create (can't be less than 2)
     * @param {Number} outerRadius - Distance of branches from center
     * @param {Number} [bevelRatio=0.5] - Ratio between branches length and bevel between them
     * @param {ComponentOptions} [options] - Drawing options
     */ constructor(positionDefinition, nbBranches = 5, outerRadius, bevelRatio = 0.5, options){
        super(positionDefinition, nbBranches * 2, outerRadius, options);
        this[$a3bf5d175c7a8e0e$var$bevelRatioKey] = bevelRatio;
        this.radius = outerRadius;
    }
    /**
     * Get the number of branches
     * @return {Number}
     */ get nbBranches() {
        return this.points.length / 2;
    }
    /**
     * Change the number of branches
     * @param {Number} nbBranches - New number of branches
     */ set nbBranches(nbBranches) {
        this.points = (0, $0c1dc17496d983ce$export$2e2bcd8739ae039).getRotatingPoints(nbBranches * 2, this.radius);
        this.rebuild();
    }
    /**
     * Get the outer radius
     * @return {Number}
     */ get radius() {
        return super.radius;
    }
    /**
     * Change the outer radius
     * @param {Number} radius - New radius value
     */ set radius(radius) {
        super.radius = radius;
        this.rebuild();
    }
    /**
     * Get the bevel ratio
     * @return {Number}
     */ get bevelRatio() {
        return this[$a3bf5d175c7a8e0e$var$bevelRatioKey];
    }
    /**
     * Change the bevel ratio
     * @param {Number} bevelRatio - New bevel ratio value
     */ set bevelRatio(bevelRatio) {
        this[$a3bf5d175c7a8e0e$var$bevelRatioKey] = bevelRatio;
        this.rebuild();
    }
    /**
     * Compute the position for the points from the internal properties
     */ rebuild() {
        const innerRadius = this.radius * this.bevelRatio;
        const innerPoints = (0, $0c1dc17496d983ce$export$2e2bcd8739ae039).getRotatingPoints(this.nbBranches, innerRadius, 0.5 / this.nbBranches);
        this.points.forEach((point, index)=>{
            if (index % 2) point.set(innerPoints[(index - 1) / 2]);
        });
    }
    /**
     * @inheritDoc
     */ toJSON() {
        const { bevelRatio: bevelRatio } = this;
        const json = {
            ...super.toJSON(),
            bevelRatio: bevelRatio
        };
        json.nbBranches = json.nbSides / 2;
        delete json.nbSides;
        return json;
    }
    /**
     * @inheritDoc
     * @param {Object} definition - Star definition
     * @return {Star}
     */ static from(definition) {
        return new $a3bf5d175c7a8e0e$export$2e2bcd8739ae039(definition.position, definition.nbBranches, definition.radius, definition.bevelRatio, definition.options);
    }
}




/**
 * @module Square
 */ const $ddc9f679561154f9$var$widthKey = Symbol("_width");
const $ddc9f679561154f9$var$heightKey = Symbol("_height");
class $ddc9f679561154f9$export$2e2bcd8739ae039 extends (0, $b5f43a4eeef4cb6f$export$2e2bcd8739ae039) {
    /**
     * Square constructor
     * @param {PositionDefinition} positionDefinition - Top-left corner
     * @param {Number} size - Side's length
     * @param {ComponentOptions} [options] - Drawing options
     */ constructor(positionDefinition, size, options){
        super(positionDefinition, size, size, options);
    }
    /**
     * Set this square's size
     * @param {Number} size - New size
     */ set size(size) {
        this[$ddc9f679561154f9$var$widthKey] = size;
        this[$ddc9f679561154f9$var$heightKey] = size;
    }
    /**
     * Get this square's size
     * @return {Number}
     */ get size() {
        return this.width;
    }
    /**
     * Set width (also set height)
     * @param {Number} width - Any value for width (and height)
     */ set width(width) {
        this.size = width;
    }
    /**
     * Get width
     * @return {Number}
     */ get width() {
        return this[$ddc9f679561154f9$var$widthKey];
    }
    /**
     * Set height (also set width)
     * @param {Number} height - Any value for height (and width)
     */ set height(height) {
        this.size = height;
    }
    /**
     * Get height
     * @return {Number}
     */ get height() {
        return this[$ddc9f679561154f9$var$heightKey];
    }
    /**
     * @inheritDoc
     */ toJSON() {
        const { size: size } = this;
        const json = {
            ...super.toJSON(),
            size: size
        };
        delete json.height;
        delete json.width;
        return json;
    }
    /**
     * @inheritDoc
     * @param {Object} definition - Square definition
     * @return {Square}
     */ static from(definition) {
        return new $ddc9f679561154f9$export$2e2bcd8739ae039(definition.position, definition.size, definition.options);
    }
}



/* eslint-disable no-use-before-define */ 

/**
 * Return either "rtl" or "ltr" for the text direction from a node.
 * If the node is not attached to any DOM, it returns an empty string ("").
 * @param {Element} [elementNode=document.body] - Any element node from a DOM or `document.body` if none specified
 * @throws {TypeError} When elementNode is truthy and not an {Element}
 * @return {String}
 */ function $df5e04a70c864ca1$export$2e2bcd8739ae039(elementNode) {
    return document.defaultView.getComputedStyle(elementNode || document.body).direction;
}


/**
 * @module Text
 */ /**
 * Reformat passed arguments into an array of line string
 * @param {String|Array<String>} string - Multiline string or Array of multiline strings to split
 * @return {Array<String>}
 */ function $0c4e551c62a7aa5b$var$formatString(string) {
    const split = (text)=>text.toString().split("\n");
    return Array.isArray(string) ? string.reduce((acc, line)=>acc.concat($0c4e551c62a7aa5b$var$formatString(line)), []) : split(string);
}
/**
 * Cache based text measurement
 * @param {String|Array<String>} text - Any text
 * @param {TextOptions} options - Font definition
 * @return {TextMeasures}
 */ const $0c4e551c62a7aa5b$var$measureText = (()=>{
    let sandbox;
    const cache = {};
    const select = ({ lineHeight: lineHeight, bold: bold, italic: italic, fontSize: fontSize, font: font })=>({
            lineHeight: lineHeight,
            bold: bold,
            italic: italic,
            fontSize: fontSize,
            font: font
        });
    return (text, options)=>{
        const lines = $0c4e551c62a7aa5b$var$formatString(text);
        const selected = select({
            ...$0c4e551c62a7aa5b$export$2e2bcd8739ae039.defaultOptions,
            ...options
        });
        const key = `${lines.join("\n")}${JSON.stringify(selected)}`;
        if (cache[key] !== undefined) return cache[key];
        if (!sandbox) sandbox = document.createElement("canvas").getContext("2d");
        sandbox.font = $0c4e551c62a7aa5b$export$2e2bcd8739ae039.getFontDefinition(selected);
        const height = selected.fontSize * selected.lineHeight * lines.length;
        const width = lines.reduce((max, line)=>Math.max(max, sandbox.measureText(line).width), 0);
        const result = {
            width: width,
            height: height
        };
        cache[key] = result;
        return result;
    };
})();
class $0c4e551c62a7aa5b$export$2e2bcd8739ae039 extends (0, $b5f43a4eeef4cb6f$export$2e2bcd8739ae039) {
    /**
     * Text constructor
     * @param {PositionDefinition} positionDefinition - Top most point of the line start (depend on align option)
     * @param {String} [text=""] - Text to display
     * @param {TextOptions} [options] - Drawing options
     */ constructor(positionDefinition, text = "", options){
        super(positionDefinition, undefined, undefined, options);
        /**
         * @type {Array<String>}
         */ this.lines = [];
        this.text = text;
        // if font is an URL
        const isLoadedEvent = new (0, $1a62a1afb6cf7c06$export$2e2bcd8739ae039)((0, $1a62a1afb6cf7c06$export$2e2bcd8739ae039).events.ready, this);
        if (/^(\w+:)?\/\//.test(this.options.font)) $0c4e551c62a7aa5b$export$2e2bcd8739ae039.load(this.options.font).then((name)=>{
            this.options.font = name;
            this.fire(isLoadedEvent);
        });
        else this.fire(isLoadedEvent);
    }
    /**
     * Returns the text
     * @return {String}
     */ get text() {
        return this.lines.join("\n");
    }
    /**
     * Change the text
     * @param {String|Array<String>} text - New text value
     * @example this.text = "Single line text";
     * @example this.text = "Multi\nLine text";
     * @example this.text = ["Multi", "Line text"];
     * @example this.text = ["Multi", "Line\ntext"];
     */ set text(text) {
        this.lines = $0c4e551c62a7aa5b$var$formatString(text);
    }
    /**
     * Draw the text into a drawing context
     * @param {CanvasRenderingContext2D} ctx - Drawing context
     * @return {Text} Itself
     */ makePath(ctx) {
        const { options: options } = this;
        if (this.text.length && (this.willFill || this.willStroke)) {
            const origin = this.getOrigin();
            ctx.translate(origin.x, origin.y);
            const lineHeight = $0c4e551c62a7aa5b$export$2e2bcd8739ae039.measure("M", this.options).height;
            const height = lineHeight / options.lineHeight;
            const margin = height * ((options.lineHeight - 1) / 2);
            if (options.underscore) ctx.beginPath();
            const offset = this.getAlignOffset();
            ctx.translate(offset * this.width, 0);
            this.lines.forEach((line, index)=>{
                const y = index * lineHeight + margin;
                if (this.willFill) ctx.fillText(line, 0, y);
                if (this.willStroke) ctx.strokeText(line, 0, y);
                if (options.underscore) {
                    const { width: width } = $0c4e551c62a7aa5b$export$2e2bcd8739ae039.measure(line, options);
                    const left = offset * width;
                    ctx.moveTo(-left, y + height);
                    ctx.lineTo(width - left, y + height);
                }
            });
            if (options.underscore) {
                ctx.lineWidth = height * (options.bold ? 0.07 : 0.05);
                ctx.strokeStyle = (this.willStroke && options.stroke || options.fill).toString(ctx);
                ctx.stroke();
                ctx.closePath();
            }
            ctx.translate(-origin.x, -origin.y);
        }
        return this;
    }
    /**
     * @inheritDoc
     * @return {Text} Itself
     */ setContext(ctx) {
        super.setContext(ctx);
        if (this.willFill || this.willStroke) {
            ctx.font = $0c4e551c62a7aa5b$export$2e2bcd8739ae039.getFontDefinition(this.options);
            ctx.textAlign = this.options.align;
            ctx.textBaseline = "top"; // TODO: user could want to change this
        }
        return this;
    }
    /**
     * Return the position offset according to alignment
     * @return {Number}
     */ getAlignOffset() {
        const { align: align } = this.options;
        let offset = 0;
        if (align === $0c4e551c62a7aa5b$export$2e2bcd8739ae039.alignments.center) offset = 0.5;
        else if (align === $0c4e551c62a7aa5b$export$2e2bcd8739ae039.alignments.right) offset = 1;
        else if (align === $0c4e551c62a7aa5b$export$2e2bcd8739ae039.alignments.start || align === $0c4e551c62a7aa5b$export$2e2bcd8739ae039.alignments.end) {
            const root = this.getRoot();
            if (root.isScene) {
                const dir = (0, $df5e04a70c864ca1$export$2e2bcd8739ae039)(root.ctx.canvas);
                if (align === $0c4e551c62a7aa5b$export$2e2bcd8739ae039.alignments.start && dir === "rtl" || align === $0c4e551c62a7aa5b$export$2e2bcd8739ae039.alignments.end && dir === "ltr") offset = 1;
            }
        }
        return offset;
    }
    /**
     * Measure the text with current options
     * @return {TextMeasures}
     */ getMeasures() {
        return $0c4e551c62a7aa5b$export$2e2bcd8739ae039.measure(this.text, this.options);
    }
    /**
     * Width of the text
     * @return {Number}
     */ get width() {
        return this.getMeasures().width;
    }
    /**
     * Can't set text's width
     * @param {*} _ -
     */ set width(_) {
    // Do nothing
    }
    /**
     * Height of the text
     * @return {Number}
     */ get height() {
        return this.getMeasures().height;
    }
    /**
     * Can't set text's height
     * @param {*} _ -
     */ set height(_) {
    // Do nothing
    }
    /**
     * @inheritDoc
     */ toJSON() {
        const { text: text } = this;
        return {
            ...super.toJSON(),
            text: text
        };
    }
    /**
     * @param {Object} definition - Text definition
     * @return {Text}
     */ static from(definition) {
        return new $0c4e551c62a7aa5b$export$2e2bcd8739ae039(definition.position, definition.text, definition.options);
    }
    /**
     * Load a font URL
     * @param {String|Array<String>} url - URL or an array of URL to font files
     * @return {Promise<String>} Promise for the generated font-family
     */ static load(url) {
        if (Array.isArray(url)) return Promise.all(url.map((singleUrl)=>$0c4e551c62a7aa5b$export$2e2bcd8739ae039.load(singleUrl)));
        const name = url.replace(/\W/g, "-");
        const fontFace = new window.FontFace(name, `url(${url})`);
        window.document.fonts.add(fontFace);
        return fontFace.load().then(()=>name);
    }
    /**
     * Return a font definition from a set of options
     * @param {TextOptions} options - Chosen options
     * @return {String}
     */ static getFontDefinition(options) {
        return `${options.bold ? "bold " : ""}${options.italic ? "italic " : ""}${options.fontSize}px ${options.font}`;
    }
    /**
     * @typedef {Object} TextMeasures
     * @prop {Number} width - Horizontal size
     * @prop {Number} height - Vertical size
     */ /**
     * Compute a text width and height
     * @param {String|Array<String>} text - Any text
     * @param {TextOptions} [options] - Options of the text
     * @return {TextMeasures}
     */ static measure(text, options) {
        return $0c4e551c62a7aa5b$var$measureText(text, options);
    }
    /**
     * @typedef {Object} TextOptions
     * @extends ComponentOptions
     * @prop {String} [font="sans-serif"] - Font to use (can be a URL)
     * @prop {Number} [fontSize=10] - Size of the text in pixels
     * @prop {String} [align=Text.alignments.start] - Text horizontal alignment
     * @prop {Boolean} [bold=false] - Use bold font-weight
     * @prop {Boolean} [italic=false] - Use italic font-style
     * @prop {Boolean} [underscore=false] - Draw a line under the text
     * @prop {Number} [lineHeight=1] - Ratio of line height (1 is normal, 2 is twice the space)
     */ /**
     * @type {TextOptions}
     */ static get defaultOptions() {
        return {
            ...super.defaultOptions,
            font: "sans-serif",
            fontSize: 20,
            align: $0c4e551c62a7aa5b$export$2e2bcd8739ae039.alignments.start,
            bold: false,
            italic: false,
            underscore: false,
            lineHeight: 1
        };
    }
    /**
     * @typedef {Object} TextAlignments
     * @prop {String} left - The text is left-aligned.
     * @prop {String} right - The text is right-aligned.
     * @prop {String} center - The text is centered.
     * @prop {String} start - The text is aligned at the normal start of the line. (regarding locales)
     * @prop {String} end - The text is aligned at the normal end of the line. (regarding locales)
     */ /**
     * @type {TextAlignments}
     */ static get alignments() {
        return {
            left: "left",
            right: "right",
            center: "center",
            start: "start",
            end: "end"
        };
    }
}







class $5889be9ae39751d2$export$2e2bcd8739ae039 {
    /**
     * @callback InstructionCallback
     * @param {Path2D} path - Current drawing path
     * @param {Position} target - Target position
     * @param {Position} previousPosition - Position from where instruction started
     */ /**
     * Instruction constructor
     * @param {InstructionCallback} action - Function to execute
     * @param {PositionDefinition} target - Position to go to
     */ constructor(action, target){
        this.action = action;
        this.target = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(target);
    }
    /**
     * Follow the instruction
     * @param {Path2D} path - Current drawing path
     * @param {Position} previousPosition - Position from where the instruction start
     * @return {Position} The position reached
     */ execute(path, previousPosition) {
        this.action.call(this, path, this.target, previousPosition);
        return this.target;
    }
    /**
     * Unimplemented
     * FIXME: How to serialize a wrapper of a function ?
     */ toJSON() {
        throw new ReferenceError("Unimplemented toJSON function in Path's Instruction");
    }
    /**
     * Unimplemented
     * FIXME
     */ static from() {
        throw new ReferenceError("Unimplemented from function in Instruction");
    }
}


class $12e0d5cfa03f0c3b$export$2e2bcd8739ae039 extends (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039) {
    /**
     * Path constructor
     * @param {PositionDefinition} positionDefinition - Starting position of the Path
     * @param {Array<Instruction>|String} instructions - Set of instructions to follow to draw it
     * @param {Boolean} [isClosed=true] - Should the path close itself (add a line to the starting position)
     * @param {ComponentOptions|LineOptions} [options] - Drawing options
     */ constructor(positionDefinition, instructions, isClosed = true, options){
        super(positionDefinition, options);
        if (!isClosed) // Overrides options to work like a line if not closed
        this.options = new (0, $e90a03c16dccc7f7$export$2e2bcd8739ae039)(this.position, [], options).options;
        this.instructions = instructions;
        this.isClosed = isClosed;
        this.closing = $12e0d5cfa03f0c3b$export$2e2bcd8739ae039.lineTo(new (0, $ce200116bfeffd8f$export$2e2bcd8739ae039)());
    }
    /**
     * Draw the path
     * @param {Path2D} path - Current drawing path
     * @return {Path} Itself
     */ trace(path) {
        let lastPosition = new (0, $ce200116bfeffd8f$export$2e2bcd8739ae039)();
        const instructions = this.instructions.slice();
        if (Array.isArray(instructions)) {
            if (this.isClosed) {
                const lastTarget = this.instructions[this.instructions.length - 1].target;
                path.moveTo(lastTarget.x, lastTarget.y);
                instructions.unshift(this.closing);
                instructions.push(this.closing);
                lastPosition = lastTarget;
            } else path.moveTo(0, 0);
            instructions.forEach((instruction)=>lastPosition = instruction.execute(path, lastPosition));
        } else if (typeof instructions === "string") {
            const svg = new window.Path2D(`M0 0 ${instructions}${this.isClosed ? " Z" : ""}`);
            path.addPath(svg);
        }
        return this;
    }
    /**
     * @inheritDoc
     */ isHover(positionDefinition, ctx) {
        return super.isHover(positionDefinition, ctx);
    }
    /**
     * @inheritDoc
     */ toJSON() {
        const { instructions: instructions, isClosed: isClosed } = this;
        return {
            ...super.toJSON(),
            instructions: instructions,
            isClosed: isClosed
        };
    }
    /**
     * @inheritDoc
     * @param {Object} definition - Path definition
     * @return {Path}
     */ static from(definition) {
        const instructions = Array.isArray(definition.instructions) ? definition.instructions.map((instruction)=>(0, $5889be9ae39751d2$export$2e2bcd8739ae039).from(instruction)) : undefined;
        return new $12e0d5cfa03f0c3b$export$2e2bcd8739ae039(definition.position, instructions, definition.isClosed, definition.options);
    }
    /**
     * Draw a line to a position
     * @param {PositionDefinition} position - Any position
     * @return {Instruction}
     */ static lineTo(position) {
        return new (0, $5889be9ae39751d2$export$2e2bcd8739ae039)((path, pos)=>path.lineTo(pos.x, pos.y), position);
    }
    /**
     * Move the pencil without drawing
     * @param {PositionDefinition} position - Any position
     * @return {Instruction}
     */ static moveTo(position) {
        return new (0, $5889be9ae39751d2$export$2e2bcd8739ae039)((path, pos)=>path.moveTo(pos.x, pos.y), position);
    }
    /**
     * Draw an quarter circle arc to a position
     * @param {PositionDefinition} position - Any position
     * @param {Boolean} [clockwise=true] - Should the arc be clockwise or not
     * @return {Instruction}
     */ static quarterTo(position, clockwise) {
        return $12e0d5cfa03f0c3b$export$2e2bcd8739ae039.arcTo(position, 0.25, 4 / 3 * (Math.sqrt(2) - 1), clockwise);
    }
    /**
     * Draw an quarter circle arc to a position
     * @param {PositionDefinition} position - Any position
     * @param {Boolean} [clockwise=true] - Should the arc be clockwise or not
     * @return {Instruction}
     */ static halfTo(position, clockwise) {
        return $12e0d5cfa03f0c3b$export$2e2bcd8739ae039.arcTo(position, 0.5, 4 / 3, clockwise);
    }
    /**
     * Try to approximate an arc between two points
     * @param {PositionDefinition} position - Any position
     * @param {Number} angle - Arc angle in ratio of a full circle (should be less than 0.5)
     * @param {Number} magicRatio - Control points "openness" ratio
     * @param {Boolean} [clockwise=true] - Should the arc be clockwise or not
     * @return {Instruction}
     */ static arcTo(position, angle, magicRatio, clockwise = true) {
        return new (0, $5889be9ae39751d2$export$2e2bcd8739ae039)((path, pos, lp)=>{
            const distance = pos.distance(lp);
            const radius = distance / 2;
            const direction = clockwise ? 1 : -1;
            const alpha = angle / 2 * direction;
            const ctrl1 = pos.clone().subtract(lp).rotate(-alpha).divide(distance).multiply(magicRatio * radius).add(lp);
            const ctrl2 = lp.clone().subtract(pos).rotate(alpha).divide(distance).multiply(magicRatio * radius).add(pos);
            // Approximate a arc with a bezier curve
            $12e0d5cfa03f0c3b$export$2e2bcd8739ae039.bezierTo(pos, ctrl1, ctrl2).execute(path, lp);
        }, position);
    }
    /**
     * Draw a quadratic curve to a position
     * @param {PositionDefinition} position - Any position
     * @param {PositionDefinition} controlPoint - Point that control the curve
     * @return {Instruction}
     */ static quadTo(position, controlPoint) {
        const control = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(controlPoint);
        return new (0, $5889be9ae39751d2$export$2e2bcd8739ae039)((path, pos)=>{
            path.quadraticCurveTo(control.x, control.y, pos.x, pos.y);
        }, position);
    }
    /**
     * Draw a bezier curve to a position
     * @param {PositionDefinition} position - Any position
     * @param {PositionDefinition} firstControlPoint - First point to control the curve
     * @param {PositionDefinition} secondControlPoint - Second point to control the curve
     * @return {Instruction}
     */ static bezierTo(position, firstControlPoint, secondControlPoint) {
        const control1 = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(firstControlPoint);
        const control2 = (0, $ce200116bfeffd8f$export$2e2bcd8739ae039).from(secondControlPoint);
        return new (0, $5889be9ae39751d2$export$2e2bcd8739ae039)((path, pos)=>{
            path.bezierCurveTo(control1.x, control1.y, control2.x, control2.y, pos.x, pos.y);
        }, position);
    }
    /**
     *
     * @param {Array<PositionDefinition>} points - Any set of positions
     * @param {Number} [tension] - Ratio of tension
     * @return {Instruction}
     */ static splineThrough(points, tension) {
        const last = points[points.length - 1];
        return new (0, $5889be9ae39751d2$export$2e2bcd8739ae039)((path, current, previousPosition)=>{
            (0, $821a4ca27fcc1e1f$export$2e2bcd8739ae039).splineThrough(path, [
                previousPosition,
                ...points
            ], tension);
        }, last);
    }
    /* eslint-disable */ /**
     *
     * @param {PositionDefinition} position - Any position
     * @param {Number} nbWaves - Number of waves to draw
     * @return {Instruction}
     */ static waveTo(position, nbWaves) {
        var path, pos, lp;
        throw new ReferenceError("This function has yet to be implemented.");
    }
    /**
     *
     * @param {PositionDefinition} position - Any position
     * @param {Number} nbSins - Number of sinusoid to draw
     * @param {Number} sinsHeight - Height of the sinusoid
     * @return {Instruction}
     */ static sinTo(position, nbSins, sinsHeight) {
        var path, pos, lp;
        throw new ReferenceError("This function has yet to be implemented.");
    }
}



class $bd29dd0079e0f6a7$export$2e2bcd8739ae039 extends (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039) {
    /**
     * Heart constructor
     * @param {PositionDefinition} positionDefinition - Position of the center of the heart
     * @param {Number} radius - radius The distance from center of heart
     * @param {ComponentOptions} [options] - Drawing options
     */ constructor(positionDefinition, radius, options){
        super(positionDefinition, options);
        /**
         * @type {Number}
         */ this.radius = radius;
    }
    /**
     * Draw the Heart
     * @param {Path2D} path - Drawing context
     * @return {Heart} Itself
     */ trace(path) {
        path.moveTo(0, -0.4 * this.radius);
        const curves = [
            [
                -0.4,
                -0.9,
                -1,
                -0.6,
                -1,
                0
            ],
            [
                -1,
                0.4,
                -0.6,
                0.6,
                0,
                1
            ],
            [
                0.6,
                0.6,
                1,
                0.4,
                1,
                0
            ],
            [
                1,
                -0.6,
                0.4,
                -0.9,
                0,
                -0.4
            ]
        ];
        curves.concat(curves.slice(0, 1)).forEach((points)=>path.bezierCurveTo(...points.map((x)=>x * this.radius)));
        return this;
    }
    /**
     * @inheritDoc
     */ toJSON() {
        const { radius: radius } = this;
        return {
            ...super.toJSON(),
            radius: radius
        };
    }
    /**
     * @inheritDoc
     * @param {Object} definition - Heart definition
     * @return {Heart}
     */ static from(definition) {
        return new $bd29dd0079e0f6a7$export$2e2bcd8739ae039(definition.position, definition.radius, definition.options);
    }
}





var $c20764db574c1db3$exports = {};
const $c20764db574c1db3$var$minimatch = $c20764db574c1db3$exports = (p, pattern, options = {})=>{
    $c20764db574c1db3$var$assertValidPattern(pattern);
    // shortcut: comments match nothing.
    if (!options.nocomment && pattern.charAt(0) === "#") return false;
    return new $c20764db574c1db3$var$Minimatch(pattern, options).match(p);
};
$c20764db574c1db3$exports = $c20764db574c1db3$var$minimatch;
var $5199c9967acba189$exports = {};
var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


const $5199c9967acba189$var$isWindows = typeof $cfae44f0dfdf62c0$exports === "object" && $cfae44f0dfdf62c0$exports && $cfae44f0dfdf62c0$exports.platform === "win32";
$5199c9967acba189$exports = $5199c9967acba189$var$isWindows ? {
    sep: "\\"
} : {
    sep: "/"
};


$c20764db574c1db3$var$minimatch.sep = $5199c9967acba189$exports.sep;
const $c20764db574c1db3$var$GLOBSTAR = Symbol("globstar **");
$c20764db574c1db3$var$minimatch.GLOBSTAR = $c20764db574c1db3$var$GLOBSTAR;
var $734947cb21bd6d57$exports = {};
var $30933cb119085804$exports = {};
"use strict";
$30933cb119085804$exports = $30933cb119085804$var$balanced;
function $30933cb119085804$var$balanced(a, b, str) {
    if (a instanceof RegExp) a = $30933cb119085804$var$maybeMatch(a, str);
    if (b instanceof RegExp) b = $30933cb119085804$var$maybeMatch(b, str);
    var r = $30933cb119085804$var$range(a, b, str);
    return r && {
        start: r[0],
        end: r[1],
        pre: str.slice(0, r[0]),
        body: str.slice(r[0] + a.length, r[1]),
        post: str.slice(r[1] + b.length)
    };
}
function $30933cb119085804$var$maybeMatch(reg, str) {
    var m = str.match(reg);
    return m ? m[0] : null;
}
$30933cb119085804$var$balanced.range = $30933cb119085804$var$range;
function $30933cb119085804$var$range(a, b, str) {
    var begs, beg, left, right, result;
    var ai = str.indexOf(a);
    var bi = str.indexOf(b, ai + 1);
    var i = ai;
    if (ai >= 0 && bi > 0) {
        if (a === b) return [
            ai,
            bi
        ];
        begs = [];
        left = str.length;
        while(i >= 0 && !result){
            if (i == ai) {
                begs.push(i);
                ai = str.indexOf(a, i + 1);
            } else if (begs.length == 1) result = [
                begs.pop(),
                bi
            ];
            else {
                beg = begs.pop();
                if (beg < left) {
                    left = beg;
                    right = bi;
                }
                bi = str.indexOf(b, i + 1);
            }
            i = ai < bi && ai >= 0 ? ai : bi;
        }
        if (begs.length) result = [
            left,
            right
        ];
    }
    return result;
}


$734947cb21bd6d57$exports = $734947cb21bd6d57$var$expandTop;
var $734947cb21bd6d57$var$escSlash = "\0SLASH" + Math.random() + "\0";
var $734947cb21bd6d57$var$escOpen = "\0OPEN" + Math.random() + "\0";
var $734947cb21bd6d57$var$escClose = "\0CLOSE" + Math.random() + "\0";
var $734947cb21bd6d57$var$escComma = "\0COMMA" + Math.random() + "\0";
var $734947cb21bd6d57$var$escPeriod = "\0PERIOD" + Math.random() + "\0";
function $734947cb21bd6d57$var$numeric(str) {
    return parseInt(str, 10) == str ? parseInt(str, 10) : str.charCodeAt(0);
}
function $734947cb21bd6d57$var$escapeBraces(str) {
    return str.split("\\\\").join($734947cb21bd6d57$var$escSlash).split("\\{").join($734947cb21bd6d57$var$escOpen).split("\\}").join($734947cb21bd6d57$var$escClose).split("\\,").join($734947cb21bd6d57$var$escComma).split("\\.").join($734947cb21bd6d57$var$escPeriod);
}
function $734947cb21bd6d57$var$unescapeBraces(str) {
    return str.split($734947cb21bd6d57$var$escSlash).join("\\").split($734947cb21bd6d57$var$escOpen).join("{").split($734947cb21bd6d57$var$escClose).join("}").split($734947cb21bd6d57$var$escComma).join(",").split($734947cb21bd6d57$var$escPeriod).join(".");
}
// Basically just str.split(","), but handling cases
// where we have nested braced sections, which should be
// treated as individual members, like {a,{b,c},d}
function $734947cb21bd6d57$var$parseCommaParts(str) {
    if (!str) return [
        ""
    ];
    var parts = [];
    var m = $30933cb119085804$exports("{", "}", str);
    if (!m) return str.split(",");
    var pre = m.pre;
    var body = m.body;
    var post = m.post;
    var p = pre.split(",");
    p[p.length - 1] += "{" + body + "}";
    var postParts = $734947cb21bd6d57$var$parseCommaParts(post);
    if (post.length) {
        p[p.length - 1] += postParts.shift();
        p.push.apply(p, postParts);
    }
    parts.push.apply(parts, p);
    return parts;
}
function $734947cb21bd6d57$var$expandTop(str) {
    if (!str) return [];
    // I don't know why Bash 4.3 does this, but it does.
    // Anything starting with {} will have the first two bytes preserved
    // but *only* at the top level, so {},a}b will not expand to anything,
    // but a{},b}c will be expanded to [a}c,abc].
    // One could argue that this is a bug in Bash, but since the goal of
    // this module is to match Bash's rules, we escape a leading {}
    if (str.substr(0, 2) === "{}") str = "\\{\\}" + str.substr(2);
    return $734947cb21bd6d57$var$expand($734947cb21bd6d57$var$escapeBraces(str), true).map($734947cb21bd6d57$var$unescapeBraces);
}
function $734947cb21bd6d57$var$embrace(str) {
    return "{" + str + "}";
}
function $734947cb21bd6d57$var$isPadded(el) {
    return /^-?0\d/.test(el);
}
function $734947cb21bd6d57$var$lte(i, y) {
    return i <= y;
}
function $734947cb21bd6d57$var$gte(i, y) {
    return i >= y;
}
function $734947cb21bd6d57$var$expand(str, isTop) {
    var expansions = [];
    var m = $30933cb119085804$exports("{", "}", str);
    if (!m) return [
        str
    ];
    // no need to expand pre, since it is guaranteed to be free of brace-sets
    var pre = m.pre;
    var post = m.post.length ? $734947cb21bd6d57$var$expand(m.post, false) : [
        ""
    ];
    if (/\$$/.test(m.pre)) for(var k = 0; k < post.length; k++){
        var expansion = pre + "{" + m.body + "}" + post[k];
        expansions.push(expansion);
    }
    else {
        var isNumericSequence = /^-?\d+\.\.-?\d+(?:\.\.-?\d+)?$/.test(m.body);
        var isAlphaSequence = /^[a-zA-Z]\.\.[a-zA-Z](?:\.\.-?\d+)?$/.test(m.body);
        var isSequence = isNumericSequence || isAlphaSequence;
        var isOptions = m.body.indexOf(",") >= 0;
        if (!isSequence && !isOptions) {
            // {a},b}
            if (m.post.match(/,.*\}/)) {
                str = m.pre + "{" + m.body + $734947cb21bd6d57$var$escClose + m.post;
                return $734947cb21bd6d57$var$expand(str);
            }
            return [
                str
            ];
        }
        var n;
        if (isSequence) n = m.body.split(/\.\./);
        else {
            n = $734947cb21bd6d57$var$parseCommaParts(m.body);
            if (n.length === 1) {
                // x{{a,b}}y ==> x{a}y x{b}y
                n = $734947cb21bd6d57$var$expand(n[0], false).map($734947cb21bd6d57$var$embrace);
                if (n.length === 1) return post.map(function(p) {
                    return m.pre + n[0] + p;
                });
            }
        }
        // at this point, n is the parts, and we know it's not a comma set
        // with a single entry.
        var N;
        if (isSequence) {
            var x = $734947cb21bd6d57$var$numeric(n[0]);
            var y = $734947cb21bd6d57$var$numeric(n[1]);
            var width = Math.max(n[0].length, n[1].length);
            var incr = n.length == 3 ? Math.abs($734947cb21bd6d57$var$numeric(n[2])) : 1;
            var test = $734947cb21bd6d57$var$lte;
            var reverse = y < x;
            if (reverse) {
                incr *= -1;
                test = $734947cb21bd6d57$var$gte;
            }
            var pad = n.some($734947cb21bd6d57$var$isPadded);
            N = [];
            for(var i = x; test(i, y); i += incr){
                var c;
                if (isAlphaSequence) {
                    c = String.fromCharCode(i);
                    if (c === "\\") c = "";
                } else {
                    c = String(i);
                    if (pad) {
                        var need = width - c.length;
                        if (need > 0) {
                            var z = new Array(need + 1).join("0");
                            if (i < 0) c = "-" + z + c.slice(1);
                            else c = z + c;
                        }
                    }
                }
                N.push(c);
            }
        } else {
            N = [];
            for(var j = 0; j < n.length; j++)N.push.apply(N, $734947cb21bd6d57$var$expand(n[j], false));
        }
        for(var j = 0; j < N.length; j++)for(var k = 0; k < post.length; k++){
            var expansion = pre + N[j] + post[k];
            if (!isTop || isSequence || expansion) expansions.push(expansion);
        }
    }
    return expansions;
}


const $c20764db574c1db3$var$plTypes = {
    "!": {
        open: "(?:(?!(?:",
        close: "))[^/]*?)"
    },
    "?": {
        open: "(?:",
        close: ")?"
    },
    "+": {
        open: "(?:",
        close: ")+"
    },
    "*": {
        open: "(?:",
        close: ")*"
    },
    "@": {
        open: "(?:",
        close: ")"
    }
};
// any single thing other than /
// don't need to escape / when using new RegExp()
const $c20764db574c1db3$var$qmark = "[^/]";
// * => any number of characters
const $c20764db574c1db3$var$star = $c20764db574c1db3$var$qmark + "*?";
// ** when dots are allowed.  Anything goes, except .. and .
// not (^ or / followed by one or two dots followed by $ or /),
// followed by anything, any number of times.
const $c20764db574c1db3$var$twoStarDot = "(?:(?!(?:\\/|^)(?:\\.{1,2})($|\\/)).)*?";
// not a ^ or / followed by a dot,
// followed by anything, any number of times.
const $c20764db574c1db3$var$twoStarNoDot = "(?:(?!(?:\\/|^)\\.).)*?";
// "abc" -> { a:true, b:true, c:true }
const $c20764db574c1db3$var$charSet = (s)=>s.split("").reduce((set, c)=>{
        set[c] = true;
        return set;
    }, {});
// characters that need to be escaped in RegExp.
const $c20764db574c1db3$var$reSpecials = $c20764db574c1db3$var$charSet("().*{}+?[]^$\\!");
// characters that indicate we have to add the pattern start
const $c20764db574c1db3$var$addPatternStartSet = $c20764db574c1db3$var$charSet("[.(");
// normalizes slashes.
const $c20764db574c1db3$var$slashSplit = /\/+/;
$c20764db574c1db3$var$minimatch.filter = (pattern, options = {})=>(p, i, list)=>$c20764db574c1db3$var$minimatch(p, pattern, options);
const $c20764db574c1db3$var$ext = (a, b = {})=>{
    const t = {};
    Object.keys(a).forEach((k)=>t[k] = a[k]);
    Object.keys(b).forEach((k)=>t[k] = b[k]);
    return t;
};
$c20764db574c1db3$var$minimatch.defaults = (def)=>{
    if (!def || typeof def !== "object" || !Object.keys(def).length) return $c20764db574c1db3$var$minimatch;
    const orig = $c20764db574c1db3$var$minimatch;
    const m = (p, pattern, options)=>orig(p, pattern, $c20764db574c1db3$var$ext(def, options));
    m.Minimatch = class Minimatch extends orig.Minimatch {
        constructor(pattern, options){
            super(pattern, $c20764db574c1db3$var$ext(def, options));
        }
    };
    m.Minimatch.defaults = (options)=>orig.defaults($c20764db574c1db3$var$ext(def, options)).Minimatch;
    m.filter = (pattern, options)=>orig.filter(pattern, $c20764db574c1db3$var$ext(def, options));
    m.defaults = (options)=>orig.defaults($c20764db574c1db3$var$ext(def, options));
    m.makeRe = (pattern, options)=>orig.makeRe(pattern, $c20764db574c1db3$var$ext(def, options));
    m.braceExpand = (pattern, options)=>orig.braceExpand(pattern, $c20764db574c1db3$var$ext(def, options));
    m.match = (list, pattern, options)=>orig.match(list, pattern, $c20764db574c1db3$var$ext(def, options));
    return m;
};
// Brace expansion:
// a{b,c}d -> abd acd
// a{b,}c -> abc ac
// a{0..3}d -> a0d a1d a2d a3d
// a{b,c{d,e}f}g -> abg acdfg acefg
// a{b,c}d{e,f}g -> abdeg acdeg abdeg abdfg
//
// Invalid sets are not expanded.
// a{2..}b -> a{2..}b
// a{b}c -> a{b}c
$c20764db574c1db3$var$minimatch.braceExpand = (pattern, options)=>$c20764db574c1db3$var$braceExpand(pattern, options);
const $c20764db574c1db3$var$braceExpand = (pattern, options = {})=>{
    $c20764db574c1db3$var$assertValidPattern(pattern);
    // Thanks to Yeting Li <https://github.com/yetingli> for
    // improving this regexp to avoid a ReDOS vulnerability.
    if (options.nobrace || !/\{(?:(?!\{).)*\}/.test(pattern)) // shortcut. no need to expand.
    return [
        pattern
    ];
    return $734947cb21bd6d57$exports(pattern);
};
const $c20764db574c1db3$var$MAX_PATTERN_LENGTH = 65536;
const $c20764db574c1db3$var$assertValidPattern = (pattern)=>{
    if (typeof pattern !== "string") throw new TypeError("invalid pattern");
    if (pattern.length > $c20764db574c1db3$var$MAX_PATTERN_LENGTH) throw new TypeError("pattern is too long");
};
// parse a component of the expanded set.
// At this point, no pattern may contain "/" in it
// so we're going to return a 2d array, where each entry is the full
// pattern, split on '/', and then turned into a regular expression.
// A regexp is made at the end which joins each array with an
// escaped /, and another full one which joins each regexp with |.
//
// Following the lead of Bash 4.1, note that "**" only has special meaning
// when it is the *only* thing in a path portion.  Otherwise, any series
// of * is equivalent to a single *.  Globstar behavior is enabled by
// default, and can be disabled by setting options.noglobstar.
const $c20764db574c1db3$var$SUBPARSE = Symbol("subparse");
$c20764db574c1db3$var$minimatch.makeRe = (pattern, options)=>new $c20764db574c1db3$var$Minimatch(pattern, options || {}).makeRe();
$c20764db574c1db3$var$minimatch.match = (list, pattern, options = {})=>{
    const mm = new $c20764db574c1db3$var$Minimatch(pattern, options);
    list = list.filter((f)=>mm.match(f));
    if (mm.options.nonull && !list.length) list.push(pattern);
    return list;
};
// replace stuff like \* with *
const $c20764db574c1db3$var$globUnescape = (s)=>s.replace(/\\(.)/g, "$1");
const $c20764db574c1db3$var$charUnescape = (s)=>s.replace(/\\([^-\]])/g, "$1");
const $c20764db574c1db3$var$regExpEscape = (s)=>s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
const $c20764db574c1db3$var$braExpEscape = (s)=>s.replace(/[[\]\\]/g, "\\$&");
class $c20764db574c1db3$var$Minimatch {
    constructor(pattern, options){
        $c20764db574c1db3$var$assertValidPattern(pattern);
        if (!options) options = {};
        this.options = options;
        this.set = [];
        this.pattern = pattern;
        this.windowsPathsNoEscape = !!options.windowsPathsNoEscape || options.allowWindowsEscape === false;
        if (this.windowsPathsNoEscape) this.pattern = this.pattern.replace(/\\/g, "/");
        this.regexp = null;
        this.negate = false;
        this.comment = false;
        this.empty = false;
        this.partial = !!options.partial;
        // make the set of regexps etc.
        this.make();
    }
    debug() {}
    make() {
        const pattern = this.pattern;
        const options = this.options;
        // empty patterns and comments match nothing.
        if (!options.nocomment && pattern.charAt(0) === "#") {
            this.comment = true;
            return;
        }
        if (!pattern) {
            this.empty = true;
            return;
        }
        // step 1: figure out negation, etc.
        this.parseNegate();
        // step 2: expand braces
        let set = this.globSet = this.braceExpand();
        if (options.debug) this.debug = (...args)=>console.error(...args);
        this.debug(this.pattern, set);
        // step 3: now we have a set, so turn each one into a series of path-portion
        // matching patterns.
        // These will be regexps, except in the case of "**", which is
        // set to the GLOBSTAR object for globstar behavior,
        // and will not contain any / characters
        set = this.globParts = set.map((s)=>s.split($c20764db574c1db3$var$slashSplit));
        this.debug(this.pattern, set);
        // glob --> regexps
        set = set.map((s, si, set)=>s.map(this.parse, this));
        this.debug(this.pattern, set);
        // filter out everything that didn't compile properly.
        set = set.filter((s)=>s.indexOf(false) === -1);
        this.debug(this.pattern, set);
        this.set = set;
    }
    parseNegate() {
        if (this.options.nonegate) return;
        const pattern = this.pattern;
        let negate = false;
        let negateOffset = 0;
        for(let i = 0; i < pattern.length && pattern.charAt(i) === "!"; i++){
            negate = !negate;
            negateOffset++;
        }
        if (negateOffset) this.pattern = pattern.slice(negateOffset);
        this.negate = negate;
    }
    // set partial to true to test if, for example,
    // "/a/b" matches the start of "/*/b/*/d"
    // Partial means, if you run out of file before you run
    // out of pattern, then that's fine, as long as all
    // the parts match.
    matchOne(file, pattern, partial) {
        var options = this.options;
        this.debug("matchOne", {
            "this": this,
            file: file,
            pattern: pattern
        });
        this.debug("matchOne", file.length, pattern.length);
        for(var fi = 0, pi = 0, fl = file.length, pl = pattern.length; fi < fl && pi < pl; fi++, pi++){
            this.debug("matchOne loop");
            var p = pattern[pi];
            var f = file[fi];
            this.debug(pattern, p, f);
            // should be impossible.
            // some invalid regexp stuff in the set.
            /* istanbul ignore if */ if (p === false) return false;
            if (p === $c20764db574c1db3$var$GLOBSTAR) {
                this.debug("GLOBSTAR", [
                    pattern,
                    p,
                    f
                ]);
                // "**"
                // a/**/b/**/c would match the following:
                // a/b/x/y/z/c
                // a/x/y/z/b/c
                // a/b/x/b/x/c
                // a/b/c
                // To do this, take the rest of the pattern after
                // the **, and see if it would match the file remainder.
                // If so, return success.
                // If not, the ** "swallows" a segment, and try again.
                // This is recursively awful.
                //
                // a/**/b/**/c matching a/b/x/y/z/c
                // - a matches a
                // - doublestar
                //   - matchOne(b/x/y/z/c, b/**/c)
                //     - b matches b
                //     - doublestar
                //       - matchOne(x/y/z/c, c) -> no
                //       - matchOne(y/z/c, c) -> no
                //       - matchOne(z/c, c) -> no
                //       - matchOne(c, c) yes, hit
                var fr = fi;
                var pr = pi + 1;
                if (pr === pl) {
                    this.debug("** at the end");
                    // a ** at the end will just swallow the rest.
                    // We have found a match.
                    // however, it will not swallow /.x, unless
                    // options.dot is set.
                    // . and .. are *never* matched by **, for explosively
                    // exponential reasons.
                    for(; fi < fl; fi++){
                        if (file[fi] === "." || file[fi] === ".." || !options.dot && file[fi].charAt(0) === ".") return false;
                    }
                    return true;
                }
                // ok, let's see if we can swallow whatever we can.
                while(fr < fl){
                    var swallowee = file[fr];
                    this.debug("\nglobstar while", file, fr, pattern, pr, swallowee);
                    // XXX remove this slice.  Just pass the start index.
                    if (this.matchOne(file.slice(fr), pattern.slice(pr), partial)) {
                        this.debug("globstar found match!", fr, fl, swallowee);
                        // found a match.
                        return true;
                    } else {
                        // can't swallow "." or ".." ever.
                        // can only swallow ".foo" when explicitly asked.
                        if (swallowee === "." || swallowee === ".." || !options.dot && swallowee.charAt(0) === ".") {
                            this.debug("dot detected!", file, fr, pattern, pr);
                            break;
                        }
                        // ** swallows a segment, and continue.
                        this.debug("globstar swallow a segment, and continue");
                        fr++;
                    }
                }
                // no match was found.
                // However, in partial mode, we can't say this is necessarily over.
                // If there's more *pattern* left, then
                /* istanbul ignore if */ if (partial) {
                    // ran out of file
                    this.debug("\n>>> no match, partial?", file, fr, pattern, pr);
                    if (fr === fl) return true;
                }
                return false;
            }
            // something other than **
            // non-magic patterns just have to match exactly
            // patterns with magic have been turned into regexps.
            var hit;
            if (typeof p === "string") {
                hit = f === p;
                this.debug("string match", p, f, hit);
            } else {
                hit = f.match(p);
                this.debug("pattern match", p, f, hit);
            }
            if (!hit) return false;
        }
        // Note: ending in / means that we'll get a final ""
        // at the end of the pattern.  This can only match a
        // corresponding "" at the end of the file.
        // If the file ends in /, then it can only match a
        // a pattern that ends in /, unless the pattern just
        // doesn't have any more for it. But, a/b/ should *not*
        // match "a/b/*", even though "" matches against the
        // [^/]*? pattern, except in partial mode, where it might
        // simply not be reached yet.
        // However, a/b/ should still satisfy a/*
        // now either we fell off the end of the pattern, or we're done.
        if (fi === fl && pi === pl) // ran out of pattern and filename at the same time.
        // an exact hit!
        return true;
        else if (fi === fl) // ran out of file, but still had pattern left.
        // this is ok if we're doing the match as part of
        // a glob fs traversal.
        return partial;
        else /* istanbul ignore else */ if (pi === pl) // ran out of pattern, still have file left.
        // this is only acceptable if we're on the very last
        // empty segment of a file with a trailing slash.
        // a/* should match a/b/
        return fi === fl - 1 && file[fi] === "";
        // should be unreachable.
        /* istanbul ignore next */ throw new Error("wtf?");
    }
    braceExpand() {
        return $c20764db574c1db3$var$braceExpand(this.pattern, this.options);
    }
    parse(pattern, isSub) {
        $c20764db574c1db3$var$assertValidPattern(pattern);
        const options = this.options;
        // shortcuts
        if (pattern === "**") {
            if (!options.noglobstar) return $c20764db574c1db3$var$GLOBSTAR;
            else pattern = "*";
        }
        if (pattern === "") return "";
        let re = "";
        let hasMagic = false;
        let escaping = false;
        // ? => one single character
        const patternListStack = [];
        const negativeLists = [];
        let stateChar;
        let inClass = false;
        let reClassStart = -1;
        let classStart = -1;
        let cs;
        let pl;
        let sp;
        // . and .. never match anything that doesn't start with .,
        // even when options.dot is set.  However, if the pattern
        // starts with ., then traversal patterns can match.
        let dotTravAllowed = pattern.charAt(0) === ".";
        let dotFileAllowed = options.dot || dotTravAllowed;
        const patternStart = ()=>dotTravAllowed ? "" : dotFileAllowed ? "(?!(?:^|\\/)\\.{1,2}(?:$|\\/))" : "(?!\\.)";
        const subPatternStart = (p)=>p.charAt(0) === "." ? "" : options.dot ? "(?!(?:^|\\/)\\.{1,2}(?:$|\\/))" : "(?!\\.)";
        const clearStateChar = ()=>{
            if (stateChar) {
                // we had some state-tracking character
                // that wasn't consumed by this pass.
                switch(stateChar){
                    case "*":
                        re += $c20764db574c1db3$var$star;
                        hasMagic = true;
                        break;
                    case "?":
                        re += $c20764db574c1db3$var$qmark;
                        hasMagic = true;
                        break;
                    default:
                        re += "\\" + stateChar;
                        break;
                }
                this.debug("clearStateChar %j %j", stateChar, re);
                stateChar = false;
            }
        };
        for(let i = 0, c; i < pattern.length && (c = pattern.charAt(i)); i++){
            this.debug("%s	%s %s %j", pattern, i, re, c);
            // skip over any that are escaped.
            if (escaping) {
                /* istanbul ignore next - completely not allowed, even escaped. */ if (c === "/") return false;
                if ($c20764db574c1db3$var$reSpecials[c]) re += "\\";
                re += c;
                escaping = false;
                continue;
            }
            switch(c){
                /* istanbul ignore next */ case "/":
                    // Should already be path-split by now.
                    return false;
                case "\\":
                    if (inClass && pattern.charAt(i + 1) === "-") {
                        re += c;
                        continue;
                    }
                    clearStateChar();
                    escaping = true;
                    continue;
                // the various stateChar values
                // for the "extglob" stuff.
                case "?":
                case "*":
                case "+":
                case "@":
                case "!":
                    this.debug("%s	%s %s %j <-- stateChar", pattern, i, re, c);
                    // all of those are literals inside a class, except that
                    // the glob [!a] means [^a] in regexp
                    if (inClass) {
                        this.debug("  in class");
                        if (c === "!" && i === classStart + 1) c = "^";
                        re += c;
                        continue;
                    }
                    // if we already have a stateChar, then it means
                    // that there was something like ** or +? in there.
                    // Handle the stateChar, then proceed with this one.
                    this.debug("call clearStateChar %j", stateChar);
                    clearStateChar();
                    stateChar = c;
                    // if extglob is disabled, then +(asdf|foo) isn't a thing.
                    // just clear the statechar *now*, rather than even diving into
                    // the patternList stuff.
                    if (options.noext) clearStateChar();
                    continue;
                case "(":
                    {
                        if (inClass) {
                            re += "(";
                            continue;
                        }
                        if (!stateChar) {
                            re += "\\(";
                            continue;
                        }
                        const plEntry = {
                            type: stateChar,
                            start: i - 1,
                            reStart: re.length,
                            open: $c20764db574c1db3$var$plTypes[stateChar].open,
                            close: $c20764db574c1db3$var$plTypes[stateChar].close
                        };
                        this.debug(this.pattern, "	", plEntry);
                        patternListStack.push(plEntry);
                        // negation is (?:(?!(?:js)(?:<rest>))[^/]*)
                        re += plEntry.open;
                        // next entry starts with a dot maybe?
                        if (plEntry.start === 0 && plEntry.type !== "!") {
                            dotTravAllowed = true;
                            re += subPatternStart(pattern.slice(i + 1));
                        }
                        this.debug("plType %j %j", stateChar, re);
                        stateChar = false;
                        continue;
                    }
                case ")":
                    {
                        const plEntry = patternListStack[patternListStack.length - 1];
                        if (inClass || !plEntry) {
                            re += "\\)";
                            continue;
                        }
                        patternListStack.pop();
                        // closing an extglob
                        clearStateChar();
                        hasMagic = true;
                        pl = plEntry;
                        // negation is (?:(?!js)[^/]*)
                        // The others are (?:<pattern>)<type>
                        re += pl.close;
                        if (pl.type === "!") negativeLists.push(Object.assign(pl, {
                            reEnd: re.length
                        }));
                        continue;
                    }
                case "|":
                    {
                        const plEntry = patternListStack[patternListStack.length - 1];
                        if (inClass || !plEntry) {
                            re += "\\|";
                            continue;
                        }
                        clearStateChar();
                        re += "|";
                        // next subpattern can start with a dot?
                        if (plEntry.start === 0 && plEntry.type !== "!") {
                            dotTravAllowed = true;
                            re += subPatternStart(pattern.slice(i + 1));
                        }
                        continue;
                    }
                // these are mostly the same in regexp and glob
                case "[":
                    // swallow any state-tracking char before the [
                    clearStateChar();
                    if (inClass) {
                        re += "\\" + c;
                        continue;
                    }
                    inClass = true;
                    classStart = i;
                    reClassStart = re.length;
                    re += c;
                    continue;
                case "]":
                    //  a right bracket shall lose its special
                    //  meaning and represent itself in
                    //  a bracket expression if it occurs
                    //  first in the list.  -- POSIX.2 2.8.3.2
                    if (i === classStart + 1 || !inClass) {
                        re += "\\" + c;
                        continue;
                    }
                    // split where the last [ was, make sure we don't have
                    // an invalid re. if so, re-walk the contents of the
                    // would-be class to re-translate any characters that
                    // were passed through as-is
                    // TODO: It would probably be faster to determine this
                    // without a try/catch and a new RegExp, but it's tricky
                    // to do safely.  For now, this is safe and works.
                    cs = pattern.substring(classStart + 1, i);
                    try {
                        RegExp("[" + $c20764db574c1db3$var$braExpEscape($c20764db574c1db3$var$charUnescape(cs)) + "]");
                        // looks good, finish up the class.
                        re += c;
                    } catch (er) {
                        // out of order ranges in JS are errors, but in glob syntax,
                        // they're just a range that matches nothing.
                        re = re.substring(0, reClassStart) + "(?:$.)" // match nothing ever
                        ;
                    }
                    hasMagic = true;
                    inClass = false;
                    continue;
                default:
                    // swallow any state char that wasn't consumed
                    clearStateChar();
                    if ($c20764db574c1db3$var$reSpecials[c] && !(c === "^" && inClass)) re += "\\";
                    re += c;
                    break;
            } // switch
        } // for
        // handle the case where we left a class open.
        // "[abc" is valid, equivalent to "\[abc"
        if (inClass) {
            // split where the last [ was, and escape it
            // this is a huge pita.  We now have to re-walk
            // the contents of the would-be class to re-translate
            // any characters that were passed through as-is
            cs = pattern.slice(classStart + 1);
            sp = this.parse(cs, $c20764db574c1db3$var$SUBPARSE);
            re = re.substring(0, reClassStart) + "\\[" + sp[0];
            hasMagic = hasMagic || sp[1];
        }
        // handle the case where we had a +( thing at the *end*
        // of the pattern.
        // each pattern list stack adds 3 chars, and we need to go through
        // and escape any | chars that were passed through as-is for the regexp.
        // Go through and escape them, taking care not to double-escape any
        // | chars that were already escaped.
        for(pl = patternListStack.pop(); pl; pl = patternListStack.pop()){
            let tail;
            tail = re.slice(pl.reStart + pl.open.length);
            this.debug("setting tail", re, pl);
            // maybe some even number of \, then maybe 1 \, followed by a |
            tail = tail.replace(/((?:\\{2}){0,64})(\\?)\|/g, (_, $1, $2)=>{
                /* istanbul ignore else - should already be done */ if (!$2) // the | isn't already escaped, so escape it.
                $2 = "\\";
                // need to escape all those slashes *again*, without escaping the
                // one that we need for escaping the | character.  As it works out,
                // escaping an even number of slashes can be done by simply repeating
                // it exactly after itself.  That's why this trick works.
                //
                // I am sorry that you have to see this.
                return $1 + $1 + $2 + "|";
            });
            this.debug("tail=%j\n   %s", tail, tail, pl, re);
            const t = pl.type === "*" ? $c20764db574c1db3$var$star : pl.type === "?" ? $c20764db574c1db3$var$qmark : "\\" + pl.type;
            hasMagic = true;
            re = re.slice(0, pl.reStart) + t + "\\(" + tail;
        }
        // handle trailing things that only matter at the very end.
        clearStateChar();
        if (escaping) // trailing \\
        re += "\\\\";
        // only need to apply the nodot start if the re starts with
        // something that could conceivably capture a dot
        const addPatternStart = $c20764db574c1db3$var$addPatternStartSet[re.charAt(0)];
        // Hack to work around lack of negative lookbehind in JS
        // A pattern like: *.!(x).!(y|z) needs to ensure that a name
        // like 'a.xyz.yz' doesn't match.  So, the first negative
        // lookahead, has to look ALL the way ahead, to the end of
        // the pattern.
        for(let n = negativeLists.length - 1; n > -1; n--){
            const nl = negativeLists[n];
            const nlBefore = re.slice(0, nl.reStart);
            const nlFirst = re.slice(nl.reStart, nl.reEnd - 8);
            let nlAfter = re.slice(nl.reEnd);
            const nlLast = re.slice(nl.reEnd - 8, nl.reEnd) + nlAfter;
            // Handle nested stuff like *(*.js|!(*.json)), where open parens
            // mean that we should *not* include the ) in the bit that is considered
            // "after" the negated section.
            const closeParensBefore = nlBefore.split(")").length;
            const openParensBefore = nlBefore.split("(").length - closeParensBefore;
            let cleanAfter = nlAfter;
            for(let i = 0; i < openParensBefore; i++)cleanAfter = cleanAfter.replace(/\)[+*?]?/, "");
            nlAfter = cleanAfter;
            const dollar = nlAfter === "" && isSub !== $c20764db574c1db3$var$SUBPARSE ? "(?:$|\\/)" : "";
            re = nlBefore + nlFirst + nlAfter + dollar + nlLast;
        }
        // if the re is not "" at this point, then we need to make sure
        // it doesn't match against an empty path part.
        // Otherwise a/* will match a/, which it should not.
        if (re !== "" && hasMagic) re = "(?=.)" + re;
        if (addPatternStart) re = patternStart() + re;
        // parsing just a piece of a larger pattern.
        if (isSub === $c20764db574c1db3$var$SUBPARSE) return [
            re,
            hasMagic
        ];
        // if it's nocase, and the lcase/uppercase don't match, it's magic
        if (options.nocase && !hasMagic) hasMagic = pattern.toUpperCase() !== pattern.toLowerCase();
        // skip the regexp for non-magical patterns
        // unescape anything in it, though, so that it'll be
        // an exact match against a file etc.
        if (!hasMagic) return $c20764db574c1db3$var$globUnescape(pattern);
        const flags = options.nocase ? "i" : "";
        try {
            return Object.assign(new RegExp("^" + re + "$", flags), {
                _glob: pattern,
                _src: re
            });
        } catch (er) /* istanbul ignore next - should be impossible */ {
            // If it was an invalid regular expression, then it can't match
            // anything.  This trick looks for a character after the end of
            // the string, which is of course impossible, except in multi-line
            // mode, but it's not a /m regex.
            return new RegExp("$.");
        }
    }
    makeRe() {
        if (this.regexp || this.regexp === false) return this.regexp;
        // at this point, this.set is a 2d array of partial
        // pattern strings, or "**".
        //
        // It's better to use .match().  This function shouldn't
        // be used, really, but it's pretty convenient sometimes,
        // when you just want to work with a regex.
        const set = this.set;
        if (!set.length) {
            this.regexp = false;
            return this.regexp;
        }
        const options = this.options;
        const twoStar = options.noglobstar ? $c20764db574c1db3$var$star : options.dot ? $c20764db574c1db3$var$twoStarDot : $c20764db574c1db3$var$twoStarNoDot;
        const flags = options.nocase ? "i" : "";
        // coalesce globstars and regexpify non-globstar patterns
        // if it's the only item, then we just do one twoStar
        // if it's the first, and there are more, prepend (\/|twoStar\/)? to next
        // if it's the last, append (\/twoStar|) to previous
        // if it's in the middle, append (\/|\/twoStar\/) to previous
        // then filter out GLOBSTAR symbols
        let re = set.map((pattern)=>{
            pattern = pattern.map((p)=>typeof p === "string" ? $c20764db574c1db3$var$regExpEscape(p) : p === $c20764db574c1db3$var$GLOBSTAR ? $c20764db574c1db3$var$GLOBSTAR : p._src).reduce((set, p)=>{
                if (!(set[set.length - 1] === $c20764db574c1db3$var$GLOBSTAR && p === $c20764db574c1db3$var$GLOBSTAR)) set.push(p);
                return set;
            }, []);
            pattern.forEach((p, i)=>{
                if (p !== $c20764db574c1db3$var$GLOBSTAR || pattern[i - 1] === $c20764db574c1db3$var$GLOBSTAR) return;
                if (i === 0) {
                    if (pattern.length > 1) pattern[i + 1] = "(?:\\/|" + twoStar + "\\/)?" + pattern[i + 1];
                    else pattern[i] = twoStar;
                } else if (i === pattern.length - 1) pattern[i - 1] += "(?:\\/|" + twoStar + ")?";
                else {
                    pattern[i - 1] += "(?:\\/|\\/" + twoStar + "\\/)" + pattern[i + 1];
                    pattern[i + 1] = $c20764db574c1db3$var$GLOBSTAR;
                }
            });
            return pattern.filter((p)=>p !== $c20764db574c1db3$var$GLOBSTAR).join("/");
        }).join("|");
        // must match entire pattern
        // ending in a * or ** will make it less strict.
        re = "^(?:" + re + ")$";
        // can match anything, as long as it's not this.
        if (this.negate) re = "^(?!" + re + ").*$";
        try {
            this.regexp = new RegExp(re, flags);
        } catch (ex) /* istanbul ignore next - should be impossible */ {
            this.regexp = false;
        }
        return this.regexp;
    }
    match(f, partial = this.partial) {
        this.debug("match", f, this.pattern);
        // short-circuit in the case of busted things.
        // comments, etc.
        if (this.comment) return false;
        if (this.empty) return f === "";
        if (f === "/" && partial) return true;
        const options = this.options;
        // windows: need to use /, not \
        if ($5199c9967acba189$exports.sep !== "/") f = f.split($5199c9967acba189$exports.sep).join("/");
        // treat the test path as a set of pathparts.
        f = f.split($c20764db574c1db3$var$slashSplit);
        this.debug(this.pattern, "split", f);
        // just ONE of the pattern sets in this.set needs to match
        // in order for it to be valid.  If negating, then just one
        // match means that we have failed.
        // Either way, return on the first hit.
        const set = this.set;
        this.debug(this.pattern, "set", set);
        // Find the basename of the path by looking for the last non-empty segment
        let filename;
        for(let i = f.length - 1; i >= 0; i--){
            filename = f[i];
            if (filename) break;
        }
        for(let i = 0; i < set.length; i++){
            const pattern = set[i];
            let file = f;
            if (options.matchBase && pattern.length === 1) file = [
                filename
            ];
            const hit = this.matchOne(file, pattern, partial);
            if (hit) {
                if (options.flipNegate) return true;
                return !this.negate;
            }
        }
        // didn't get any hits.  this is success if it's a negative
        // pattern, failure otherwise.
        if (options.flipNegate) return false;
        return this.negate;
    }
    static defaults(def) {
        return $c20764db574c1db3$var$minimatch.defaults(def).Minimatch;
    }
}
$c20764db574c1db3$var$minimatch.Minimatch = $c20764db574c1db3$var$Minimatch;


class $a8efcbda4713a3fe$export$2e2bcd8739ae039 extends (0, $b61520fd682d0ff5$export$2e2bcd8739ae039) {
    /**
     * @typedef {Object} Frame
     * @prop {Number} x - Horizontal position
     * @prop {Number} y - Vertical position
     * @prop {Number} w - Width
     * @prop {Number} h - Height
     */ /**
     * @typedef {Object} FrameData
     * @prop {Frame} frame - Data about this frame in the sprite-sheet
     * @prop {Frame} spriteSourceSize - Data about the original file
     */ /**
     * Sprite constructor
     * @param {PositionDefinition} positionDefinition -
     * @param {String} url -
     * @param {Array<FrameData>} frames -
     * @param {SpriteOptions} [options] - Drawing options
     */ constructor(positionDefinition, url, frames, options){
        super(positionDefinition, url, options);
        this.frames = frames;
        this.frame = 0;
        this.isPaused = false;
    }
    /**
     * @inheritDoc
     * @return {Sprite} Itself
     */ makePath(ctx) {
        const { sourceSize: sourceSize } = this.frames[Math.floor(this.frame)];
        this.width = sourceSize.w;
        this.height = sourceSize.h;
        super.makePath(ctx);
        if (this.isLoaded) {
            const frameNumber = Math.floor(this.frame);
            if (!this.isPaused && (this.options.loop || this.frame < this.frames.length - 1)) this.setFrame(this.frame + this.options.speed);
            const nextFrame = Math.floor(this.frame);
            if (nextFrame !== frameNumber) {
                this.fire(new (0, $1aed883b78728e08$export$2e2bcd8739ae039)($a8efcbda4713a3fe$export$2e2bcd8739ae039.events.frame, this));
                if (!this.options.loop && nextFrame === this.frames.length - 1) this.fire(new (0, $1aed883b78728e08$export$2e2bcd8739ae039)($a8efcbda4713a3fe$export$2e2bcd8739ae039.events.end, this));
            }
        }
        return this;
    }
    /**
     * @inheritDoc
     * @return {Sprite} Itself
     */ draw(ctx) {
        const { frame: frame, spriteSourceSize: spriteSourceSize } = this.frames[Math.floor(this.frame)];
        ctx.drawImage(this.file, frame.x, frame.y, frame.w, frame.h, spriteSourceSize.x, spriteSourceSize.y, spriteSourceSize.w, spriteSourceSize.h);
        return this;
    }
    /**
     * Play the sprite animation
     * @param {Number} [speed] - Choose a play speed
     * @return {Sprite} Itself
     */ play(speed) {
        this.isPaused = false;
        if (speed !== undefined) this.options.speed = speed;
        return this;
    }
    /**
     * Put the sprite on pause
     * @return {Sprite} Itself
     */ pause() {
        this.isPaused = true;
        return this;
    }
    /**
     *
     * @param {Number} frame - Number of the frame to set
     * @return {Sprite} Itself
     */ setFrame(frame) {
        this.frame = (0, $26d060ef72148247$export$ba467bec01d66def)(frame, this.frames.length);
        return this;
    }
    /**
     * @inheritDoc
     */ toJSON() {
        const { frames: frames, frame: frame, isPaused: isPaused } = this;
        return {
            ...super.toJSON(),
            frames: frames,
            frame: frame,
            isPaused: isPaused
        };
    }
    /**
     *
     * @param {Object} definition -
     * @return {Sprite}
     */ static from(definition) {
        const { position: position, url: url, frames: frames, frame: frame, isPaused: isPaused, options: options } = definition;
        const sprite = new $a8efcbda4713a3fe$export$2e2bcd8739ae039(position, url, frames, options);
        sprite.setFrame(frame);
        if (isPaused) sprite.pause();
        return sprite;
    }
    /**
     * Load and return a spritesheet json file
     * @param {String} url - Url to the file
     * @return {Spritesheet}
     */ static async sheet(url) {
        const response = await window.fetch(url);
        const json = await response.json();
        json.meta.file = await this.load(json.meta.image);
        // eslint-disable-next-line no-use-before-define
        return new $a8efcbda4713a3fe$var$Spritesheet(json);
    }
    /**
     * @typedef {Object} SpriteOptions
     * @extends ComponentOptions
     * @prop {Number} [speed=1] -
     * @prop {Boolean} [loop=true] -
     */ /**
     * @type {SpriteOptions}
     */ static get defaultOptions() {
        return {
            ...super.defaultOptions,
            speed: 1,
            loop: true
        };
    }
    /**
     * @typedef {Object} SpriteEvents
     * @extends ContainerEvent
     * @prop {String} start -
     * @prop {String} frame -
     * @prop {String} end -
     */ /**
     * @type {SpriteEvents}
     */ static get events() {
        return {
            ...super.events,
            start: "sprite-start",
            frame: "sprite-frame",
            end: "sprite-end"
        };
    }
}
/**
 * Spritesheet class
 * @class
 */ class $a8efcbda4713a3fe$var$Spritesheet {
    /**
     * Spritesheet constructor
     * @param {Object} json -
     */ constructor(json){
        this.json = json;
    }
    /**
     * Getter for the image file
     * @return {Image}
     */ get file() {
        return this.json.meta.file;
    }
    /**
     * Return all the frames corresponding to a selector
     * @param {String|Function|RegExp} [selector="*"] - Match against the spritesheet images name using a glob pattern, a validation function or a regular expression
     * @return {Array}
     */ get(selector = "*") {
        const filter = ((matcher)=>{
            if (typeof matcher === "function") return matcher;
            if (typeof matcher === "string") {
                const glob = new (0, (/*@__PURE__*/$parcel$interopDefault($c20764db574c1db3$exports))).Minimatch(matcher, {
                    dot: true,
                    matchBase: true
                });
                return (string)=>matcher === string || glob.match(string);
            }
            if (matcher instanceof RegExp) return (string)=>matcher.test(string);
            return ()=>false;
        })(selector);
        const { frames: frames } = this.json;
        return Object.keys(frames).filter(filter).map((key)=>frames[key]);
    }
    /**
     * Group images from the spritesheet into a single sprite
     * @param {PositionDefinition} position - Position of the sprite
     * @param {String|Function|RegExp} [selector="*"] - Match against the spritesheet images name using a glob pattern, a validation function or a regular expression
     * @param {ImageOptions} [options] - Options of the sprite
     * @return {Sprite}
     */ extract(position, selector, options) {
        return new $a8efcbda4713a3fe$export$2e2bcd8739ae039(position, this.file, this.get(selector), options);
    }
}





class $d7b76b7e3153c630$export$2e2bcd8739ae039 extends (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039) {
    /**
     * Input constructor
     * @param {PositionDefinition} positionDefinition - Any position
     * @param {Component} base - Base shape for the background
     * @param {InputOptions} [options] - Specific options
     */ constructor(positionDefinition, base, options){
        super(positionDefinition, options);
        this.base = base;
        let fill;
        this.on((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.hover, ()=>{
            fill = fill || this.options.fill;
            this.options.fill = this.options.hover;
        }).on((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.leave, ()=>{
            this.options.fill = fill;
            fill = null;
        }).on((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.click, (event)=>{
            this.click(event.position.clone().subtract(this.getAbsolutePosition()));
        });
        this.on((0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).events.attach, ()=>this.value = this.options.value, true);
    }
    /**
     * @inheritDoc
     */ trace(path) {
        return this.base.prototype.trace.call(this, path);
    }
    /**
     * @inheritDoc
     */ getOrigin() {
        return this.base.prototype.getOrigin.call(this);
    }
    /**
     * Return the value of the input
     */ get value() {
        throw new ReferenceError(`Unimplemented get value function in ${this.constructor.name}`);
    }
    /**
     * Set the value of the input
     * @param {*} value - Any value
     */ set value(value) {
        throw new ReferenceError(`Unimplemented set value function in ${this.constructor.name}`);
    }
    /**
     * Action to execute on click
     */ click() {
        this.fire(new (0, $1aed883b78728e08$export$2e2bcd8739ae039)($d7b76b7e3153c630$export$2e2bcd8739ae039.events.change, this));
    }
    /**
     * @inheritDoc
     */ toJSON() {
        const json = super.toJSON();
        json.options = json.options || {};
        json.options.value = this.value;
        return json;
    }
    /**
     * @inheritDoc
     * @param {Object} definition - Input definition
     * @return {Input}
     */ static from(definition) {
        return new this(definition.position, definition.options);
    }
    /**
     * @typedef {Object} InputOptions
     * @extends ComponentOptions
     * @prop {*} [value=null] - Initial value of the input
     * @prop {String} [foreground="#444"] - Color of the filling
     * @prop {String} [fill="#f6f6f6"] - Color of the background
     * @prop {String} [border="#aaa"] - Color of the border
     * @prop {String} [hover="#d0d0d0"] - Color of the background when hovered
     * @prop {String} [cursor=Component.cursors.pointer] - Cursor on hover
     */ /**
     * @type {InputOptions}
     */ static get defaultOptions() {
        return {
            ...super.defaultOptions,
            value: null,
            foreground: "#444",
            fill: "#f6f6f6",
            stroke: "#aaa",
            hover: "#dcdcdc",
            cursor: (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).cursors.pointer
        };
    }
    /**
     * @typedef {Object} InputEvents
     * @prop {String} change - Input value has changed
     */ /**
     * @type {InputEvents}
     */ static get events() {
        return {
            ...super.events,
            change: "change"
        };
    }
}





class $4509ca553fe002b7$export$2e2bcd8739ae039 extends (0, $d7b76b7e3153c630$export$2e2bcd8739ae039) {
    /**
     * Button constructor
     * @param {PositionDefinition} positionDefinition - Position of the top-left corner
     * @param {ButtonOptions} [options] - Specific options
     */ constructor(positionDefinition, options){
        super(positionDefinition, (0, $b5f43a4eeef4cb6f$export$2e2bcd8739ae039), options);
        this.text = new (0, $0c4e551c62a7aa5b$export$2e2bcd8739ae039)(undefined, this.options.value, {
            fill: this.options.foreground,
            cursor: this.options.cursor,
            font: this.options.font,
            fontSize: this.options.fontSize,
            align: this.options.align,
            bold: this.options.bold,
            italic: this.options.italic,
            underscore: this.options.underscore,
            lineHeight: this.options.lineHeight
        });
        this.add(this.text);
    }
    /**
     * Computer button size
     * @return {{width: Number, height: Number}}
     */ get size() {
        const measures = this.text.getMeasures();
        const margin = (0, $0c4e551c62a7aa5b$export$2e2bcd8739ae039).measure("M", this.text.options).height * $4509ca553fe002b7$export$2e2bcd8739ae039.MARGIN;
        return {
            width: measures.width + margin * 4,
            height: measures.height + margin * 2
        };
    }
    /**
     * Get this button's width
     * @return {Number}
     */ get width() {
        return this.size.width;
    }
    /**
     * Get this button's height
     * @return {Number}
     */ get height() {
        return this.size.height;
    }
    /**
     * @inheritDoc
     */ click() {
    // TODO: need visual feedback
    // do not call super.click on purpose, don't need to fire "change" on a button
    }
    /**
     * Return this button's text
     * @return {String}
     */ get value() {
        return this.text.text;
    }
    /**
     * Change this button's text
     * @param {String|Array<String>} value - Any text or list of line
     */ set value(value) {
        this.text.text = value;
        const margin = (0, $0c4e551c62a7aa5b$export$2e2bcd8739ae039).measure("M", this.text.options).height * $4509ca553fe002b7$export$2e2bcd8739ae039.MARGIN;
        this.text.position.set(this.getOrigin()).add(margin * 2, margin);
    }
    /**
     * @typedef {Object} ButtonOptions
     * @extends TextOptions
     * @extends InputOptions
     * @prop {String} [value=""] - Text of the button
     */ /**
     * @type {ButtonOptions}
     */ static get defaultOptions() {
        return {
            ...(0, $0c4e551c62a7aa5b$export$2e2bcd8739ae039).defaultOptions,
            ...super.defaultOptions,
            value: ""
        };
    }
    /**
     * Margin around the text
     * @type {Number}
     */ static get MARGIN() {
        return 0.2;
    }
}




class $5f8efce6271bc06d$export$2e2bcd8739ae039 extends (0, $d7b76b7e3153c630$export$2e2bcd8739ae039) {
    /**
     * Checkbox constructor
     * @param {PositionDefinition} positionDefinition - Top-left corner
     * @param {CheckboxOptions} [options] - Specific options
     */ constructor(positionDefinition, options){
        super(positionDefinition, (0, $ddc9f679561154f9$export$2e2bcd8739ae039), options);
        const margin = this.options.size * $5f8efce6271bc06d$export$2e2bcd8739ae039.MARGIN;
        this.fill = new (0, $ddc9f679561154f9$export$2e2bcd8739ae039)([
            margin,
            margin
        ], this.options.size - 2 * margin, {
            fill: this.options.foreground,
            shown: this.options.value,
            cursor: this.options.cursor,
            origin: this.getOrigin()
        });
        this.add(this.fill);
    }
    /**
     * Get it's width
     * @return {Number}
     */ get width() {
        return this.options.size;
    }
    /**
     * Set it's width
     * @param {Number} value - Width of the checkbox
     */ set width(value) {
        this.options.size = value;
    }
    /**
     * Get it's height
     * @return {Number}
     */ get height() {
        return this.options.size;
    }
    /**
     * Set it's height
     * @param {Number} value - Height of the checkbox
     */ set height(value) {
        this.options.size = value;
    }
    /**
     * @inheritDoc
     */ click() {
        this.toggle();
        super.click();
    }
    /**
     * Inverse whether it's checked
     * @param {Boolean} [newValue] - If defined, will force the value
     * @return {Boolean}
     */ toggle(newValue = !this.value) {
        this.value = newValue;
        return newValue;
    }
    /**
     * Return whether it's checked
     * @return {Boolean}
     */ get value() {
        return this.fill.options.shown;
    }
    /**
     * Change whether it's checked
     * @param {Boolean} value - New value
     */ set value(value) {
        if (value) this.fill.show();
        else this.fill.hide();
    }
    /**
     * @typedef {Object} CheckboxOptions
     * @extends InputOptions
     * @prop {Number} [size=20] - Width and height of the checkbox
     * @prop {Boolean} [value=false] - Whether it's check ot not
     */ /**
     * @type {CheckboxOptions}
     */ static get defaultOptions() {
        return {
            ...super.defaultOptions,
            size: 20,
            value: false
        };
    }
    /**
     * Margin around the filling square in ratio
     * @type {Number}
     */ static get MARGIN() {
        return 0.2;
    }
}










/**
 * @module Select
 */ const $adb4f6d12e6abfca$var$selectedKey = Symbol("_selected");
class $adb4f6d12e6abfca$export$2e2bcd8739ae039 extends (0, $d7b76b7e3153c630$export$2e2bcd8739ae039) {
    /**
     * Select constructor
     * @param {PositionDefinition} positionDefinition - Any position
     * @param {Array<String>} optionsList - List of options to display
     * @param {InputOptions} [options] - Drawing options
     */ constructor(positionDefinition, optionsList, options){
        if (!optionsList.length) throw new RangeError("Options list should have at least one item.");
        super(positionDefinition, (0, $b5f43a4eeef4cb6f$export$2e2bcd8739ae039), options);
        this[$adb4f6d12e6abfca$var$selectedKey] = 0;
        const textOptions = {
            cursor: (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).cursors.pointer,
            fill: this.options.foreground,
            font: this.options.font,
            fontSize: this.options.fontSize,
            align: this.options.align,
            bold: this.options.bold,
            italic: this.options.italic,
            underscore: this.options.underscore,
            lineHeight: this.options.lineHeight
        };
        const margin = (0, $0c4e551c62a7aa5b$export$2e2bcd8739ae039).measure("M", textOptions).height * $adb4f6d12e6abfca$export$2e2bcd8739ae039.MARGIN;
        this.display = new (0, $0c4e551c62a7aa5b$export$2e2bcd8739ae039)(undefined, "", textOptions);
        this.optionsList = optionsList.map((option)=>new (0, $0c4e551c62a7aa5b$export$2e2bcd8739ae039)([
                margin * 2 - 1,
                margin
            ], option || "", textOptions));
        const maxWidth = Math.max(...this.optionsList.map((text)=>text.width));
        textOptions.origin = [
            maxWidth * this.display.getAlignOffset(),
            0
        ];
        this.optionsContainer = new (0, $b5f43a4eeef4cb6f$export$2e2bcd8739ae039)(undefined, this.width, 0, {
            fill: this.options.fill,
            stroke: this.options.stroke,
            strokeWidth: this.options.strokeWidth
        });
        this.optionsContainer.hide();
        let position = 0;
        this.optionsList.forEach((text, index)=>{
            const rect = new (0, $b5f43a4eeef4cb6f$export$2e2bcd8739ae039)([
                1,
                position + 1
            ], maxWidth + 6 * margin - 2, text.height + 2 * margin, {
                fill: this.options.fill,
                cursor: (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).cursors.pointer
            });
            position += rect.height;
            let fill;
            rect.on((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.hover, ()=>{
                fill = fill || rect.options.fill;
                rect.options.fill = this.options.hover;
            }).on((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.leave, ()=>{
                rect.options.fill = fill;
                fill = null;
            }).on((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.click, (event)=>{
                event.stop();
                this.value = index;
                this.fire(new (0, $1aed883b78728e08$export$2e2bcd8739ae039)($adb4f6d12e6abfca$export$2e2bcd8739ae039.events.change, this));
            });
            rect.add(text);
            this.optionsContainer.add(rect);
        });
        this.optionsContainer.height = position + 2;
        this.arrow = new (0, $7adea6df750c4d07$export$2e2bcd8739ae039)([
            maxWidth + 4 * margin,
            this.height / 2
        ], margin, {
            fill: this.options.foreground,
            rotation: 0.5,
            cursor: (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).cursors.pointer
        });
        this.add(this.display, this.optionsContainer, this.arrow);
    }
    /**
     * Computer button size
     * @return {{width: Number, height: Number}}
     */ get size() {
        const measures = this.optionsList[this.value].getMeasures();
        const maxWidth = Math.max(...this.optionsList.map((text)=>text.width));
        const margin = (0, $0c4e551c62a7aa5b$export$2e2bcd8739ae039).measure("M", this.optionsList[this.value].options).height * $adb4f6d12e6abfca$export$2e2bcd8739ae039.MARGIN;
        return {
            width: maxWidth + margin * 6,
            height: measures.height + margin * 2
        };
    }
    /**
     * Get this button's width
     * @return {Number}
     */ get width() {
        return this.size.width;
    }
    /**
     * Get this button's height
     * @return {Number}
     */ get height() {
        return this.size.height;
    }
    /**
     * @return {Number}
     */ get value() {
        return this[$adb4f6d12e6abfca$var$selectedKey];
    }
    /**
     * @param {Number} value - Index of the selected option
     */ set value(value) {
        this[$adb4f6d12e6abfca$var$selectedKey] = (0, $26d060ef72148247$export$c4e2ecac49351ef2)(value, 0, this.optionsList.length - 1);
        this.display.text = this.optionsList[this.value].text;
        const margin = this.optionsList[0].height * $adb4f6d12e6abfca$export$2e2bcd8739ae039.MARGIN;
        const origin = this.getOrigin();
        this.display.options.origin.set(origin.clone().add(margin * 2, margin));
        this.arrow.options.origin.set(origin.clone().multiply(-1));
        this.optionsContainer.hide();
        if (this.isHovered) this.fire(new (0, $06750c2c311f70ee$export$2e2bcd8739ae039)((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.leave, this));
    }
    /**
     * @inheritDoc
     */ click() {
        const { position: position } = this.optionsList[this.value].parent;
        this.optionsContainer.position.set(this.getOrigin()).subtract(position).add(1, 0);
        this.optionsContainer.show();
    }
    /**
     * @inheritDoc
     */ toJSON() {
        const json = super.toJSON();
        json.values = this.optionsList.map((component)=>component.text);
        return json;
    }
    /**
     * @inheritDoc
     * @param {Object} definition - Select definition
     * @return {Select}
     */ static from(definition) {
        return new $adb4f6d12e6abfca$export$2e2bcd8739ae039(definition.position, definition.values, definition.options);
    }
    /**
     * @typedef {Object} SelectOptions
     * @extends TextOptions
     * @extends InputOptions
     * @prop {String} [value=0] - Selected index of the select
     */ /**
     * @type {SelectOptions}
     */ static get defaultOptions() {
        return {
            ...(0, $0c4e551c62a7aa5b$export$2e2bcd8739ae039).defaultOptions,
            ...super.defaultOptions,
            value: 0
        };
    }
    /**
     * Margin around the text
     * @type {Number}
     */ static get MARGIN() {
        return 0.2;
    }
}













/**
 * @module Draggable
 */ /**
 * @typedef {Object} DraggableOptions
 * @prop {Boolean} [x=true] - Can move along vertical axis
 * @prop {Boolean} [y=true] - Can move along horizontal axis
 * @prop {Vector} [constrain] - Relative limit of freedom
 */ /**
 * @typedef {Object} DraggableAPI
 * @prop {Function} x - Change the "x" value in the draggable's options
 * @prop {Function} y - Change the "y" value in the draggable's options
 * @prop {Function} constrain - Change the "constrain" value in the draggable's options
 * @prop {Function} stop - Stop the component from being draggable
 */ /**
 * Set this component draggable
 * @param {DraggableOptions} [options] - Additional options
 * @return {DraggableAPI}
 * @memberOf module:Component#
 */ (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).prototype.draggable = function draggable(options) {
    if (this.isRotatable) throw new Error("Component can't be both rotatable and draggable.");
    const cursorNotSet = this.options.cursor === (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).cursors.default;
    if (cursorNotSet) this.options.cursor = (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).cursors.grab;
    this.isDraggable = true;
    this.isDragged = false;
    const mergedOptions = {
        x: true,
        y: true,
        ...options
    };
    if (mergedOptions.constrain) mergedOptions.constrain = (0, $92b1416d713d9082$export$2e2bcd8739ae039).from(mergedOptions.constrain);
    let startPosition = null;
    let originPosition = null;
    const downHandler = ({ position: position })=>{
        if (cursorNotSet) this.options.cursor = (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).cursors.grabbing;
        startPosition = position;
        originPosition = this.position.clone();
        this.isDragged = true;
        this.fire(new (0, $06750c2c311f70ee$export$2e2bcd8739ae039)((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.grab, this, this.position.clone()));
    };
    this.on((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.down, downHandler, true);
    const moveHandler = (event)=>{
        if (this.isDragged && startPosition) {
            const difference = event.position.clone().subtract(startPosition);
            const move = originPosition.clone().add(mergedOptions.x && difference.x, mergedOptions.y && difference.y);
            this.position.set(move);
            if (mergedOptions.constrain) this.position.constrain(mergedOptions.constrain.start, mergedOptions.constrain.end);
            this.fire(new (0, $06750c2c311f70ee$export$2e2bcd8739ae039)((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.drag, this, this.position.clone()));
        }
    };
    const upHandler = ()=>{
        if (cursorNotSet) this.options.cursor = (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).cursors.grab;
        if (this.isDragged && startPosition) {
            startPosition = null;
            this.isDragged = false;
            this.fire(new (0, $06750c2c311f70ee$export$2e2bcd8739ae039)((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.drop, this, this.position.clone()));
        }
    };
    let scene;
    this.getScene().then((theScene)=>{
        if (this.isDraggable) {
            scene = theScene;
            scene.on((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.move, moveHandler).on((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.up, upHandler);
        }
    });
    return {
        /**
         * Set the draggable "x" option
         * @param {Boolean} x - New value for "x"
         * @memberOf DraggableAPI#
         */ set x (x){
            mergedOptions.x = x;
        },
        /**
         * Set the draggable "y" option
         * @param {Boolean} y - New value for "y"
         * @memberOf DraggableAPI#
         */ set y (y){
            mergedOptions.y = y;
        },
        /**
         * Set the draggable "constrain" option
         * @param {Vector} constrain - New value for "constrain"
         * @memberOf DraggableAPI#
         */ set constrain (constrain){
            mergedOptions.constrain = constrain ? (0, $92b1416d713d9082$export$2e2bcd8739ae039).from(constrain) : constrain;
        },
        /**
         * Stop the component from being draggable
         * @memberOf DraggableAPI#
         */ stop: ()=>{
            this.removeListener((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.down, downHandler);
            if (scene) scene.removeListener((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.move, moveHandler).removeListener((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.up, upHandler);
            if (cursorNotSet) this.options.cursor = (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).cursors.default;
            this.isDraggable = false;
            this.isDragged = false;
        }
    };
};


/**
 * @module Slider
 */ const $4a7bbc8f70ad7c62$var$constrainerKey = Symbol("_constrainer");
const $4a7bbc8f70ad7c62$var$moveHandleKey = Symbol("_moveHandle");
class $4a7bbc8f70ad7c62$export$2e2bcd8739ae039 extends (0, $d7b76b7e3153c630$export$2e2bcd8739ae039) {
    /**
     * Slider constructor
     * @param {PositionDefinition} positionDefinition - Top-left corner
     * @param {SliderOptions} [options] - Specific options
     */ constructor(positionDefinition, options){
        super(positionDefinition, (0, $b5f43a4eeef4cb6f$export$2e2bcd8739ae039), options);
        const radius = (this.height - 2) / 2;
        this.handle = new (0, $34ea7009dfd1f98d$export$2e2bcd8739ae039)([
            0,
            this.height / 2
        ], radius, {
            fill: this.options.foreground,
            cursor: (0, $b5f43a4eeef4cb6f$export$2e2bcd8739ae039).cursors.ewResize,
            origin: this.getOrigin()
        });
        this.add(this.handle);
        this[$4a7bbc8f70ad7c62$var$constrainerKey] = new (0, $92b1416d713d9082$export$2e2bcd8739ae039)([
            radius + 1,
            this.height / 2
        ], [
            this.width - radius - 1,
            this.height / 2
        ]);
        this.handle.draggable({
            constrain: this[$4a7bbc8f70ad7c62$var$constrainerKey]
        });
        this.handle.on((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.drag, ()=>this.fire(new (0, $1aed883b78728e08$export$2e2bcd8739ae039)($4a7bbc8f70ad7c62$export$2e2bcd8739ae039.events.change, this)), true);
    }
    /**
     * @inheritDoc
     */ click(position) {
        const origin = this.getOrigin();
        this.handle.position.set(position.x - origin.x, 0).constrain(this[$4a7bbc8f70ad7c62$var$constrainerKey].start, this[$4a7bbc8f70ad7c62$var$constrainerKey].end);
        super.click();
    }
    /**
     * Change this slider's size
     * @param {Number} newWidth - A new size in pixels
     */ set width(newWidth) {
        if (newWidth < $4a7bbc8f70ad7c62$export$2e2bcd8739ae039.HEIGHT) throw new RangeError(`Slider is too small, minimum is ${$4a7bbc8f70ad7c62$export$2e2bcd8739ae039.HEIGHT}px.`);
        this.options.width = newWidth;
        this[$4a7bbc8f70ad7c62$var$constrainerKey].end = new (0, $ce200116bfeffd8f$export$2e2bcd8739ae039)(this.width - $4a7bbc8f70ad7c62$export$2e2bcd8739ae039.HEIGHT, 0);
        this[$4a7bbc8f70ad7c62$var$moveHandleKey](this.value);
    }
    /**
     * Return this slider's width
     * @return {Number}
     */ get width() {
        return this.options.width;
    }
    /**
     * Return this slider's height
     * @return {Number}
     */ get height() {
        return $4a7bbc8f70ad7c62$export$2e2bcd8739ae039.HEIGHT;
    }
    /**
     * Returns this current value
     * @return {Number}
     */ get value() {
        const { min: min, max: max } = this.options;
        const { start: start, end: end } = this[$4a7bbc8f70ad7c62$var$constrainerKey];
        return (0, $26d060ef72148247$export$871de8747c9eaa88)(this.handle.position.x, start.x, end.x, min, max);
    }
    /**
     * Change this current value
     * @param {Number} newValue - A new value to set
     */ set value(newValue) {
        this[$4a7bbc8f70ad7c62$var$moveHandleKey]((0, $26d060ef72148247$export$c4e2ecac49351ef2)(newValue, this.options.min, this.options.max));
    }
    /**
     * @typedef {Object} SliderOptions
     * @extends InputOptions
     * @prop {Number} [min=0] - Minimum value when the slider is at lowest
     * @prop {Number} [max=10] - Maximum value when the slider is at highest
     * @prop {Number} [value=0] - Initial value
     * @prop {Number} [width=200] - Size of the slider
     */ /**
     * @type {SliderOptions}
     */ static get defaultOptions() {
        return {
            ...super.defaultOptions,
            min: 0,
            max: 1,
            value: 0,
            width: 200
        };
    }
    /**
     * Height of sliders
     * @type {Number}
     */ static get HEIGHT() {
        return 20;
    }
}
/**
 * Move the handle to a specified value
 * @param {Number} value - New value to use
 * @memberOf Slider#
 */ $4a7bbc8f70ad7c62$export$2e2bcd8739ae039.prototype[$4a7bbc8f70ad7c62$var$moveHandleKey] = function moveHandle(value) {
    const { min: min, max: max } = this.options;
    const { start: start, end: end } = this[$4a7bbc8f70ad7c62$var$constrainerKey];
    this.handle.position.x = (0, $26d060ef72148247$export$871de8747c9eaa88)(value, min, max, start.x, end.x);
};






/**
 * @module ProgressBar
 */ const $2d4478b234bc6fa9$var$valueKey = Symbol("_value");
class $2d4478b234bc6fa9$export$2e2bcd8739ae039 extends (0, $d7b76b7e3153c630$export$2e2bcd8739ae039) {
    /**
     * Slider constructor
     * @param {PositionDefinition} positionDefinition - Top-left corner
     * @param {ProgressBarOptions} [options] - Specific options
     */ constructor(positionDefinition, options){
        super(positionDefinition, (0, $b5f43a4eeef4cb6f$export$2e2bcd8739ae039), options);
        this.removeListener([
            (0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.hover,
            (0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.leave,
            (0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.click
        ]);
        this.progress = new (0, $b5f43a4eeef4cb6f$export$2e2bcd8739ae039)([
            1,
            1
        ], 0, $2d4478b234bc6fa9$export$2e2bcd8739ae039.HEIGHT - 2, {
            fill: this.options.foreground,
            origin: this.getOrigin()
        });
        this.add(this.progress);
        if (this.options.speed < 1) this.progress.on($2d4478b234bc6fa9$export$2e2bcd8739ae039.events.draw, ()=>{
            const targetWidth = (this.width - 2) * this.value;
            this.progress.width += (targetWidth - this.progress.width) * this.options.speed ** 2;
        }, true);
        /**
         * @type {Number}
         */ this[$2d4478b234bc6fa9$var$valueKey] = null;
    }
    /**
     * @inheritDoc
     */ click() {
    // Do nothing
    }
    /**
     * Return this width
     * @return {Number}
     */ get width() {
        return this.options.width;
    }
    /**
     * Change this size
     * @param {Number} newWidth - A new size in pixels
     */ set width(newWidth) {
        if (newWidth < $2d4478b234bc6fa9$export$2e2bcd8739ae039.HEIGHT) throw new RangeError(`Progress-bar is too small, minimum is ${$2d4478b234bc6fa9$export$2e2bcd8739ae039.HEIGHT}px.`);
        this.options.width = newWidth;
    }
    /**
     * Return this height
     * @return {Number}
     */ get height() {
        return $2d4478b234bc6fa9$export$2e2bcd8739ae039.HEIGHT;
    }
    /**
     * Returns this current value
     * @return {Number}
     */ get value() {
        return this[$2d4478b234bc6fa9$var$valueKey];
    }
    /**
     * Change this current value
     * @param {Number} newValue - A new value to be set (between 0 and 1)
     */ set value(newValue) {
        this[$2d4478b234bc6fa9$var$valueKey] = (0, $26d060ef72148247$export$c4e2ecac49351ef2)(newValue, 0, 1);
        if (this.options.speed >= 1) this.progress.width = (this.width - 2) * this.value;
    }
    /**
     * @typedef {Object} ProgressBarOptions
     * @extends InputOptions
     * @prop {Number} [value=0] - Initial value
     * @prop {Number} [width=200] - Size of the slider
     * @prop {Number} [speed=0.3] - Transition speed between two value (0 mean no change, 1 mean instant change)
     */ /**
     * @type {ProgressBarOptions}
     */ static get defaultOptions() {
        return {
            ...super.defaultOptions,
            cursor: null,
            value: 0,
            width: 200,
            speed: 0.3
        };
    }
    /**
     * Height of sliders
     * @type {Number}
     */ static get HEIGHT() {
        return 20;
    }
}







/**
 * @module ProgressPie
 */ const $8674ab98b5f3ab2a$var$valueKey = Symbol("_value");
class $8674ab98b5f3ab2a$export$2e2bcd8739ae039 extends (0, $d7b76b7e3153c630$export$2e2bcd8739ae039) {
    /**
     * ProgressPie constructor
     * @param {PositionDefinition} positionDefinition - Position of the progress-pie center
     * @param {ProgressPieOptions} [options] - Specific options
     */ constructor(positionDefinition, options){
        super(positionDefinition, (0, $34ea7009dfd1f98d$export$2e2bcd8739ae039), options);
        this.removeListener([
            (0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.hover,
            (0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.leave,
            (0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.click
        ]);
        this.progress = new (0, $3c25639b66649cfc$export$2e2bcd8739ae039)(this.getOrigin(), this.radius - this.options.strokeWidth / 2, 0, 0, {
            fill: this.options.foreground
        });
        this.add(this.progress);
        if (this.options.speed < 1) this.progress.on($8674ab98b5f3ab2a$export$2e2bcd8739ae039.events.draw, ()=>{
            this.progress.endAngle += (this.value - this.progress.endAngle) * this.options.speed ** 2;
        }, true);
        /**
         * @type {Number}
         */ this[$8674ab98b5f3ab2a$var$valueKey] = null;
    }
    /**
     * @inheritDoc
     */ click() {
    // Do nothing
    }
    /**
     * Return this size
     * @return {Number}
     */ get radius() {
        return this.options.radius;
    }
    /**
     * Change this size
     * @param {Number} newRadius - A new size in pixels
     */ set radius(newRadius) {
        this.options.radius = newRadius;
        this.progress.radius = newRadius - 1;
    }
    /**
     * Returns this current value
     * @return {Number}
     */ get value() {
        return this[$8674ab98b5f3ab2a$var$valueKey];
    }
    /**
     * Change this current value
     * @param {Number} newValue - A new value to be set (between 0 and 1)
     */ set value(newValue) {
        this[$8674ab98b5f3ab2a$var$valueKey] = (0, $26d060ef72148247$export$c4e2ecac49351ef2)(newValue, 0, 1);
        if (this.options.speed >= 1) this.progress.endAngle = this.value;
    }
    /**
     * @typedef {Object} ProgressPieOptions
     * @extends InputOptions
     * @prop {Number} [value=0] - Initial value
     * @prop {Number} [radius=100] - Size of the progress-pie
     * @prop {Number} [speed=0.3] - Transition speed between two value (0 mean no change, 1 mean instant change)
     */ /**
     * @type {ProgressPieOptions}
     */ static get defaultOptions() {
        return {
            ...super.defaultOptions,
            cursor: null,
            value: 0,
            radius: 100,
            speed: 0.3
        };
    }
}











/**
 * @module Rotatable
 */ /**
 * @typedef {Object} RotatableAPI
 * @prop {Function} stop - Stop the component from being rotatable
 */ /**
 * Set this component rotatable (use drag and drop interaction to rotate)
 * @return {RotatableAPI}
 * @memberOf module:Component#
 */ (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).prototype.rotatable = function rotatable() {
    if (this.isDraggable) throw new Error("Component can't be both draggable and rotatable.");
    const cursorNotSet = this.options.cursor === (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).cursors.default;
    if (cursorNotSet) this.options.cursor = (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).cursors.grab;
    this.isRotatable = true;
    this.isRotated = false;
    let previousAngle = null;
    let startingAngle = null;
    const downHandler = ({ position: position })=>{
        if (cursorNotSet) this.options.cursor = (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).cursors.grabbing;
        previousAngle = this.options.rotation;
        startingAngle = position.subtract(this.getAbsolutePosition()).angle;
        this.isRotated = true;
        this.fire(new (0, $06750c2c311f70ee$export$2e2bcd8739ae039)((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.grab, this, position));
    };
    this.on((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.down, downHandler);
    const moveHandler = ({ position: position })=>{
        if (previousAngle !== null) {
            const absolutePosition = this.getAbsolutePosition();
            this.options.rotation = previousAngle + position.subtract(absolutePosition).angle - startingAngle;
            this.fire(new (0, $06750c2c311f70ee$export$2e2bcd8739ae039)((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.rotate, this, position));
        }
    };
    const upHandler = ({ position: position })=>{
        if (cursorNotSet) this.options.cursor = (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).cursors.grab;
        if (previousAngle !== null && this.isRotated) {
            previousAngle = null;
            startingAngle = null;
            this.isRotated = false;
            this.fire(new (0, $06750c2c311f70ee$export$2e2bcd8739ae039)((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.drop, this, position));
        }
    };
    let scene;
    this.getScene().then((theScene)=>{
        if (this.isRotatable) {
            scene = theScene;
            scene.on((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.move, moveHandler).on((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.up, upHandler);
        }
    });
    return {
        /**
         * Stop the component from being rotatable
         * @memberOf RotatableAPI#
         */ stop: ()=>{
            this.removeListener((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.down, downHandler, true);
            if (scene) scene.removeListener((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.move, moveHandler).removeListener((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.up, upHandler);
            if (cursorNotSet) this.options.cursor = (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).cursors.default;
            this.isRotatable = false;
            this.isRotated = false;
        }
    };
};


class $1904804e70622215$export$2e2bcd8739ae039 extends (0, $d7b76b7e3153c630$export$2e2bcd8739ae039) {
    /**
     * knob constructor
     * @param {PositionDefinition} positionDefinition - Position of the center
     * @param {KnobOptions} [options] - Specific options
     */ constructor(positionDefinition, options){
        super(positionDefinition, (0, $34ea7009dfd1f98d$export$2e2bcd8739ae039), options);
        const origin = this.getOrigin();
        this.options.rotationCenter = origin;
        const strokeWidth = this.options.radius * $1904804e70622215$export$2e2bcd8739ae039.NOTCH_SIZE;
        const margin = this.options.radius / 3;
        const notch = new (0, $e90a03c16dccc7f7$export$2e2bcd8739ae039)([
            0,
            -margin
        ], [
            [
                0,
                -this.options.radius + margin + strokeWidth
            ]
        ], {
            stroke: this.options.foreground,
            strokeWidth: strokeWidth,
            cursor: (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).cursors.grab,
            origin: origin
        });
        this.add(notch).on((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.rotate, ()=>this.fire(new (0, $1aed883b78728e08$export$2e2bcd8739ae039)($1904804e70622215$export$2e2bcd8739ae039.events.change, this)), true).rotatable();
    }
    /**
     * Get this knob's radius
     * @return {Number}
     */ get radius() {
        return this.options.radius;
    }
    /**
     * Set this knob's radius
     * @param {Number} value - Radius of the knob
     */ set radius(value) {
        this.options.radius = value;
    }
    /**
     * @inheritDoc
     */ click() {
    // Do nothing
    }
    /**
     * Returns this current value
     * @return {Number}
     */ get value() {
        return (0, $26d060ef72148247$export$871de8747c9eaa88)((0, $26d060ef72148247$export$ba467bec01d66def)(this.options.rotation, 1), 0, 1, this.options.min, this.options.max);
    }
    /**
     * Change this current value
     * @param {Number} newValue - A new value to set
     */ set value(newValue) {
        this.options.rotation = (0, $26d060ef72148247$export$ba467bec01d66def)((0, $26d060ef72148247$export$871de8747c9eaa88)(newValue, this.options.min, this.options.max, 0, 1), 1);
    }
    /**
     * @typedef {Object} KnobOptions
     * @prop {Number} [min=0] - Minimum value when the knob is at lowest
     * @prop {Number} [max=10] - Maximum value when the knob is at highest
     * @prop {Number} [value=0] - Initial value
     * @prop {Number} [radius=100] - Radius of the knob
     */ /**
     * @type {KnobOptions}
     */ static get defaultOptions() {
        return {
            ...super.defaultOptions,
            cursor: (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).cursors.default,
            min: 0,
            max: 1,
            value: 0,
            radius: 100
        };
    }
    /**
     * Width of the rotation marker
     * @type {Number}
     */ static get NOTCH_SIZE() {
        return 0.09;
    }
}









/**
 * @module Resizable
 */ /**
 * @typedef {Object} ResizableOptions
 * @extends DraggableOptions
 * @prop {Component} [handle] - Draggable shape used as handle (default is a right-triangle at the bottom right angle)
 */ /**
 * Enable resize on a rectangle
 * @param {ResizableOptions} [options] - Additional options
 * @return {DraggableAPI}
 * @memberOf module:Rectangle#
 */ (0, $b5f43a4eeef4cb6f$export$2e2bcd8739ae039).prototype.resizable = function resizable(options) {
    if (this.options.rotation % 1 !== 0) throw new EvalError("Resizable don't support rotation.");
    const origin = this.getOrigin();
    if (origin.x !== 0 || origin.y !== 0) throw new EvalError("Resizable don't support other origin than [0, 0] or topLeft.");
    this.isResizable = true;
    const size = 15;
    const mergedOptions = {
        x: true,
        y: true,
        handle: new (0, $975d882a2cf46c71$export$2e2bcd8739ae039)([
            this.width,
            this.height
        ], [
            [
                0,
                0
            ],
            [
                -size,
                0
            ],
            [
                0,
                -size
            ]
        ], {
            fill: "gold",
            cursor: (0, $0fd58fd98fd800e4$export$2e2bcd8739ae039).cursors.seResize
        }),
        ...options
    };
    if (!(mergedOptions.x && mergedOptions.y) && this instanceof (0, $ddc9f679561154f9$export$2e2bcd8739ae039)) throw new TypeError("Square should be resizable in both x and y axis.");
    this.add(mergedOptions.handle);
    const distanceToBottomRight = mergedOptions.handle.position.clone().multiply(-1).add(this.width, this.height);
    const api = mergedOptions.handle.draggable(mergedOptions);
    mergedOptions.handle.on((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.drag, ()=>{
        if (this instanceof (0, $ddc9f679561154f9$export$2e2bcd8739ae039)) {
            mergedOptions.handle.position.add(distanceToBottomRight);
            this.size = (mergedOptions.handle.position.x + mergedOptions.handle.position.y) / 2;
            mergedOptions.handle.position.set(this.size).subtract(distanceToBottomRight);
        } else {
            if (mergedOptions.x) this.width = mergedOptions.handle.position.x + distanceToBottomRight.x;
            if (mergedOptions.y) this.height = mergedOptions.handle.position.y + distanceToBottomRight.y;
        }
        this.fire(new (0, $06750c2c311f70ee$export$2e2bcd8739ae039)((0, $06750c2c311f70ee$export$2e2bcd8739ae039).events.resize, this, mergedOptions.handle.position));
    }, true);
    return api;
};



var $8a1b276ac53d7217$exports = {};
$8a1b276ac53d7217$exports = JSON.parse('{"name":"pencil.js","version":"3.2.0","description":"Nice modular interactive 2D drawing library.","main":"src/index.js","type":"module","files":["dist","src","!src/**/*.test.js"],"types":"dist/index.d.ts","sideEffects":false,"unpkg":"dist/pencil.min.js","jsdelivr":"dist/pencil.min.js","scripts":{"lint":"eslint src/","test":"c8 --reporter=html --reporter=text-summary ava","testci":"c8 --reporter=lcovonly --reporter=text-summary ava","play":"webpack --mode=development --watch","build":"webpack --mode=production && tsc","contrib":"all-contributors generate","docs":"jsdoc -c .jsdocrc","prepublishOnly":"npm run build","postversion":"vercel --prod"},"ava":{"require":["@pencil.js/test-environment"],"timeout":"2m"},"eslintConfig":{"extends":"@gmartigny/eslint-config","parserOptions":{"ecmaVersion":"latest"},"rules":{"import/no-extraneous-dependencies":0}},"repository":{"type":"git","url":"git+https://github.com/pencil-js/pencil.js.git"},"keywords":["canvas","HTML","drawing","renderer","engine","frontend","web","modular","OOP","toolbelt"],"author":"Guillaume Martigny <guillaume.martigny@gmail.com> (https://www.guillaume-martigny.fr)","license":"MIT","bugs":{"url":"https://github.com/pencil-js/pencil.js/issues"},"homepage":"https://pencil.js.org/","funding":{"url":"https://github.com/pencil-js/pencil.js?sponsor=1"},"dependencies":{"@pencil.js/arc":"file:src/modules/arc","@pencil.js/base-event":"file:src/modules/base-event","@pencil.js/button":"file:src/modules/button","@pencil.js/checkbox":"file:src/modules/checkbox","@pencil.js/circle":"file:src/modules/circle","@pencil.js/color":"file:src/modules/color","@pencil.js/component":"file:src/modules/component","@pencil.js/conic-gradient":"file:src/modules/conic-gradient","@pencil.js/container":"file:src/modules/container","@pencil.js/draggable":"file:src/modules/draggable","@pencil.js/ellipse":"file:src/modules/ellipse","@pencil.js/event-emitter":"file:src/modules/event-emitter","@pencil.js/heart":"file:src/modules/heart","@pencil.js/image":"file:src/modules/image","@pencil.js/input":"file:src/modules/input","@pencil.js/keyboard-event":"file:src/modules/keyboard-event","@pencil.js/knob":"file:src/modules/knob","@pencil.js/line":"file:src/modules/line","@pencil.js/linear-gradient":"file:src/modules/linear-gradient","@pencil.js/math":"file:src/modules/math","@pencil.js/mouse-event":"file:src/modules/mouse-event","@pencil.js/navigation":"file:src/modules/navigation","@pencil.js/network-event":"file:src/modules/network-event","@pencil.js/offscreen-canvas":"file:src/modules/offscreen-canvas","@pencil.js/particles":"file:src/modules/particles","@pencil.js/path":"file:src/modules/path","@pencil.js/pattern":"file:src/modules/pattern","@pencil.js/pie":"file:src/modules/pie","@pencil.js/polygon":"file:src/modules/polygon","@pencil.js/position":"file:src/modules/position","@pencil.js/progress-bar":"file:src/modules/progress-bar","@pencil.js/progress-pie":"file:src/modules/progress-pie","@pencil.js/radial-gradient":"file:src/modules/radial-gradient","@pencil.js/rectangle":"file:src/modules/rectangle","@pencil.js/regular-polygon":"file:src/modules/regular-polygon","@pencil.js/resizable":"file:src/modules/resizable","@pencil.js/rotatable":"file:src/modules/rotatable","@pencil.js/scene":"file:src/modules/scene","@pencil.js/select":"file:src/modules/select","@pencil.js/slider":"file:src/modules/slider","@pencil.js/spline":"file:src/modules/spline","@pencil.js/sprite":"file:src/modules/sprite","@pencil.js/square":"file:src/modules/square","@pencil.js/star":"file:src/modules/star","@pencil.js/text":"file:src/modules/text","@pencil.js/triangle":"file:src/modules/triangle","@pencil.js/vector":"file:src/modules/vector","colord":"^2.9.3","minimatch":"^5.1.6","text-direction":"^2.0.1"},"devDependencies":{"@babel/plugin-syntax-import-assertions":"^7.22.5","@babel/preset-env":"^7.22.15","@gmartigny/eslint-config":"^2.1.0","@pencil.js/test-environment":"^1.2.1","all-contributors-cli":"^6.26.1","ava":"^5.3.1","benchmark":"^2.1.4","c8":"^8.0.1","clean-jsdoc-theme":"4.2.12","eslint":"^8.49.0","jsdoc":"^4.0.2","jsdoc-babel":"^0.5.0","typescript":"^5.2.2","webpack":"^5.53.0","webpack-cli":"^5.1.4"}}');


const { version: $40cbe5f5a5d459bf$export$83d89fbfd8236492, author: $40cbe5f5a5d459bf$export$571b02044ddb2ab3, homepage: $40cbe5f5a5d459bf$export$4cec2234a9c7ce6d } = (0, (/*@__PURE__*/$parcel$interopDefault($8a1b276ac53d7217$exports)));
const $40cbe5f5a5d459bf$var$exportableClasses = {
    Container: $38771a883d186a4e$export$2e2bcd8739ae039,
    Particles: $cd5768e945a9e13e$export$2e2bcd8739ae039,
    OffScreenCanvas: $254037bcf672ea5f$export$2e2bcd8739ae039,
    Scene: $2f1bdb7a84694571$export$2e2bcd8739ae039,
    Arc: $8b03e4ec6db32fa2$export$2e2bcd8739ae039,
    Pie: $3c25639b66649cfc$export$2e2bcd8739ae039,
    Ellipse: $38f1308b79e8c5d9$export$2e2bcd8739ae039,
    Circle: $34ea7009dfd1f98d$export$2e2bcd8739ae039,
    Line: $e90a03c16dccc7f7$export$2e2bcd8739ae039,
    Spline: $821a4ca27fcc1e1f$export$2e2bcd8739ae039,
    Polygon: $975d882a2cf46c71$export$2e2bcd8739ae039,
    RegularPolygon: $0c1dc17496d983ce$export$2e2bcd8739ae039,
    Triangle: $7adea6df750c4d07$export$2e2bcd8739ae039,
    Star: $a3bf5d175c7a8e0e$export$2e2bcd8739ae039,
    Rectangle: $b5f43a4eeef4cb6f$export$2e2bcd8739ae039,
    Square: $ddc9f679561154f9$export$2e2bcd8739ae039,
    Image: $b61520fd682d0ff5$export$2e2bcd8739ae039,
    Text: $0c4e551c62a7aa5b$export$2e2bcd8739ae039,
    Path: $12e0d5cfa03f0c3b$export$2e2bcd8739ae039,
    Position: $ce200116bfeffd8f$export$2e2bcd8739ae039,
    Vector: $92b1416d713d9082$export$2e2bcd8739ae039,
    Select: $adb4f6d12e6abfca$export$2e2bcd8739ae039,
    Slider: $4a7bbc8f70ad7c62$export$2e2bcd8739ae039,
    Checkbox: $5f8efce6271bc06d$export$2e2bcd8739ae039,
    Button: $4509ca553fe002b7$export$2e2bcd8739ae039,
    ProgressBar: $2d4478b234bc6fa9$export$2e2bcd8739ae039,
    ProgressPie: $8674ab98b5f3ab2a$export$2e2bcd8739ae039,
    Knob: $1904804e70622215$export$2e2bcd8739ae039,
    Color: $f69eec5534190452$export$2e2bcd8739ae039,
    LinearGradient: $96c9ad69e5873844$export$2e2bcd8739ae039,
    RadialGradient: $f299e79e5e44b044$export$2e2bcd8739ae039,
    ConicGradient: $cae15293d24a770e$export$2e2bcd8739ae039,
    Pattern: $f720b88b21c518e1$export$2e2bcd8739ae039,
    Heart: $bd29dd0079e0f6a7$export$2e2bcd8739ae039,
    Sprite: $a8efcbda4713a3fe$export$2e2bcd8739ae039
};
/**
 * Construct Pencil objects from a JSON
 * @param {Object} json - Valid JSON
 * @return {*}
 */ function $40cbe5f5a5d459bf$export$6788812c4e6611e6(json) {
    const instance = $40cbe5f5a5d459bf$var$exportableClasses[json.constructor].from(json);
    if (json.children) instance.add(...json.children.map((child)=>$40cbe5f5a5d459bf$export$6788812c4e6611e6(child)));
    return instance;
}
var // Export all under namespace
$40cbe5f5a5d459bf$export$2e2bcd8739ae039 = {
    EventEmitter: $e3eecb02d2839ca2$export$2e2bcd8739ae039,
    Component: $0fd58fd98fd800e4$export$2e2bcd8739ae039,
    Input: $d7b76b7e3153c630$export$2e2bcd8739ae039,
    BaseEvent: $1aed883b78728e08$export$2e2bcd8739ae039,
    MouseEvent: $06750c2c311f70ee$export$2e2bcd8739ae039,
    NetworkEvent: $1a62a1afb6cf7c06$export$2e2bcd8739ae039,
    KeyboardEvent: $c9f089248e02e4ab$export$2e2bcd8739ae039,
    from: $40cbe5f5a5d459bf$export$6788812c4e6611e6,
    Math: $26d060ef72148247$exports,
    Navigation: $fb421388df2e4f8d$exports,
    version: $40cbe5f5a5d459bf$export$83d89fbfd8236492,
    author: $40cbe5f5a5d459bf$export$571b02044ddb2ab3,
    homepage: $40cbe5f5a5d459bf$export$4cec2234a9c7ce6d,
    ...$40cbe5f5a5d459bf$var$exportableClasses
};


var $a52dc4c4de3c5520$export$2e2bcd8739ae039 = {
    render: (container)=>{
        const scene = new (0, $2f1bdb7a84694571$export$2e2bcd8739ae039)(container);
        const { width: width, height: height } = scene;
        scene.setOptions({
            fill: new (0, $96c9ad69e5873844$export$2e2bcd8739ae039)([
                0,
                0
            ], [
                0,
                height / 2
            ], {
                0: "#3c7bd1",
                1: "#a4b6e1"
            })
        });
        scene.add(new (0, $b5f43a4eeef4cb6f$export$2e2bcd8739ae039)([
            0,
            height / 2
        ], width, height / 2, {
            fill: "#c37a3e"
        })).render();
    }
};



var $4ee2b06a9c1953f0$export$2e2bcd8739ae039 = {
    render () {
        const game = {
            resources: [],
            persons: [],
            logs: []
        };
        const displayContainer = (0, $1bf5d568346a5aa2$export$b3890eb0ae9dca99)("div", {
            class: "display"
        });
        const element = (0, $1bf5d568346a5aa2$export$b3890eb0ae9dca99)("main", {
            class: "game",
            [`@${(0, $d558274f28a688d2$export$4bf9923669ad6c63).addLog}`]: ({ detail: detail })=>{
                game.logs.unshift(detail);
            },
            [`@${(0, $41f6e0b01b0859bd$export$4bf9923669ad6c63).consume}`]: ({ detail: detail })=>{
                detail.forEach(([amount, res])=>{
                    const possessed = game.resources.find(([, has])=>has === res);
                    if (possessed) game.resources.splice(game.resources.indexOf(possessed), 1, [
                        possessed[0] - amount,
                        res
                    ]);
                    else throw new Error(`Resource ${res.name} not found`);
                });
            },
            [`@${(0, $41f6e0b01b0859bd$export$4bf9923669ad6c63).earn}`]: ({ detail: detail })=>{
                detail.forEach(([amount, res])=>{
                    const possessed = game.resources.find(([, has])=>has === res);
                    if (possessed) game.resources.splice(game.resources.indexOf(possessed), 1, [
                        possessed[0] + amount,
                        res
                    ]);
                    else game.resources.push([
                        amount,
                        res
                    ]);
                });
            },
            [`@${(0, $7b17dadf09a1ff76$export$4bf9923669ad6c63).arrive}`]: ({ detail: detail })=>{
                game.persons.push(detail);
            },
            [`@${(0, $7b17dadf09a1ff76$export$4bf9923669ad6c63).die}`]: ({ detail: detail })=>{
                game.persons.splice(game.persons.indexOf(detail), 1);
            }
        }, [
            (0, $17a0552230a278a9$export$2e2bcd8739ae039)(game, "resources", (init, list)=>(0, $1bf5d568346a5aa2$export$b3890eb0ae9dca99)(list ?? "header", {
                    class: "resources"
                }, init), (0, $41f6e0b01b0859bd$export$2e2bcd8739ae039).render),
            (0, $1bf5d568346a5aa2$export$b3890eb0ae9dca99)(undefined, {
                class: "content"
            }, [
                (0, $17a0552230a278a9$export$2e2bcd8739ae039)(game, "persons", (init, list)=>(0, $1bf5d568346a5aa2$export$b3890eb0ae9dca99)(list, {
                        class: "persons"
                    }, init), (0, $7b17dadf09a1ff76$export$2e2bcd8739ae039).render),
                (0, $17a0552230a278a9$export$2e2bcd8739ae039)(game, "logs", (init, list)=>(0, $1bf5d568346a5aa2$export$b3890eb0ae9dca99)(list, {
                        class: "logs"
                    }), (0, $d558274f28a688d2$export$2e2bcd8739ae039).render)
            ]),
            displayContainer
        ]);
        setTimeout(()=>{
            (0, $a52dc4c4de3c5520$export$2e2bcd8739ae039).render(displayContainer);
        });
        setTimeout(()=>{
            (0, $820877bea407f5fe$export$635e15bbd66f01ea)((0, $7b17dadf09a1ff76$export$4bf9923669ad6c63).arrive, element, {
                name: "Alice",
                actions: [
                    (0, $2a9f999bc54a0719$export$e324594224ef24da).gather
                ]
            });
        }, 1000);
        return element;
    },
    styles: {
        ".game": {
            height: "100vh",
            overflow: "hidden",
            ...(0, $a18ed44ada1e4192$export$ccc7b0636abaffc3).flexCol(),
            ".resources": {
                ...(0, $a18ed44ada1e4192$export$ccc7b0636abaffc3).flex(),
                padding: "1em",
                background: "#533d20",
                "&:empty": {
                    transform: "translateY(-100%)"
                },
                ...(0, $41f6e0b01b0859bd$export$2e2bcd8739ae039).styles
            },
            ".content": {
                flex: 1,
                ...(0, $a18ed44ada1e4192$export$ccc7b0636abaffc3).flex(),
                ".logs, .persons": {
                    flex: "1 50%",
                    ...(0, $a18ed44ada1e4192$export$ccc7b0636abaffc3).flexCol()
                },
                ".persons": {
                    ...(0, $7b17dadf09a1ff76$export$2e2bcd8739ae039).styles
                },
                ".logs": {
                    ...(0, $d558274f28a688d2$export$2e2bcd8739ae039).styles
                }
            },
            ".display": {
                flex: 1
            }
        }
    }
};


document.body.appendChild((0, $4ee2b06a9c1953f0$export$2e2bcd8739ae039).render());
document.head.appendChild((0, $1bf5d568346a5aa2$export$2ac1b4e32926b135)({
    html: {
        overflow: "hidden"
    },
    body: {
        background: (0, $a18ed44ada1e4192$export$44c6a27b41bcee9f).black
    },
    "*": {
        margin: "0",
        padding: "0",
        "box-sizing": "border-box",
        color: "#fff"
    },
    ...(0, $a18ed44ada1e4192$export$7f9953c70dacfd7f),
    ...(0, $4ee2b06a9c1953f0$export$2e2bcd8739ae039).styles
}));


//# sourceMappingURL=index.faffd754.js.map
